import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import * as Types from './operations';
const defaultOptions = {} as const;
export const SessionPayloadFragmentFragmentDoc = gql`
  fragment SessionPayloadFragment on SessionPayload {
    events
    errors {
      id
      error_group_secure_id
      event
      type
      url
      source
      stack_trace
      structured_stack_trace {
        fileName
        lineNumber
        functionName
        columnNumber
      }
      timestamp
      payload
      request_id
    }
    rage_clicks {
      start_timestamp
      end_timestamp
      total_clicks
    }
    session_comments {
      id
      timestamp
      session_id
      session_secure_id
      created_at
      updated_at
      project_id
      text
      author {
        id
        name
        email
        photo_url
      }
      attachments {
        integration_type
        external_id
        title
      }
      x_coordinate
      y_coordinate
      type
      metadata
    }
    last_user_interaction_time
  }
`;
export const ErrorObjectFragmentDoc = gql`
  fragment ErrorObject on ErrorObject {
    id
    created_at
    project_id
    session_id
    trace_id
    span_id
    log_cursor
    session {
      identifier
      fingerprint
      secure_id
      city
      state
      country
      user_properties
      processed
      excluded
      excluded_reason
      session_feedback {
        id
        timestamp
        created_at
        updated_at
        project_id
        text
      }
    }
    error_group_id
    error_group_secure_id
    event
    type
    url
    source
    lineNumber
    columnNumber
    stack_trace
    structured_stack_trace {
      fileName
      lineNumber
      functionName
      columnNumber
      lineContent
      linesBefore
      linesAfter
      error
      enhancementSource
      enhancementVersion
      externalLink
      sourceMappingErrorMetadata {
        errorCode
        stackTraceFileURL
        sourcemapFetchStrategy
        sourceMapURL
        minifiedFetchStrategy
        actualMinifiedFetchedPath
        minifiedLineNumber
        minifiedColumnNumber
        actualSourcemapFetchedPath
        sourcemapFileSize
        minifiedFileSize
        mappedLineNumber
        mappedColumnNumber
      }
    }
    timestamp
    payload
    request_id
    os
    browser
    environment
    serviceVersion
    serviceName
    attributes
  }
`;
export const ProjectFragmentDoc = gql`
  fragment Project on Project {
    id
    name
    verbose_id
    billing_email
    secret
    workspace_id
    error_filters
    workspace {
      id
    }
    excluded_users
    error_json_paths
    filter_chrome_extension
    rage_click_window_seconds
    rage_click_radius_pixels
    rage_click_count
    platforms
  }
`;
export const MarkErrorGroupAsViewedDocument = gql`
  mutation MarkErrorGroupAsViewed($error_secure_id: String!, $viewed: Boolean!) {
    markErrorGroupAsViewed(error_secure_id: $error_secure_id, viewed: $viewed) {
      secure_id
      viewed
    }
  }
`;
export type MarkErrorGroupAsViewedMutationFn = Apollo.MutationFunction<
  Types.MarkErrorGroupAsViewedMutation,
  Types.MarkErrorGroupAsViewedMutationVariables
>;

/**
 * __useMarkErrorGroupAsViewedMutation__
 *
 * To run a mutation, you first call `useMarkErrorGroupAsViewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkErrorGroupAsViewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markErrorGroupAsViewedMutation, { data, loading, error }] = useMarkErrorGroupAsViewedMutation({
 *   variables: {
 *      error_secure_id: // value for 'error_secure_id'
 *      viewed: // value for 'viewed'
 *   },
 * });
 */
export function useMarkErrorGroupAsViewedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.MarkErrorGroupAsViewedMutation,
    Types.MarkErrorGroupAsViewedMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.MarkErrorGroupAsViewedMutation, Types.MarkErrorGroupAsViewedMutationVariables>(
    MarkErrorGroupAsViewedDocument,
    options,
  );
}
export type MarkErrorGroupAsViewedMutationHookResult = ReturnType<typeof useMarkErrorGroupAsViewedMutation>;
export type MarkErrorGroupAsViewedMutationResult = Apollo.MutationResult<Types.MarkErrorGroupAsViewedMutation>;
export type MarkErrorGroupAsViewedMutationOptions = Apollo.BaseMutationOptions<
  Types.MarkErrorGroupAsViewedMutation,
  Types.MarkErrorGroupAsViewedMutationVariables
>;
export const MarkSessionAsViewedDocument = gql`
  mutation MarkSessionAsViewed($secure_id: String!, $viewed: Boolean!) {
    markSessionAsViewed(secure_id: $secure_id, viewed: $viewed) {
      secure_id
      viewed
    }
  }
`;
export type MarkSessionAsViewedMutationFn = Apollo.MutationFunction<
  Types.MarkSessionAsViewedMutation,
  Types.MarkSessionAsViewedMutationVariables
>;

/**
 * __useMarkSessionAsViewedMutation__
 *
 * To run a mutation, you first call `useMarkSessionAsViewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSessionAsViewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSessionAsViewedMutation, { data, loading, error }] = useMarkSessionAsViewedMutation({
 *   variables: {
 *      secure_id: // value for 'secure_id'
 *      viewed: // value for 'viewed'
 *   },
 * });
 */
export function useMarkSessionAsViewedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.MarkSessionAsViewedMutation,
    Types.MarkSessionAsViewedMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.MarkSessionAsViewedMutation, Types.MarkSessionAsViewedMutationVariables>(
    MarkSessionAsViewedDocument,
    options,
  );
}
export type MarkSessionAsViewedMutationHookResult = ReturnType<typeof useMarkSessionAsViewedMutation>;
export type MarkSessionAsViewedMutationResult = Apollo.MutationResult<Types.MarkSessionAsViewedMutation>;
export type MarkSessionAsViewedMutationOptions = Apollo.BaseMutationOptions<
  Types.MarkSessionAsViewedMutation,
  Types.MarkSessionAsViewedMutationVariables
>;
export const UpdateErrorGroupStateDocument = gql`
  mutation updateErrorGroupState($secure_id: String!, $state: ErrorState!, $snoozed_until: Timestamp) {
    updateErrorGroupState(secure_id: $secure_id, state: $state, snoozed_until: $snoozed_until) {
      secure_id
      state
      snoozed_until
    }
  }
`;
export type UpdateErrorGroupStateMutationFn = Apollo.MutationFunction<
  Types.UpdateErrorGroupStateMutation,
  Types.UpdateErrorGroupStateMutationVariables
>;

/**
 * __useUpdateErrorGroupStateMutation__
 *
 * To run a mutation, you first call `useUpdateErrorGroupStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateErrorGroupStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateErrorGroupStateMutation, { data, loading, error }] = useUpdateErrorGroupStateMutation({
 *   variables: {
 *      secure_id: // value for 'secure_id'
 *      state: // value for 'state'
 *      snoozed_until: // value for 'snoozed_until'
 *   },
 * });
 */
export function useUpdateErrorGroupStateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateErrorGroupStateMutation,
    Types.UpdateErrorGroupStateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.UpdateErrorGroupStateMutation, Types.UpdateErrorGroupStateMutationVariables>(
    UpdateErrorGroupStateDocument,
    options,
  );
}
export type UpdateErrorGroupStateMutationHookResult = ReturnType<typeof useUpdateErrorGroupStateMutation>;
export type UpdateErrorGroupStateMutationResult = Apollo.MutationResult<Types.UpdateErrorGroupStateMutation>;
export type UpdateErrorGroupStateMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateErrorGroupStateMutation,
  Types.UpdateErrorGroupStateMutationVariables
>;
export const AddIntegrationToProjectDocument = gql`
  mutation AddIntegrationToProject($integration_type: IntegrationType, $project_id: ID!, $code: String!) {
    addIntegrationToProject(integration_type: $integration_type, project_id: $project_id, code: $code)
  }
`;
export type AddIntegrationToProjectMutationFn = Apollo.MutationFunction<
  Types.AddIntegrationToProjectMutation,
  Types.AddIntegrationToProjectMutationVariables
>;

/**
 * __useAddIntegrationToProjectMutation__
 *
 * To run a mutation, you first call `useAddIntegrationToProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddIntegrationToProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addIntegrationToProjectMutation, { data, loading, error }] = useAddIntegrationToProjectMutation({
 *   variables: {
 *      integration_type: // value for 'integration_type'
 *      project_id: // value for 'project_id'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useAddIntegrationToProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.AddIntegrationToProjectMutation,
    Types.AddIntegrationToProjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.AddIntegrationToProjectMutation, Types.AddIntegrationToProjectMutationVariables>(
    AddIntegrationToProjectDocument,
    options,
  );
}
export type AddIntegrationToProjectMutationHookResult = ReturnType<typeof useAddIntegrationToProjectMutation>;
export type AddIntegrationToProjectMutationResult = Apollo.MutationResult<Types.AddIntegrationToProjectMutation>;
export type AddIntegrationToProjectMutationOptions = Apollo.BaseMutationOptions<
  Types.AddIntegrationToProjectMutation,
  Types.AddIntegrationToProjectMutationVariables
>;
export const RemoveIntegrationFromProjectDocument = gql`
  mutation RemoveIntegrationFromProject($integration_type: IntegrationType, $project_id: ID!) {
    removeIntegrationFromProject(integration_type: $integration_type, project_id: $project_id)
  }
`;
export type RemoveIntegrationFromProjectMutationFn = Apollo.MutationFunction<
  Types.RemoveIntegrationFromProjectMutation,
  Types.RemoveIntegrationFromProjectMutationVariables
>;

/**
 * __useRemoveIntegrationFromProjectMutation__
 *
 * To run a mutation, you first call `useRemoveIntegrationFromProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveIntegrationFromProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeIntegrationFromProjectMutation, { data, loading, error }] = useRemoveIntegrationFromProjectMutation({
 *   variables: {
 *      integration_type: // value for 'integration_type'
 *      project_id: // value for 'project_id'
 *   },
 * });
 */
export function useRemoveIntegrationFromProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.RemoveIntegrationFromProjectMutation,
    Types.RemoveIntegrationFromProjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.RemoveIntegrationFromProjectMutation,
    Types.RemoveIntegrationFromProjectMutationVariables
  >(RemoveIntegrationFromProjectDocument, options);
}
export type RemoveIntegrationFromProjectMutationHookResult = ReturnType<typeof useRemoveIntegrationFromProjectMutation>;
export type RemoveIntegrationFromProjectMutationResult =
  Apollo.MutationResult<Types.RemoveIntegrationFromProjectMutation>;
export type RemoveIntegrationFromProjectMutationOptions = Apollo.BaseMutationOptions<
  Types.RemoveIntegrationFromProjectMutation,
  Types.RemoveIntegrationFromProjectMutationVariables
>;
export const AddIntegrationToWorkspaceDocument = gql`
  mutation AddIntegrationToWorkspace($integration_type: IntegrationType, $workspace_id: ID!, $code: String!) {
    addIntegrationToWorkspace(integration_type: $integration_type, workspace_id: $workspace_id, code: $code)
  }
`;
export type AddIntegrationToWorkspaceMutationFn = Apollo.MutationFunction<
  Types.AddIntegrationToWorkspaceMutation,
  Types.AddIntegrationToWorkspaceMutationVariables
>;

/**
 * __useAddIntegrationToWorkspaceMutation__
 *
 * To run a mutation, you first call `useAddIntegrationToWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddIntegrationToWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addIntegrationToWorkspaceMutation, { data, loading, error }] = useAddIntegrationToWorkspaceMutation({
 *   variables: {
 *      integration_type: // value for 'integration_type'
 *      workspace_id: // value for 'workspace_id'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useAddIntegrationToWorkspaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.AddIntegrationToWorkspaceMutation,
    Types.AddIntegrationToWorkspaceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.AddIntegrationToWorkspaceMutation, Types.AddIntegrationToWorkspaceMutationVariables>(
    AddIntegrationToWorkspaceDocument,
    options,
  );
}
export type AddIntegrationToWorkspaceMutationHookResult = ReturnType<typeof useAddIntegrationToWorkspaceMutation>;
export type AddIntegrationToWorkspaceMutationResult = Apollo.MutationResult<Types.AddIntegrationToWorkspaceMutation>;
export type AddIntegrationToWorkspaceMutationOptions = Apollo.BaseMutationOptions<
  Types.AddIntegrationToWorkspaceMutation,
  Types.AddIntegrationToWorkspaceMutationVariables
>;
export const RemoveIntegrationFromWorkspaceDocument = gql`
  mutation RemoveIntegrationFromWorkspace($integration_type: IntegrationType!, $workspace_id: ID!) {
    removeIntegrationFromWorkspace(integration_type: $integration_type, workspace_id: $workspace_id)
  }
`;
export type RemoveIntegrationFromWorkspaceMutationFn = Apollo.MutationFunction<
  Types.RemoveIntegrationFromWorkspaceMutation,
  Types.RemoveIntegrationFromWorkspaceMutationVariables
>;

/**
 * __useRemoveIntegrationFromWorkspaceMutation__
 *
 * To run a mutation, you first call `useRemoveIntegrationFromWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveIntegrationFromWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeIntegrationFromWorkspaceMutation, { data, loading, error }] = useRemoveIntegrationFromWorkspaceMutation({
 *   variables: {
 *      integration_type: // value for 'integration_type'
 *      workspace_id: // value for 'workspace_id'
 *   },
 * });
 */
export function useRemoveIntegrationFromWorkspaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.RemoveIntegrationFromWorkspaceMutation,
    Types.RemoveIntegrationFromWorkspaceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.RemoveIntegrationFromWorkspaceMutation,
    Types.RemoveIntegrationFromWorkspaceMutationVariables
  >(RemoveIntegrationFromWorkspaceDocument, options);
}
export type RemoveIntegrationFromWorkspaceMutationHookResult = ReturnType<
  typeof useRemoveIntegrationFromWorkspaceMutation
>;
export type RemoveIntegrationFromWorkspaceMutationResult =
  Apollo.MutationResult<Types.RemoveIntegrationFromWorkspaceMutation>;
export type RemoveIntegrationFromWorkspaceMutationOptions = Apollo.BaseMutationOptions<
  Types.RemoveIntegrationFromWorkspaceMutation,
  Types.RemoveIntegrationFromWorkspaceMutationVariables
>;
export const SubmitRegistrationFormDocument = gql`
  mutation SubmitRegistrationForm(
    $workspace_id: ID!
    $team_size: String!
    $role: String!
    $use_case: String!
    $heard_about: String!
    $pun: String
  ) {
    submitRegistrationForm(
      workspace_id: $workspace_id
      team_size: $team_size
      role: $role
      use_case: $use_case
      heard_about: $heard_about
      pun: $pun
    )
  }
`;
export type SubmitRegistrationFormMutationFn = Apollo.MutationFunction<
  Types.SubmitRegistrationFormMutation,
  Types.SubmitRegistrationFormMutationVariables
>;

/**
 * __useSubmitRegistrationFormMutation__
 *
 * To run a mutation, you first call `useSubmitRegistrationFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitRegistrationFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitRegistrationFormMutation, { data, loading, error }] = useSubmitRegistrationFormMutation({
 *   variables: {
 *      workspace_id: // value for 'workspace_id'
 *      team_size: // value for 'team_size'
 *      role: // value for 'role'
 *      use_case: // value for 'use_case'
 *      heard_about: // value for 'heard_about'
 *      pun: // value for 'pun'
 *   },
 * });
 */
export function useSubmitRegistrationFormMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SubmitRegistrationFormMutation,
    Types.SubmitRegistrationFormMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.SubmitRegistrationFormMutation, Types.SubmitRegistrationFormMutationVariables>(
    SubmitRegistrationFormDocument,
    options,
  );
}
export type SubmitRegistrationFormMutationHookResult = ReturnType<typeof useSubmitRegistrationFormMutation>;
export type SubmitRegistrationFormMutationResult = Apollo.MutationResult<Types.SubmitRegistrationFormMutation>;
export type SubmitRegistrationFormMutationOptions = Apollo.BaseMutationOptions<
  Types.SubmitRegistrationFormMutation,
  Types.SubmitRegistrationFormMutationVariables
>;
export const EditProjectSettingsDocument = gql`
  mutation EditProjectSettings(
    $projectId: StringID!
    $excluded_users: StringArray
    $error_filters: StringArray
    $error_json_paths: StringArray
    $filter_chrome_extension: Boolean
    $rage_click_window_seconds: Int
    $rage_click_radius_pixels: Int
    $rage_click_count: Int
    $filterSessionsWithoutError: Boolean
    $autoResolveStaleErrorsDayInterval: Int
    $sampling: SamplingInput
  ) {
    editProjectSettings(
      projectId: $projectId
      excluded_users: $excluded_users
      error_filters: $error_filters
      error_json_paths: $error_json_paths
      filter_chrome_extension: $filter_chrome_extension
      rage_click_window_seconds: $rage_click_window_seconds
      rage_click_radius_pixels: $rage_click_radius_pixels
      rage_click_count: $rage_click_count
      filterSessionsWithoutError: $filterSessionsWithoutError
      autoResolveStaleErrorsDayInterval: $autoResolveStaleErrorsDayInterval
      sampling: $sampling
    ) {
      id
      name
      billing_email
      excluded_users
      error_filters
      error_json_paths
      filter_chrome_extension
      rage_click_window_seconds
      rage_click_radius_pixels
      rage_click_count
      filterSessionsWithoutError
      autoResolveStaleErrorsDayInterval
      sampling {
        session_sampling_rate
        error_sampling_rate
        log_sampling_rate
        trace_sampling_rate
        metric_sampling_rate
        session_minute_rate_limit
        error_minute_rate_limit
        log_minute_rate_limit
        trace_minute_rate_limit
        metric_minute_rate_limit
        session_exclusion_query
        error_exclusion_query
        log_exclusion_query
        trace_exclusion_query
        metric_exclusion_query
      }
    }
  }
`;
export type EditProjectSettingsMutationFn = Apollo.MutationFunction<
  Types.EditProjectSettingsMutation,
  Types.EditProjectSettingsMutationVariables
>;

/**
 * __useEditProjectSettingsMutation__
 *
 * To run a mutation, you first call `useEditProjectSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProjectSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProjectSettingsMutation, { data, loading, error }] = useEditProjectSettingsMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      excluded_users: // value for 'excluded_users'
 *      error_filters: // value for 'error_filters'
 *      error_json_paths: // value for 'error_json_paths'
 *      filter_chrome_extension: // value for 'filter_chrome_extension'
 *      rage_click_window_seconds: // value for 'rage_click_window_seconds'
 *      rage_click_radius_pixels: // value for 'rage_click_radius_pixels'
 *      rage_click_count: // value for 'rage_click_count'
 *      filterSessionsWithoutError: // value for 'filterSessionsWithoutError'
 *      autoResolveStaleErrorsDayInterval: // value for 'autoResolveStaleErrorsDayInterval'
 *      sampling: // value for 'sampling'
 *   },
 * });
 */
export function useEditProjectSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.EditProjectSettingsMutation,
    Types.EditProjectSettingsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.EditProjectSettingsMutation, Types.EditProjectSettingsMutationVariables>(
    EditProjectSettingsDocument,
    options,
  );
}
export type EditProjectSettingsMutationHookResult = ReturnType<typeof useEditProjectSettingsMutation>;
export type EditProjectSettingsMutationResult = Apollo.MutationResult<Types.EditProjectSettingsMutation>;
export type EditProjectSettingsMutationOptions = Apollo.BaseMutationOptions<
  Types.EditProjectSettingsMutation,
  Types.EditProjectSettingsMutationVariables
>;
export const CreateAlertDocument = gql`
  mutation CreateAlert(
    $project_id: StringID!
    $name: String!
    $message_content: String
    $product_type: ProductType!
    $function_type: MetricAggregator!
    $population_function_type: MetricAggregator
    $population_query: String
    $population_window: Int
    $function_column: String
    $query: String
    $group_by_key: String
    $group_by_keys: [String!]
    $default: Boolean
    $threshold_value: Float
    $threshold_window: Int
    $threshold_cooldown: Int
    $threshold_type: ThresholdType
    $threshold_condition: ThresholdCondition
    $destinations: [AlertDestinationInput!]!
    $sql: String
    $auto_investigation_enabled: Boolean
    $investigation_cooldown: Int
    $permission_mode: String
    $investigation_repositories: StringArray
    $investigation_prompt: String
    $evaluation_delay_seconds: Int
    $hide_graph: Boolean
    $warn_threshold_value: Float
    $no_data_behavior: NoDataBehavior
    $send_resolved_alert: Boolean
    $tags: StringMap
  ) {
    createAlert(
      project_id: $project_id
      name: $name
      message_content: $message_content
      product_type: $product_type
      function_type: $function_type
      population_function_type: $population_function_type
      population_query: $population_query
      population_window: $population_window
      function_column: $function_column
      query: $query
      group_by_key: $group_by_key
      group_by_keys: $group_by_keys
      default: $default
      threshold_value: $threshold_value
      threshold_window: $threshold_window
      threshold_cooldown: $threshold_cooldown
      threshold_type: $threshold_type
      threshold_condition: $threshold_condition
      destinations: $destinations
      sql: $sql
      auto_investigation_enabled: $auto_investigation_enabled
      investigation_cooldown: $investigation_cooldown
      permission_mode: $permission_mode
      investigation_repositories: $investigation_repositories
      investigation_prompt: $investigation_prompt
      evaluation_delay_seconds: $evaluation_delay_seconds
      hide_graph: $hide_graph
      warn_threshold_value: $warn_threshold_value
      no_data_behavior: $no_data_behavior
      send_resolved_alert: $send_resolved_alert
      tags: $tags
    ) {
      id
      name
      product_type
    }
  }
`;
export type CreateAlertMutationFn = Apollo.MutationFunction<
  Types.CreateAlertMutation,
  Types.CreateAlertMutationVariables
>;

/**
 * __useCreateAlertMutation__
 *
 * To run a mutation, you first call `useCreateAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAlertMutation, { data, loading, error }] = useCreateAlertMutation({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      name: // value for 'name'
 *      message_content: // value for 'message_content'
 *      product_type: // value for 'product_type'
 *      function_type: // value for 'function_type'
 *      population_function_type: // value for 'population_function_type'
 *      population_query: // value for 'population_query'
 *      population_window: // value for 'population_window'
 *      function_column: // value for 'function_column'
 *      query: // value for 'query'
 *      group_by_key: // value for 'group_by_key'
 *      group_by_keys: // value for 'group_by_keys'
 *      default: // value for 'default'
 *      threshold_value: // value for 'threshold_value'
 *      threshold_window: // value for 'threshold_window'
 *      threshold_cooldown: // value for 'threshold_cooldown'
 *      threshold_type: // value for 'threshold_type'
 *      threshold_condition: // value for 'threshold_condition'
 *      destinations: // value for 'destinations'
 *      sql: // value for 'sql'
 *      auto_investigation_enabled: // value for 'auto_investigation_enabled'
 *      investigation_cooldown: // value for 'investigation_cooldown'
 *      permission_mode: // value for 'permission_mode'
 *      investigation_repositories: // value for 'investigation_repositories'
 *      investigation_prompt: // value for 'investigation_prompt'
 *      evaluation_delay_seconds: // value for 'evaluation_delay_seconds'
 *      hide_graph: // value for 'hide_graph'
 *      warn_threshold_value: // value for 'warn_threshold_value'
 *      no_data_behavior: // value for 'no_data_behavior'
 *      send_resolved_alert: // value for 'send_resolved_alert'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateAlertMutation(
  baseOptions?: Apollo.MutationHookOptions<Types.CreateAlertMutation, Types.CreateAlertMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.CreateAlertMutation, Types.CreateAlertMutationVariables>(
    CreateAlertDocument,
    options,
  );
}
export type CreateAlertMutationHookResult = ReturnType<typeof useCreateAlertMutation>;
export type CreateAlertMutationResult = Apollo.MutationResult<Types.CreateAlertMutation>;
export type CreateAlertMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateAlertMutation,
  Types.CreateAlertMutationVariables
>;
export const UpdateAlertDocument = gql`
  mutation UpdateAlert(
    $project_id: StringID!
    $alert_id: ID!
    $name: String!
    $message_content: String
    $product_type: ProductType!
    $function_type: MetricAggregator!
    $population_function_type: MetricAggregator
    $population_query: String
    $population_window: Int
    $function_column: String
    $query: String
    $group_by_key: String
    $group_by_keys: [String!]
    $threshold_value: Float
    $threshold_window: Int
    $threshold_cooldown: Int
    $threshold_type: ThresholdType
    $threshold_condition: ThresholdCondition
    $destinations: [AlertDestinationInput!]
    $sql: String
    $auto_investigation_enabled: Boolean
    $investigation_cooldown: Int
    $permission_mode: String
    $investigation_repositories: StringArray
    $investigation_prompt: String
    $evaluation_delay_seconds: Int
    $hide_graph: Boolean
    $warn_threshold_value: Float
    $no_data_behavior: NoDataBehavior
    $send_resolved_alert: Boolean
    $tags: StringMap
  ) {
    updateAlert(
      project_id: $project_id
      alert_id: $alert_id
      name: $name
      message_content: $message_content
      product_type: $product_type
      function_type: $function_type
      population_function_type: $population_function_type
      population_query: $population_query
      population_window: $population_window
      function_column: $function_column
      query: $query
      group_by_key: $group_by_key
      group_by_keys: $group_by_keys
      threshold_value: $threshold_value
      threshold_window: $threshold_window
      threshold_cooldown: $threshold_cooldown
      threshold_type: $threshold_type
      threshold_condition: $threshold_condition
      destinations: $destinations
      sql: $sql
      auto_investigation_enabled: $auto_investigation_enabled
      investigation_cooldown: $investigation_cooldown
      permission_mode: $permission_mode
      investigation_repositories: $investigation_repositories
      investigation_prompt: $investigation_prompt
      evaluation_delay_seconds: $evaluation_delay_seconds
      hide_graph: $hide_graph
      warn_threshold_value: $warn_threshold_value
      no_data_behavior: $no_data_behavior
      send_resolved_alert: $send_resolved_alert
      tags: $tags
    ) {
      id
      name
      product_type
    }
  }
`;
export type UpdateAlertMutationFn = Apollo.MutationFunction<
  Types.UpdateAlertMutation,
  Types.UpdateAlertMutationVariables
>;

/**
 * __useUpdateAlertMutation__
 *
 * To run a mutation, you first call `useUpdateAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAlertMutation, { data, loading, error }] = useUpdateAlertMutation({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      alert_id: // value for 'alert_id'
 *      name: // value for 'name'
 *      message_content: // value for 'message_content'
 *      product_type: // value for 'product_type'
 *      function_type: // value for 'function_type'
 *      population_function_type: // value for 'population_function_type'
 *      population_query: // value for 'population_query'
 *      population_window: // value for 'population_window'
 *      function_column: // value for 'function_column'
 *      query: // value for 'query'
 *      group_by_key: // value for 'group_by_key'
 *      group_by_keys: // value for 'group_by_keys'
 *      threshold_value: // value for 'threshold_value'
 *      threshold_window: // value for 'threshold_window'
 *      threshold_cooldown: // value for 'threshold_cooldown'
 *      threshold_type: // value for 'threshold_type'
 *      threshold_condition: // value for 'threshold_condition'
 *      destinations: // value for 'destinations'
 *      sql: // value for 'sql'
 *      auto_investigation_enabled: // value for 'auto_investigation_enabled'
 *      investigation_cooldown: // value for 'investigation_cooldown'
 *      permission_mode: // value for 'permission_mode'
 *      investigation_repositories: // value for 'investigation_repositories'
 *      investigation_prompt: // value for 'investigation_prompt'
 *      evaluation_delay_seconds: // value for 'evaluation_delay_seconds'
 *      hide_graph: // value for 'hide_graph'
 *      warn_threshold_value: // value for 'warn_threshold_value'
 *      no_data_behavior: // value for 'no_data_behavior'
 *      send_resolved_alert: // value for 'send_resolved_alert'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useUpdateAlertMutation(
  baseOptions?: Apollo.MutationHookOptions<Types.UpdateAlertMutation, Types.UpdateAlertMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.UpdateAlertMutation, Types.UpdateAlertMutationVariables>(
    UpdateAlertDocument,
    options,
  );
}
export type UpdateAlertMutationHookResult = ReturnType<typeof useUpdateAlertMutation>;
export type UpdateAlertMutationResult = Apollo.MutationResult<Types.UpdateAlertMutation>;
export type UpdateAlertMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateAlertMutation,
  Types.UpdateAlertMutationVariables
>;
export const UpdateAlertDisabledDocument = gql`
  mutation UpdateAlertDisabled($project_id: StringID!, $alert_id: ID!, $disabled: Boolean!) {
    updateAlertDisabled(project_id: $project_id, alert_id: $alert_id, disabled: $disabled)
  }
`;
export type UpdateAlertDisabledMutationFn = Apollo.MutationFunction<
  Types.UpdateAlertDisabledMutation,
  Types.UpdateAlertDisabledMutationVariables
>;

/**
 * __useUpdateAlertDisabledMutation__
 *
 * To run a mutation, you first call `useUpdateAlertDisabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlertDisabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAlertDisabledMutation, { data, loading, error }] = useUpdateAlertDisabledMutation({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      alert_id: // value for 'alert_id'
 *      disabled: // value for 'disabled'
 *   },
 * });
 */
export function useUpdateAlertDisabledMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateAlertDisabledMutation,
    Types.UpdateAlertDisabledMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.UpdateAlertDisabledMutation, Types.UpdateAlertDisabledMutationVariables>(
    UpdateAlertDisabledDocument,
    options,
  );
}
export type UpdateAlertDisabledMutationHookResult = ReturnType<typeof useUpdateAlertDisabledMutation>;
export type UpdateAlertDisabledMutationResult = Apollo.MutationResult<Types.UpdateAlertDisabledMutation>;
export type UpdateAlertDisabledMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateAlertDisabledMutation,
  Types.UpdateAlertDisabledMutationVariables
>;
export const DeleteAlertDocument = gql`
  mutation DeleteAlert($project_id: StringID!, $alert_id: ID!) {
    deleteAlert(project_id: $project_id, alert_id: $alert_id)
  }
`;
export type DeleteAlertMutationFn = Apollo.MutationFunction<
  Types.DeleteAlertMutation,
  Types.DeleteAlertMutationVariables
>;

/**
 * __useDeleteAlertMutation__
 *
 * To run a mutation, you first call `useDeleteAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAlertMutation, { data, loading, error }] = useDeleteAlertMutation({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      alert_id: // value for 'alert_id'
 *   },
 * });
 */
export function useDeleteAlertMutation(
  baseOptions?: Apollo.MutationHookOptions<Types.DeleteAlertMutation, Types.DeleteAlertMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.DeleteAlertMutation, Types.DeleteAlertMutationVariables>(
    DeleteAlertDocument,
    options,
  );
}
export type DeleteAlertMutationHookResult = ReturnType<typeof useDeleteAlertMutation>;
export type DeleteAlertMutationResult = Apollo.MutationResult<Types.DeleteAlertMutation>;
export type DeleteAlertMutationOptions = Apollo.BaseMutationOptions<
  Types.DeleteAlertMutation,
  Types.DeleteAlertMutationVariables
>;
export const TestAlertConfigurationDocument = gql`
  mutation TestAlertConfiguration($project_id: StringID!, $alert_configuration: AlertConfigurationInput!) {
    testAlertConfiguration(project_id: $project_id, alert_configuration: $alert_configuration)
  }
`;
export type TestAlertConfigurationMutationFn = Apollo.MutationFunction<
  Types.TestAlertConfigurationMutation,
  Types.TestAlertConfigurationMutationVariables
>;

/**
 * __useTestAlertConfigurationMutation__
 *
 * To run a mutation, you first call `useTestAlertConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestAlertConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testAlertConfigurationMutation, { data, loading, error }] = useTestAlertConfigurationMutation({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      alert_configuration: // value for 'alert_configuration'
 *   },
 * });
 */
export function useTestAlertConfigurationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.TestAlertConfigurationMutation,
    Types.TestAlertConfigurationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.TestAlertConfigurationMutation, Types.TestAlertConfigurationMutationVariables>(
    TestAlertConfigurationDocument,
    options,
  );
}
export type TestAlertConfigurationMutationHookResult = ReturnType<typeof useTestAlertConfigurationMutation>;
export type TestAlertConfigurationMutationResult = Apollo.MutationResult<Types.TestAlertConfigurationMutation>;
export type TestAlertConfigurationMutationOptions = Apollo.BaseMutationOptions<
  Types.TestAlertConfigurationMutation,
  Types.TestAlertConfigurationMutationVariables
>;
export const UpdateSessionIsPublicDocument = gql`
  mutation UpdateSessionIsPublic($session_secure_id: String!, $is_public: Boolean!) {
    updateSessionIsPublic(session_secure_id: $session_secure_id, is_public: $is_public) {
      secure_id
      is_public
    }
  }
`;
export type UpdateSessionIsPublicMutationFn = Apollo.MutationFunction<
  Types.UpdateSessionIsPublicMutation,
  Types.UpdateSessionIsPublicMutationVariables
>;

/**
 * __useUpdateSessionIsPublicMutation__
 *
 * To run a mutation, you first call `useUpdateSessionIsPublicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSessionIsPublicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSessionIsPublicMutation, { data, loading, error }] = useUpdateSessionIsPublicMutation({
 *   variables: {
 *      session_secure_id: // value for 'session_secure_id'
 *      is_public: // value for 'is_public'
 *   },
 * });
 */
export function useUpdateSessionIsPublicMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateSessionIsPublicMutation,
    Types.UpdateSessionIsPublicMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.UpdateSessionIsPublicMutation, Types.UpdateSessionIsPublicMutationVariables>(
    UpdateSessionIsPublicDocument,
    options,
  );
}
export type UpdateSessionIsPublicMutationHookResult = ReturnType<typeof useUpdateSessionIsPublicMutation>;
export type UpdateSessionIsPublicMutationResult = Apollo.MutationResult<Types.UpdateSessionIsPublicMutation>;
export type UpdateSessionIsPublicMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateSessionIsPublicMutation,
  Types.UpdateSessionIsPublicMutationVariables
>;
export const UpdateErrorGroupIsPublicDocument = gql`
  mutation UpdateErrorGroupIsPublic($error_group_secure_id: String!, $is_public: Boolean!) {
    updateErrorGroupIsPublic(error_group_secure_id: $error_group_secure_id, is_public: $is_public) {
      secure_id
      is_public
    }
  }
`;
export type UpdateErrorGroupIsPublicMutationFn = Apollo.MutationFunction<
  Types.UpdateErrorGroupIsPublicMutation,
  Types.UpdateErrorGroupIsPublicMutationVariables
>;

/**
 * __useUpdateErrorGroupIsPublicMutation__
 *
 * To run a mutation, you first call `useUpdateErrorGroupIsPublicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateErrorGroupIsPublicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateErrorGroupIsPublicMutation, { data, loading, error }] = useUpdateErrorGroupIsPublicMutation({
 *   variables: {
 *      error_group_secure_id: // value for 'error_group_secure_id'
 *      is_public: // value for 'is_public'
 *   },
 * });
 */
export function useUpdateErrorGroupIsPublicMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateErrorGroupIsPublicMutation,
    Types.UpdateErrorGroupIsPublicMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.UpdateErrorGroupIsPublicMutation, Types.UpdateErrorGroupIsPublicMutationVariables>(
    UpdateErrorGroupIsPublicDocument,
    options,
  );
}
export type UpdateErrorGroupIsPublicMutationHookResult = ReturnType<typeof useUpdateErrorGroupIsPublicMutation>;
export type UpdateErrorGroupIsPublicMutationResult = Apollo.MutationResult<Types.UpdateErrorGroupIsPublicMutation>;
export type UpdateErrorGroupIsPublicMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateErrorGroupIsPublicMutation,
  Types.UpdateErrorGroupIsPublicMutationVariables
>;
export const UpdateAllowMeterOverageDocument = gql`
  mutation UpdateAllowMeterOverage($workspace_id: ID!, $allow_meter_overage: Boolean!) {
    updateAllowMeterOverage(workspace_id: $workspace_id, allow_meter_overage: $allow_meter_overage) {
      id
      allow_meter_overage
    }
  }
`;
export type UpdateAllowMeterOverageMutationFn = Apollo.MutationFunction<
  Types.UpdateAllowMeterOverageMutation,
  Types.UpdateAllowMeterOverageMutationVariables
>;

/**
 * __useUpdateAllowMeterOverageMutation__
 *
 * To run a mutation, you first call `useUpdateAllowMeterOverageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllowMeterOverageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllowMeterOverageMutation, { data, loading, error }] = useUpdateAllowMeterOverageMutation({
 *   variables: {
 *      workspace_id: // value for 'workspace_id'
 *      allow_meter_overage: // value for 'allow_meter_overage'
 *   },
 * });
 */
export function useUpdateAllowMeterOverageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateAllowMeterOverageMutation,
    Types.UpdateAllowMeterOverageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.UpdateAllowMeterOverageMutation, Types.UpdateAllowMeterOverageMutationVariables>(
    UpdateAllowMeterOverageDocument,
    options,
  );
}
export type UpdateAllowMeterOverageMutationHookResult = ReturnType<typeof useUpdateAllowMeterOverageMutation>;
export type UpdateAllowMeterOverageMutationResult = Apollo.MutationResult<Types.UpdateAllowMeterOverageMutation>;
export type UpdateAllowMeterOverageMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateAllowMeterOverageMutation,
  Types.UpdateAllowMeterOverageMutationVariables
>;
export const SyncSlackIntegrationDocument = gql`
  mutation SyncSlackIntegration($project_id: ID!) {
    syncSlackIntegration(project_id: $project_id) {
      success
      newChannelsAddedCount
    }
  }
`;
export type SyncSlackIntegrationMutationFn = Apollo.MutationFunction<
  Types.SyncSlackIntegrationMutation,
  Types.SyncSlackIntegrationMutationVariables
>;

/**
 * __useSyncSlackIntegrationMutation__
 *
 * To run a mutation, you first call `useSyncSlackIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncSlackIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncSlackIntegrationMutation, { data, loading, error }] = useSyncSlackIntegrationMutation({
 *   variables: {
 *      project_id: // value for 'project_id'
 *   },
 * });
 */
export function useSyncSlackIntegrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SyncSlackIntegrationMutation,
    Types.SyncSlackIntegrationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.SyncSlackIntegrationMutation, Types.SyncSlackIntegrationMutationVariables>(
    SyncSlackIntegrationDocument,
    options,
  );
}
export type SyncSlackIntegrationMutationHookResult = ReturnType<typeof useSyncSlackIntegrationMutation>;
export type SyncSlackIntegrationMutationResult = Apollo.MutationResult<Types.SyncSlackIntegrationMutation>;
export type SyncSlackIntegrationMutationOptions = Apollo.BaseMutationOptions<
  Types.SyncSlackIntegrationMutation,
  Types.SyncSlackIntegrationMutationVariables
>;
export const DeleteSessionsDocument = gql`
  mutation DeleteSessions($project_id: ID!, $params: QueryInput!, $sessionCount: Int!) {
    deleteSessions(project_id: $project_id, params: $params, sessionCount: $sessionCount)
  }
`;
export type DeleteSessionsMutationFn = Apollo.MutationFunction<
  Types.DeleteSessionsMutation,
  Types.DeleteSessionsMutationVariables
>;

/**
 * __useDeleteSessionsMutation__
 *
 * To run a mutation, you first call `useDeleteSessionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSessionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSessionsMutation, { data, loading, error }] = useDeleteSessionsMutation({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      params: // value for 'params'
 *      sessionCount: // value for 'sessionCount'
 *   },
 * });
 */
export function useDeleteSessionsMutation(
  baseOptions?: Apollo.MutationHookOptions<Types.DeleteSessionsMutation, Types.DeleteSessionsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.DeleteSessionsMutation, Types.DeleteSessionsMutationVariables>(
    DeleteSessionsDocument,
    options,
  );
}
export type DeleteSessionsMutationHookResult = ReturnType<typeof useDeleteSessionsMutation>;
export type DeleteSessionsMutationResult = Apollo.MutationResult<Types.DeleteSessionsMutation>;
export type DeleteSessionsMutationOptions = Apollo.BaseMutationOptions<
  Types.DeleteSessionsMutation,
  Types.DeleteSessionsMutationVariables
>;
export const ExportSessionDocument = gql`
  mutation ExportSession($session_secure_id: String!) {
    exportSession(session_secure_id: $session_secure_id)
  }
`;
export type ExportSessionMutationFn = Apollo.MutationFunction<
  Types.ExportSessionMutation,
  Types.ExportSessionMutationVariables
>;

/**
 * __useExportSessionMutation__
 *
 * To run a mutation, you first call `useExportSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportSessionMutation, { data, loading, error }] = useExportSessionMutation({
 *   variables: {
 *      session_secure_id: // value for 'session_secure_id'
 *   },
 * });
 */
export function useExportSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<Types.ExportSessionMutation, Types.ExportSessionMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.ExportSessionMutation, Types.ExportSessionMutationVariables>(
    ExportSessionDocument,
    options,
  );
}
export type ExportSessionMutationHookResult = ReturnType<typeof useExportSessionMutation>;
export type ExportSessionMutationResult = Apollo.MutationResult<Types.ExportSessionMutation>;
export type ExportSessionMutationOptions = Apollo.BaseMutationOptions<
  Types.ExportSessionMutation,
  Types.ExportSessionMutationVariables
>;
export const UpdateIntegrationProjectSettingsDocument = gql`
  mutation UpdateIntegrationProjectSettings(
    $workspace_id: ID!
    $integration_type: IntegrationType!
    $project_mappings: [IntegrationProjectMappingInput!]!
  ) {
    updateIntegrationProjectMappings(
      workspace_id: $workspace_id
      integration_type: $integration_type
      project_mappings: $project_mappings
    )
  }
`;
export type UpdateIntegrationProjectSettingsMutationFn = Apollo.MutationFunction<
  Types.UpdateIntegrationProjectSettingsMutation,
  Types.UpdateIntegrationProjectSettingsMutationVariables
>;

/**
 * __useUpdateIntegrationProjectSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateIntegrationProjectSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIntegrationProjectSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIntegrationProjectSettingsMutation, { data, loading, error }] = useUpdateIntegrationProjectSettingsMutation({
 *   variables: {
 *      workspace_id: // value for 'workspace_id'
 *      integration_type: // value for 'integration_type'
 *      project_mappings: // value for 'project_mappings'
 *   },
 * });
 */
export function useUpdateIntegrationProjectSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateIntegrationProjectSettingsMutation,
    Types.UpdateIntegrationProjectSettingsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpdateIntegrationProjectSettingsMutation,
    Types.UpdateIntegrationProjectSettingsMutationVariables
  >(UpdateIntegrationProjectSettingsDocument, options);
}
export type UpdateIntegrationProjectSettingsMutationHookResult = ReturnType<
  typeof useUpdateIntegrationProjectSettingsMutation
>;
export type UpdateIntegrationProjectSettingsMutationResult =
  Apollo.MutationResult<Types.UpdateIntegrationProjectSettingsMutation>;
export type UpdateIntegrationProjectSettingsMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateIntegrationProjectSettingsMutation,
  Types.UpdateIntegrationProjectSettingsMutationVariables
>;
export const EditServiceGithubSettingsDocument = gql`
  mutation EditServiceGithubSettings(
    $id: Int64ID!
    $project_id: ID!
    $github_repo_path: String
    $build_prefix: String
    $github_prefix: String
  ) {
    editServiceGithubSettings(
      id: $id
      project_id: $project_id
      github_repo_path: $github_repo_path
      build_prefix: $build_prefix
      github_prefix: $github_prefix
    ) {
      id
      projectID
      name
      status
      githubRepoPath
      buildPrefix
      githubPrefix
      errorDetails
    }
  }
`;
export type EditServiceGithubSettingsMutationFn = Apollo.MutationFunction<
  Types.EditServiceGithubSettingsMutation,
  Types.EditServiceGithubSettingsMutationVariables
>;

/**
 * __useEditServiceGithubSettingsMutation__
 *
 * To run a mutation, you first call `useEditServiceGithubSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditServiceGithubSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editServiceGithubSettingsMutation, { data, loading, error }] = useEditServiceGithubSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      project_id: // value for 'project_id'
 *      github_repo_path: // value for 'github_repo_path'
 *      build_prefix: // value for 'build_prefix'
 *      github_prefix: // value for 'github_prefix'
 *   },
 * });
 */
export function useEditServiceGithubSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.EditServiceGithubSettingsMutation,
    Types.EditServiceGithubSettingsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.EditServiceGithubSettingsMutation, Types.EditServiceGithubSettingsMutationVariables>(
    EditServiceGithubSettingsDocument,
    options,
  );
}
export type EditServiceGithubSettingsMutationHookResult = ReturnType<typeof useEditServiceGithubSettingsMutation>;
export type EditServiceGithubSettingsMutationResult = Apollo.MutationResult<Types.EditServiceGithubSettingsMutation>;
export type EditServiceGithubSettingsMutationOptions = Apollo.BaseMutationOptions<
  Types.EditServiceGithubSettingsMutation,
  Types.EditServiceGithubSettingsMutationVariables
>;
export const UpsertSlackChannelDocument = gql`
  mutation UpsertSlackChannel($project_id: ID!, $name: String!) {
    upsertSlackChannel(project_id: $project_id, name: $name) {
      webhook_channel
      webhook_channel_id
    }
  }
`;
export type UpsertSlackChannelMutationFn = Apollo.MutationFunction<
  Types.UpsertSlackChannelMutation,
  Types.UpsertSlackChannelMutationVariables
>;

/**
 * __useUpsertSlackChannelMutation__
 *
 * To run a mutation, you first call `useUpsertSlackChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSlackChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSlackChannelMutation, { data, loading, error }] = useUpsertSlackChannelMutation({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpsertSlackChannelMutation(
  baseOptions?: Apollo.MutationHookOptions<Types.UpsertSlackChannelMutation, Types.UpsertSlackChannelMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.UpsertSlackChannelMutation, Types.UpsertSlackChannelMutationVariables>(
    UpsertSlackChannelDocument,
    options,
  );
}
export type UpsertSlackChannelMutationHookResult = ReturnType<typeof useUpsertSlackChannelMutation>;
export type UpsertSlackChannelMutationResult = Apollo.MutationResult<Types.UpsertSlackChannelMutation>;
export type UpsertSlackChannelMutationOptions = Apollo.BaseMutationOptions<
  Types.UpsertSlackChannelMutation,
  Types.UpsertSlackChannelMutationVariables
>;
export const TestErrorEnhancementDocument = gql`
  mutation testErrorEnhancement(
    $error_object_id: Int64ID!
    $github_repo_path: String!
    $github_prefix: String
    $build_prefix: String
    $save_error: Boolean
  ) {
    testErrorEnhancement(
      error_object_id: $error_object_id
      github_repo_path: $github_repo_path
      github_prefix: $github_prefix
      build_prefix: $build_prefix
      save_error: $save_error
    ) {
      id
      type
      serviceName
      serviceVersion
      stack_trace
      structured_stack_trace {
        columnNumber
        enhancementSource
        enhancementVersion
        error
        externalLink
        fileName
        functionName
        lineContent
        lineNumber
        linesAfter
        linesBefore
      }
    }
  }
`;
export type TestErrorEnhancementMutationFn = Apollo.MutationFunction<
  Types.TestErrorEnhancementMutation,
  Types.TestErrorEnhancementMutationVariables
>;

/**
 * __useTestErrorEnhancementMutation__
 *
 * To run a mutation, you first call `useTestErrorEnhancementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestErrorEnhancementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testErrorEnhancementMutation, { data, loading, error }] = useTestErrorEnhancementMutation({
 *   variables: {
 *      error_object_id: // value for 'error_object_id'
 *      github_repo_path: // value for 'github_repo_path'
 *      github_prefix: // value for 'github_prefix'
 *      build_prefix: // value for 'build_prefix'
 *      save_error: // value for 'save_error'
 *   },
 * });
 */
export function useTestErrorEnhancementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.TestErrorEnhancementMutation,
    Types.TestErrorEnhancementMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.TestErrorEnhancementMutation, Types.TestErrorEnhancementMutationVariables>(
    TestErrorEnhancementDocument,
    options,
  );
}
export type TestErrorEnhancementMutationHookResult = ReturnType<typeof useTestErrorEnhancementMutation>;
export type TestErrorEnhancementMutationResult = Apollo.MutationResult<Types.TestErrorEnhancementMutation>;
export type TestErrorEnhancementMutationOptions = Apollo.BaseMutationOptions<
  Types.TestErrorEnhancementMutation,
  Types.TestErrorEnhancementMutationVariables
>;
export const DeleteSavedSegmentDocument = gql`
  mutation DeleteSavedSegment($segment_id: ID!) {
    deleteSavedSegment(segment_id: $segment_id)
  }
`;
export type DeleteSavedSegmentMutationFn = Apollo.MutationFunction<
  Types.DeleteSavedSegmentMutation,
  Types.DeleteSavedSegmentMutationVariables
>;

/**
 * __useDeleteSavedSegmentMutation__
 *
 * To run a mutation, you first call `useDeleteSavedSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSavedSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSavedSegmentMutation, { data, loading, error }] = useDeleteSavedSegmentMutation({
 *   variables: {
 *      segment_id: // value for 'segment_id'
 *   },
 * });
 */
export function useDeleteSavedSegmentMutation(
  baseOptions?: Apollo.MutationHookOptions<Types.DeleteSavedSegmentMutation, Types.DeleteSavedSegmentMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.DeleteSavedSegmentMutation, Types.DeleteSavedSegmentMutationVariables>(
    DeleteSavedSegmentDocument,
    options,
  );
}
export type DeleteSavedSegmentMutationHookResult = ReturnType<typeof useDeleteSavedSegmentMutation>;
export type DeleteSavedSegmentMutationResult = Apollo.MutationResult<Types.DeleteSavedSegmentMutation>;
export type DeleteSavedSegmentMutationOptions = Apollo.BaseMutationOptions<
  Types.DeleteSavedSegmentMutation,
  Types.DeleteSavedSegmentMutationVariables
>;
export const EditSavedSegmentDocument = gql`
  mutation EditSavedSegment(
    $project_id: StringID!
    $id: ID!
    $query: String!
    $name: String!
    $entity_type: SavedSegmentEntityType!
    $advanced_search_params: AdvancedSearchParamsInput
  ) {
    editSavedSegment(
      project_id: $project_id
      id: $id
      query: $query
      name: $name
      entity_type: $entity_type
      advanced_search_params: $advanced_search_params
    )
  }
`;
export type EditSavedSegmentMutationFn = Apollo.MutationFunction<
  Types.EditSavedSegmentMutation,
  Types.EditSavedSegmentMutationVariables
>;

/**
 * __useEditSavedSegmentMutation__
 *
 * To run a mutation, you first call `useEditSavedSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSavedSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSavedSegmentMutation, { data, loading, error }] = useEditSavedSegmentMutation({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      id: // value for 'id'
 *      query: // value for 'query'
 *      name: // value for 'name'
 *      entity_type: // value for 'entity_type'
 *      advanced_search_params: // value for 'advanced_search_params'
 *   },
 * });
 */
export function useEditSavedSegmentMutation(
  baseOptions?: Apollo.MutationHookOptions<Types.EditSavedSegmentMutation, Types.EditSavedSegmentMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.EditSavedSegmentMutation, Types.EditSavedSegmentMutationVariables>(
    EditSavedSegmentDocument,
    options,
  );
}
export type EditSavedSegmentMutationHookResult = ReturnType<typeof useEditSavedSegmentMutation>;
export type EditSavedSegmentMutationResult = Apollo.MutationResult<Types.EditSavedSegmentMutation>;
export type EditSavedSegmentMutationOptions = Apollo.BaseMutationOptions<
  Types.EditSavedSegmentMutation,
  Types.EditSavedSegmentMutationVariables
>;
export const CreateSavedSegmentDocument = gql`
  mutation CreateSavedSegment(
    $project_id: StringID!
    $name: String!
    $query: String!
    $entity_type: SavedSegmentEntityType!
    $advanced_search_params: AdvancedSearchParamsInput
  ) {
    createSavedSegment(
      project_id: $project_id
      entity_type: $entity_type
      name: $name
      query: $query
      advanced_search_params: $advanced_search_params
    ) {
      name
      id
    }
  }
`;
export type CreateSavedSegmentMutationFn = Apollo.MutationFunction<
  Types.CreateSavedSegmentMutation,
  Types.CreateSavedSegmentMutationVariables
>;

/**
 * __useCreateSavedSegmentMutation__
 *
 * To run a mutation, you first call `useCreateSavedSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSavedSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSavedSegmentMutation, { data, loading, error }] = useCreateSavedSegmentMutation({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      name: // value for 'name'
 *      query: // value for 'query'
 *      entity_type: // value for 'entity_type'
 *      advanced_search_params: // value for 'advanced_search_params'
 *   },
 * });
 */
export function useCreateSavedSegmentMutation(
  baseOptions?: Apollo.MutationHookOptions<Types.CreateSavedSegmentMutation, Types.CreateSavedSegmentMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.CreateSavedSegmentMutation, Types.CreateSavedSegmentMutationVariables>(
    CreateSavedSegmentDocument,
    options,
  );
}
export type CreateSavedSegmentMutationHookResult = ReturnType<typeof useCreateSavedSegmentMutation>;
export type CreateSavedSegmentMutationResult = Apollo.MutationResult<Types.CreateSavedSegmentMutation>;
export type CreateSavedSegmentMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateSavedSegmentMutation,
  Types.CreateSavedSegmentMutationVariables
>;
export const UpsertVisualizationDocument = gql`
  mutation UpsertVisualization($visualization: VisualizationInput!) {
    upsertVisualization(visualization: $visualization)
  }
`;
export type UpsertVisualizationMutationFn = Apollo.MutationFunction<
  Types.UpsertVisualizationMutation,
  Types.UpsertVisualizationMutationVariables
>;

/**
 * __useUpsertVisualizationMutation__
 *
 * To run a mutation, you first call `useUpsertVisualizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertVisualizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertVisualizationMutation, { data, loading, error }] = useUpsertVisualizationMutation({
 *   variables: {
 *      visualization: // value for 'visualization'
 *   },
 * });
 */
export function useUpsertVisualizationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpsertVisualizationMutation,
    Types.UpsertVisualizationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.UpsertVisualizationMutation, Types.UpsertVisualizationMutationVariables>(
    UpsertVisualizationDocument,
    options,
  );
}
export type UpsertVisualizationMutationHookResult = ReturnType<typeof useUpsertVisualizationMutation>;
export type UpsertVisualizationMutationResult = Apollo.MutationResult<Types.UpsertVisualizationMutation>;
export type UpsertVisualizationMutationOptions = Apollo.BaseMutationOptions<
  Types.UpsertVisualizationMutation,
  Types.UpsertVisualizationMutationVariables
>;
export const DeleteVisualizationDocument = gql`
  mutation DeleteVisualization($id: ID!) {
    deleteVisualization(id: $id)
  }
`;
export type DeleteVisualizationMutationFn = Apollo.MutationFunction<
  Types.DeleteVisualizationMutation,
  Types.DeleteVisualizationMutationVariables
>;

/**
 * __useDeleteVisualizationMutation__
 *
 * To run a mutation, you first call `useDeleteVisualizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVisualizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVisualizationMutation, { data, loading, error }] = useDeleteVisualizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVisualizationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeleteVisualizationMutation,
    Types.DeleteVisualizationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.DeleteVisualizationMutation, Types.DeleteVisualizationMutationVariables>(
    DeleteVisualizationDocument,
    options,
  );
}
export type DeleteVisualizationMutationHookResult = ReturnType<typeof useDeleteVisualizationMutation>;
export type DeleteVisualizationMutationResult = Apollo.MutationResult<Types.DeleteVisualizationMutation>;
export type DeleteVisualizationMutationOptions = Apollo.BaseMutationOptions<
  Types.DeleteVisualizationMutation,
  Types.DeleteVisualizationMutationVariables
>;
export const UpsertGraphDocument = gql`
  mutation UpsertGraph($graph: GraphInput!) {
    upsertGraph(graph: $graph) {
      id
      type
      title
      productType
      query
      groupByKeys
      bucketByKey
      bucketCount
      limit
      limitFunctionType
      limitMetric
      funnelSteps {
        title
        query
      }
      display
      comparisonMode
      strictOrder
      breakdownBy
      breakdownLimit
      nullHandling
      showExemplars
      exemplarScaleMode
      expressions {
        aggregator
        column
      }
      sql
      heatmapSecureSessionId
      heatmapSessionTimestamp
    }
  }
`;
export type UpsertGraphMutationFn = Apollo.MutationFunction<
  Types.UpsertGraphMutation,
  Types.UpsertGraphMutationVariables
>;

/**
 * __useUpsertGraphMutation__
 *
 * To run a mutation, you first call `useUpsertGraphMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertGraphMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertGraphMutation, { data, loading, error }] = useUpsertGraphMutation({
 *   variables: {
 *      graph: // value for 'graph'
 *   },
 * });
 */
export function useUpsertGraphMutation(
  baseOptions?: Apollo.MutationHookOptions<Types.UpsertGraphMutation, Types.UpsertGraphMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.UpsertGraphMutation, Types.UpsertGraphMutationVariables>(
    UpsertGraphDocument,
    options,
  );
}
export type UpsertGraphMutationHookResult = ReturnType<typeof useUpsertGraphMutation>;
export type UpsertGraphMutationResult = Apollo.MutationResult<Types.UpsertGraphMutation>;
export type UpsertGraphMutationOptions = Apollo.BaseMutationOptions<
  Types.UpsertGraphMutation,
  Types.UpsertGraphMutationVariables
>;
export const DeleteGraphDocument = gql`
  mutation DeleteGraph($id: ID!) {
    deleteGraph(id: $id)
  }
`;
export type DeleteGraphMutationFn = Apollo.MutationFunction<
  Types.DeleteGraphMutation,
  Types.DeleteGraphMutationVariables
>;

/**
 * __useDeleteGraphMutation__
 *
 * To run a mutation, you first call `useDeleteGraphMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGraphMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGraphMutation, { data, loading, error }] = useDeleteGraphMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGraphMutation(
  baseOptions?: Apollo.MutationHookOptions<Types.DeleteGraphMutation, Types.DeleteGraphMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.DeleteGraphMutation, Types.DeleteGraphMutationVariables>(
    DeleteGraphDocument,
    options,
  );
}
export type DeleteGraphMutationHookResult = ReturnType<typeof useDeleteGraphMutation>;
export type DeleteGraphMutationResult = Apollo.MutationResult<Types.DeleteGraphMutation>;
export type DeleteGraphMutationOptions = Apollo.BaseMutationOptions<
  Types.DeleteGraphMutation,
  Types.DeleteGraphMutationVariables
>;
export const CreateCloudflareProxyDocument = gql`
  mutation CreateCloudflareProxy($workspace_id: ID!, $proxy_subdomain: String!) {
    createCloudflareProxy(workspace_id: $workspace_id, proxy_subdomain: $proxy_subdomain)
  }
`;
export type CreateCloudflareProxyMutationFn = Apollo.MutationFunction<
  Types.CreateCloudflareProxyMutation,
  Types.CreateCloudflareProxyMutationVariables
>;

/**
 * __useCreateCloudflareProxyMutation__
 *
 * To run a mutation, you first call `useCreateCloudflareProxyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCloudflareProxyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCloudflareProxyMutation, { data, loading, error }] = useCreateCloudflareProxyMutation({
 *   variables: {
 *      workspace_id: // value for 'workspace_id'
 *      proxy_subdomain: // value for 'proxy_subdomain'
 *   },
 * });
 */
export function useCreateCloudflareProxyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateCloudflareProxyMutation,
    Types.CreateCloudflareProxyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.CreateCloudflareProxyMutation, Types.CreateCloudflareProxyMutationVariables>(
    CreateCloudflareProxyDocument,
    options,
  );
}
export type CreateCloudflareProxyMutationHookResult = ReturnType<typeof useCreateCloudflareProxyMutation>;
export type CreateCloudflareProxyMutationResult = Apollo.MutationResult<Types.CreateCloudflareProxyMutation>;
export type CreateCloudflareProxyMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateCloudflareProxyMutation,
  Types.CreateCloudflareProxyMutationVariables
>;
export const AgentPromptDocument = gql`
  mutation AgentPrompt($input: AgentPromptInput!) {
    agentPrompt(input: $input) {
      conversation_id
      text
      turn
      is_final
    }
  }
`;
export type AgentPromptMutationFn = Apollo.MutationFunction<
  Types.AgentPromptMutation,
  Types.AgentPromptMutationVariables
>;

/**
 * __useAgentPromptMutation__
 *
 * To run a mutation, you first call `useAgentPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAgentPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [agentPromptMutation, { data, loading, error }] = useAgentPromptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAgentPromptMutation(
  baseOptions?: Apollo.MutationHookOptions<Types.AgentPromptMutation, Types.AgentPromptMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.AgentPromptMutation, Types.AgentPromptMutationVariables>(
    AgentPromptDocument,
    options,
  );
}
export type AgentPromptMutationHookResult = ReturnType<typeof useAgentPromptMutation>;
export type AgentPromptMutationResult = Apollo.MutationResult<Types.AgentPromptMutation>;
export type AgentPromptMutationOptions = Apollo.BaseMutationOptions<
  Types.AgentPromptMutation,
  Types.AgentPromptMutationVariables
>;
export const FlagCleanupPromptDocument = gql`
  mutation FlagCleanupPrompt($input: FlagCleanupPromptInput!) {
    flagCleanupPrompt(input: $input) {
      conversation_id
      text
      turn
      is_final
    }
  }
`;
export type FlagCleanupPromptMutationFn = Apollo.MutationFunction<
  Types.FlagCleanupPromptMutation,
  Types.FlagCleanupPromptMutationVariables
>;

/**
 * __useFlagCleanupPromptMutation__
 *
 * To run a mutation, you first call `useFlagCleanupPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFlagCleanupPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [flagCleanupPromptMutation, { data, loading, error }] = useFlagCleanupPromptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFlagCleanupPromptMutation(
  baseOptions?: Apollo.MutationHookOptions<Types.FlagCleanupPromptMutation, Types.FlagCleanupPromptMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.FlagCleanupPromptMutation, Types.FlagCleanupPromptMutationVariables>(
    FlagCleanupPromptDocument,
    options,
  );
}
export type FlagCleanupPromptMutationHookResult = ReturnType<typeof useFlagCleanupPromptMutation>;
export type FlagCleanupPromptMutationResult = Apollo.MutationResult<Types.FlagCleanupPromptMutation>;
export type FlagCleanupPromptMutationOptions = Apollo.BaseMutationOptions<
  Types.FlagCleanupPromptMutation,
  Types.FlagCleanupPromptMutationVariables
>;
export const PricingConciergePromptDocument = gql`
  mutation PricingConciergePrompt($input: PricingConciergePromptInput!) {
    pricingConciergePrompt(input: $input) {
      conversation_id
      text
      turn
      is_final
    }
  }
`;
export type PricingConciergePromptMutationFn = Apollo.MutationFunction<
  Types.PricingConciergePromptMutation,
  Types.PricingConciergePromptMutationVariables
>;

/**
 * __usePricingConciergePromptMutation__
 *
 * To run a mutation, you first call `usePricingConciergePromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePricingConciergePromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pricingConciergePromptMutation, { data, loading, error }] = usePricingConciergePromptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePricingConciergePromptMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.PricingConciergePromptMutation,
    Types.PricingConciergePromptMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.PricingConciergePromptMutation, Types.PricingConciergePromptMutationVariables>(
    PricingConciergePromptDocument,
    options,
  );
}
export type PricingConciergePromptMutationHookResult = ReturnType<typeof usePricingConciergePromptMutation>;
export type PricingConciergePromptMutationResult = Apollo.MutationResult<Types.PricingConciergePromptMutation>;
export type PricingConciergePromptMutationOptions = Apollo.BaseMutationOptions<
  Types.PricingConciergePromptMutation,
  Types.PricingConciergePromptMutationVariables
>;
export const StopAgentDocument = gql`
  mutation StopAgent($conversation_id: StringID!) {
    stopAgent(conversation_id: $conversation_id)
  }
`;
export type StopAgentMutationFn = Apollo.MutationFunction<Types.StopAgentMutation, Types.StopAgentMutationVariables>;

/**
 * __useStopAgentMutation__
 *
 * To run a mutation, you first call `useStopAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopAgentMutation, { data, loading, error }] = useStopAgentMutation({
 *   variables: {
 *      conversation_id: // value for 'conversation_id'
 *   },
 * });
 */
export function useStopAgentMutation(
  baseOptions?: Apollo.MutationHookOptions<Types.StopAgentMutation, Types.StopAgentMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.StopAgentMutation, Types.StopAgentMutationVariables>(StopAgentDocument, options);
}
export type StopAgentMutationHookResult = ReturnType<typeof useStopAgentMutation>;
export type StopAgentMutationResult = Apollo.MutationResult<Types.StopAgentMutation>;
export type StopAgentMutationOptions = Apollo.BaseMutationOptions<
  Types.StopAgentMutation,
  Types.StopAgentMutationVariables
>;
export const UpsertVegaSlackConfigurationDocument = gql`
  mutation UpsertVegaSlackConfiguration($input: VegaSlackConfigurationInput!) {
    upsertVegaSlackConfiguration(input: $input) {
      id
      admin_id
      permission_mode
      investigation_prompt
      investigation_project_id
      investigation_repositories
    }
  }
`;
export type UpsertVegaSlackConfigurationMutationFn = Apollo.MutationFunction<
  Types.UpsertVegaSlackConfigurationMutation,
  Types.UpsertVegaSlackConfigurationMutationVariables
>;

/**
 * __useUpsertVegaSlackConfigurationMutation__
 *
 * To run a mutation, you first call `useUpsertVegaSlackConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertVegaSlackConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertVegaSlackConfigurationMutation, { data, loading, error }] = useUpsertVegaSlackConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertVegaSlackConfigurationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpsertVegaSlackConfigurationMutation,
    Types.UpsertVegaSlackConfigurationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpsertVegaSlackConfigurationMutation,
    Types.UpsertVegaSlackConfigurationMutationVariables
  >(UpsertVegaSlackConfigurationDocument, options);
}
export type UpsertVegaSlackConfigurationMutationHookResult = ReturnType<typeof useUpsertVegaSlackConfigurationMutation>;
export type UpsertVegaSlackConfigurationMutationResult =
  Apollo.MutationResult<Types.UpsertVegaSlackConfigurationMutation>;
export type UpsertVegaSlackConfigurationMutationOptions = Apollo.BaseMutationOptions<
  Types.UpsertVegaSlackConfigurationMutation,
  Types.UpsertVegaSlackConfigurationMutationVariables
>;
export const UpsertVegaProjectConfigurationDocument = gql`
  mutation UpsertVegaProjectConfiguration($input: VegaProjectConfigurationInput!) {
    upsertVegaProjectConfiguration(input: $input) {
      id
      project_id
      pull_request_title_prefix
      pull_request_bot_identity_workflows
    }
  }
`;
export type UpsertVegaProjectConfigurationMutationFn = Apollo.MutationFunction<
  Types.UpsertVegaProjectConfigurationMutation,
  Types.UpsertVegaProjectConfigurationMutationVariables
>;

/**
 * __useUpsertVegaProjectConfigurationMutation__
 *
 * To run a mutation, you first call `useUpsertVegaProjectConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertVegaProjectConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertVegaProjectConfigurationMutation, { data, loading, error }] = useUpsertVegaProjectConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertVegaProjectConfigurationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpsertVegaProjectConfigurationMutation,
    Types.UpsertVegaProjectConfigurationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpsertVegaProjectConfigurationMutation,
    Types.UpsertVegaProjectConfigurationMutationVariables
  >(UpsertVegaProjectConfigurationDocument, options);
}
export type UpsertVegaProjectConfigurationMutationHookResult = ReturnType<
  typeof useUpsertVegaProjectConfigurationMutation
>;
export type UpsertVegaProjectConfigurationMutationResult =
  Apollo.MutationResult<Types.UpsertVegaProjectConfigurationMutation>;
export type UpsertVegaProjectConfigurationMutationOptions = Apollo.BaseMutationOptions<
  Types.UpsertVegaProjectConfigurationMutation,
  Types.UpsertVegaProjectConfigurationMutationVariables
>;
export const CreateQueryFilterRuleDocument = gql`
  mutation CreateQueryFilterRule($input: CreateQueryFilterRuleInput!) {
    createQueryFilterRule(input: $input) {
      id
      rule_name
      is_rule_enabled
      product_type
      project_id
      query
      filter_operation
      filter_operation_rate
      attributes
      created_at
      updated_at
    }
  }
`;
export type CreateQueryFilterRuleMutationFn = Apollo.MutationFunction<
  Types.CreateQueryFilterRuleMutation,
  Types.CreateQueryFilterRuleMutationVariables
>;

/**
 * __useCreateQueryFilterRuleMutation__
 *
 * To run a mutation, you first call `useCreateQueryFilterRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQueryFilterRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQueryFilterRuleMutation, { data, loading, error }] = useCreateQueryFilterRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateQueryFilterRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateQueryFilterRuleMutation,
    Types.CreateQueryFilterRuleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.CreateQueryFilterRuleMutation, Types.CreateQueryFilterRuleMutationVariables>(
    CreateQueryFilterRuleDocument,
    options,
  );
}
export type CreateQueryFilterRuleMutationHookResult = ReturnType<typeof useCreateQueryFilterRuleMutation>;
export type CreateQueryFilterRuleMutationResult = Apollo.MutationResult<Types.CreateQueryFilterRuleMutation>;
export type CreateQueryFilterRuleMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateQueryFilterRuleMutation,
  Types.CreateQueryFilterRuleMutationVariables
>;
export const UpdateQueryFilterRuleDocument = gql`
  mutation UpdateQueryFilterRule($input: UpdateQueryFilterRuleInput!) {
    updateQueryFilterRule(input: $input) {
      id
      rule_name
      is_rule_enabled
      product_type
      project_id
      query
      filter_operation
      filter_operation_rate
      attributes
      created_at
      updated_at
    }
  }
`;
export type UpdateQueryFilterRuleMutationFn = Apollo.MutationFunction<
  Types.UpdateQueryFilterRuleMutation,
  Types.UpdateQueryFilterRuleMutationVariables
>;

/**
 * __useUpdateQueryFilterRuleMutation__
 *
 * To run a mutation, you first call `useUpdateQueryFilterRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQueryFilterRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQueryFilterRuleMutation, { data, loading, error }] = useUpdateQueryFilterRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQueryFilterRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateQueryFilterRuleMutation,
    Types.UpdateQueryFilterRuleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.UpdateQueryFilterRuleMutation, Types.UpdateQueryFilterRuleMutationVariables>(
    UpdateQueryFilterRuleDocument,
    options,
  );
}
export type UpdateQueryFilterRuleMutationHookResult = ReturnType<typeof useUpdateQueryFilterRuleMutation>;
export type UpdateQueryFilterRuleMutationResult = Apollo.MutationResult<Types.UpdateQueryFilterRuleMutation>;
export type UpdateQueryFilterRuleMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateQueryFilterRuleMutation,
  Types.UpdateQueryFilterRuleMutationVariables
>;
export const DeleteQueryFilterRuleDocument = gql`
  mutation DeleteQueryFilterRule($input: DeleteQueryFilterRuleInput!) {
    deleteQueryFilterRule(input: $input)
  }
`;
export type DeleteQueryFilterRuleMutationFn = Apollo.MutationFunction<
  Types.DeleteQueryFilterRuleMutation,
  Types.DeleteQueryFilterRuleMutationVariables
>;

/**
 * __useDeleteQueryFilterRuleMutation__
 *
 * To run a mutation, you first call `useDeleteQueryFilterRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQueryFilterRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQueryFilterRuleMutation, { data, loading, error }] = useDeleteQueryFilterRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteQueryFilterRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeleteQueryFilterRuleMutation,
    Types.DeleteQueryFilterRuleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.DeleteQueryFilterRuleMutation, Types.DeleteQueryFilterRuleMutationVariables>(
    DeleteQueryFilterRuleDocument,
    options,
  );
}
export type DeleteQueryFilterRuleMutationHookResult = ReturnType<typeof useDeleteQueryFilterRuleMutation>;
export type DeleteQueryFilterRuleMutationResult = Apollo.MutationResult<Types.DeleteQueryFilterRuleMutation>;
export type DeleteQueryFilterRuleMutationOptions = Apollo.BaseMutationOptions<
  Types.DeleteQueryFilterRuleMutation,
  Types.DeleteQueryFilterRuleMutationVariables
>;
export const UpdateFilterSettingsDocument = gql`
  mutation UpdateFilterSettings($input: UpdateFilterSettingsInput!) {
    updateFilterSettings(input: $input) {
      filter_rules {
        error_filter_rules_order
        log_filter_rules_order
        metric_filter_rules_order
        session_filter_rules_order
        trace_filter_rules_order
      }
      sampling {
        session_sampling_rate
        error_sampling_rate
        log_sampling_rate
        trace_sampling_rate
        metric_sampling_rate
        session_minute_rate_limit
        error_minute_rate_limit
        log_minute_rate_limit
        trace_minute_rate_limit
        metric_minute_rate_limit
        session_exclusion_query
        error_exclusion_query
        log_exclusion_query
        trace_exclusion_query
        metric_exclusion_query
      }
    }
  }
`;
export type UpdateFilterSettingsMutationFn = Apollo.MutationFunction<
  Types.UpdateFilterSettingsMutation,
  Types.UpdateFilterSettingsMutationVariables
>;

/**
 * __useUpdateFilterSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateFilterSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFilterSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFilterSettingsMutation, { data, loading, error }] = useUpdateFilterSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFilterSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateFilterSettingsMutation,
    Types.UpdateFilterSettingsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.UpdateFilterSettingsMutation, Types.UpdateFilterSettingsMutationVariables>(
    UpdateFilterSettingsDocument,
    options,
  );
}
export type UpdateFilterSettingsMutationHookResult = ReturnType<typeof useUpdateFilterSettingsMutation>;
export type UpdateFilterSettingsMutationResult = Apollo.MutationResult<Types.UpdateFilterSettingsMutation>;
export type UpdateFilterSettingsMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateFilterSettingsMutation,
  Types.UpdateFilterSettingsMutationVariables
>;
export const ShareConversationDocument = gql`
  mutation ShareConversation($project_id: StringID!, $conversation_id: StringID!) {
    shareConversation(project_id: $project_id, conversation_id: $conversation_id)
  }
`;
export type ShareConversationMutationFn = Apollo.MutationFunction<
  Types.ShareConversationMutation,
  Types.ShareConversationMutationVariables
>;

/**
 * __useShareConversationMutation__
 *
 * To run a mutation, you first call `useShareConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareConversationMutation, { data, loading, error }] = useShareConversationMutation({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      conversation_id: // value for 'conversation_id'
 *   },
 * });
 */
export function useShareConversationMutation(
  baseOptions?: Apollo.MutationHookOptions<Types.ShareConversationMutation, Types.ShareConversationMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.ShareConversationMutation, Types.ShareConversationMutationVariables>(
    ShareConversationDocument,
    options,
  );
}
export type ShareConversationMutationHookResult = ReturnType<typeof useShareConversationMutation>;
export type ShareConversationMutationResult = Apollo.MutationResult<Types.ShareConversationMutation>;
export type ShareConversationMutationOptions = Apollo.BaseMutationOptions<
  Types.ShareConversationMutation,
  Types.ShareConversationMutationVariables
>;
export const TagConversationDocument = gql`
  mutation TagConversation($project_id: StringID!, $conversation_id: StringID!, $key: String!, $value: String!) {
    tagConversation(project_id: $project_id, conversation_id: $conversation_id, key: $key, value: $value)
  }
`;
export type TagConversationMutationFn = Apollo.MutationFunction<
  Types.TagConversationMutation,
  Types.TagConversationMutationVariables
>;

/**
 * __useTagConversationMutation__
 *
 * To run a mutation, you first call `useTagConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagConversationMutation, { data, loading, error }] = useTagConversationMutation({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      conversation_id: // value for 'conversation_id'
 *      key: // value for 'key'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useTagConversationMutation(
  baseOptions?: Apollo.MutationHookOptions<Types.TagConversationMutation, Types.TagConversationMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.TagConversationMutation, Types.TagConversationMutationVariables>(
    TagConversationDocument,
    options,
  );
}
export type TagConversationMutationHookResult = ReturnType<typeof useTagConversationMutation>;
export type TagConversationMutationResult = Apollo.MutationResult<Types.TagConversationMutation>;
export type TagConversationMutationOptions = Apollo.BaseMutationOptions<
  Types.TagConversationMutation,
  Types.TagConversationMutationVariables
>;
export const SignAiTermsRecordDocument = gql`
  mutation SignAiTermsRecord($enabled: Boolean!) {
    signAiTermsRecord(enabled: $enabled)
  }
`;
export type SignAiTermsRecordMutationFn = Apollo.MutationFunction<
  Types.SignAiTermsRecordMutation,
  Types.SignAiTermsRecordMutationVariables
>;

/**
 * __useSignAiTermsRecordMutation__
 *
 * To run a mutation, you first call `useSignAiTermsRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignAiTermsRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signAiTermsRecordMutation, { data, loading, error }] = useSignAiTermsRecordMutation({
 *   variables: {
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSignAiTermsRecordMutation(
  baseOptions?: Apollo.MutationHookOptions<Types.SignAiTermsRecordMutation, Types.SignAiTermsRecordMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.SignAiTermsRecordMutation, Types.SignAiTermsRecordMutationVariables>(
    SignAiTermsRecordDocument,
    options,
  );
}
export type SignAiTermsRecordMutationHookResult = ReturnType<typeof useSignAiTermsRecordMutation>;
export type SignAiTermsRecordMutationResult = Apollo.MutationResult<Types.SignAiTermsRecordMutation>;
export type SignAiTermsRecordMutationOptions = Apollo.BaseMutationOptions<
  Types.SignAiTermsRecordMutation,
  Types.SignAiTermsRecordMutationVariables
>;
export const CreateJiraIssueForAlertDocument = gql`
  mutation CreateJiraIssueForAlert($alertID: ID!, $input: JiraIssueCreateInput!) {
    createJiraIssueForAlert(alertID: $alertID, input: $input) {
      id
      issueKey
      issueUrl
      createdBy
      createdAt
    }
  }
`;
export type CreateJiraIssueForAlertMutationFn = Apollo.MutationFunction<
  Types.CreateJiraIssueForAlertMutation,
  Types.CreateJiraIssueForAlertMutationVariables
>;

/**
 * __useCreateJiraIssueForAlertMutation__
 *
 * To run a mutation, you first call `useCreateJiraIssueForAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJiraIssueForAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJiraIssueForAlertMutation, { data, loading, error }] = useCreateJiraIssueForAlertMutation({
 *   variables: {
 *      alertID: // value for 'alertID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateJiraIssueForAlertMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateJiraIssueForAlertMutation,
    Types.CreateJiraIssueForAlertMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.CreateJiraIssueForAlertMutation, Types.CreateJiraIssueForAlertMutationVariables>(
    CreateJiraIssueForAlertDocument,
    options,
  );
}
export type CreateJiraIssueForAlertMutationHookResult = ReturnType<typeof useCreateJiraIssueForAlertMutation>;
export type CreateJiraIssueForAlertMutationResult = Apollo.MutationResult<Types.CreateJiraIssueForAlertMutation>;
export type CreateJiraIssueForAlertMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateJiraIssueForAlertMutation,
  Types.CreateJiraIssueForAlertMutationVariables
>;
export const CreateJiraIssueForErrorGroupDocument = gql`
  mutation CreateJiraIssueForErrorGroup($errorGroupSecureID: String!, $input: JiraIssueCreateInput!) {
    createJiraIssueForErrorGroup(errorGroupSecureID: $errorGroupSecureID, input: $input) {
      id
      issueKey
      issueUrl
      createdBy
      createdAt
    }
  }
`;
export type CreateJiraIssueForErrorGroupMutationFn = Apollo.MutationFunction<
  Types.CreateJiraIssueForErrorGroupMutation,
  Types.CreateJiraIssueForErrorGroupMutationVariables
>;

/**
 * __useCreateJiraIssueForErrorGroupMutation__
 *
 * To run a mutation, you first call `useCreateJiraIssueForErrorGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJiraIssueForErrorGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJiraIssueForErrorGroupMutation, { data, loading, error }] = useCreateJiraIssueForErrorGroupMutation({
 *   variables: {
 *      errorGroupSecureID: // value for 'errorGroupSecureID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateJiraIssueForErrorGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateJiraIssueForErrorGroupMutation,
    Types.CreateJiraIssueForErrorGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.CreateJiraIssueForErrorGroupMutation,
    Types.CreateJiraIssueForErrorGroupMutationVariables
  >(CreateJiraIssueForErrorGroupDocument, options);
}
export type CreateJiraIssueForErrorGroupMutationHookResult = ReturnType<typeof useCreateJiraIssueForErrorGroupMutation>;
export type CreateJiraIssueForErrorGroupMutationResult =
  Apollo.MutationResult<Types.CreateJiraIssueForErrorGroupMutation>;
export type CreateJiraIssueForErrorGroupMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateJiraIssueForErrorGroupMutation,
  Types.CreateJiraIssueForErrorGroupMutationVariables
>;
export const CreateJiraIssueForSessionDocument = gql`
  mutation CreateJiraIssueForSession($sessionSecureID: String!, $input: JiraIssueCreateInput!) {
    createJiraIssueForSession(sessionSecureID: $sessionSecureID, input: $input) {
      id
      issueKey
      issueUrl
      createdBy
      createdAt
    }
  }
`;
export type CreateJiraIssueForSessionMutationFn = Apollo.MutationFunction<
  Types.CreateJiraIssueForSessionMutation,
  Types.CreateJiraIssueForSessionMutationVariables
>;

/**
 * __useCreateJiraIssueForSessionMutation__
 *
 * To run a mutation, you first call `useCreateJiraIssueForSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJiraIssueForSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJiraIssueForSessionMutation, { data, loading, error }] = useCreateJiraIssueForSessionMutation({
 *   variables: {
 *      sessionSecureID: // value for 'sessionSecureID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateJiraIssueForSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateJiraIssueForSessionMutation,
    Types.CreateJiraIssueForSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.CreateJiraIssueForSessionMutation, Types.CreateJiraIssueForSessionMutationVariables>(
    CreateJiraIssueForSessionDocument,
    options,
  );
}
export type CreateJiraIssueForSessionMutationHookResult = ReturnType<typeof useCreateJiraIssueForSessionMutation>;
export type CreateJiraIssueForSessionMutationResult = Apollo.MutationResult<Types.CreateJiraIssueForSessionMutation>;
export type CreateJiraIssueForSessionMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateJiraIssueForSessionMutation,
  Types.CreateJiraIssueForSessionMutationVariables
>;
export const ExperimentHypothesisBuilderAssistDocument = gql`
  mutation ExperimentHypothesisBuilderAssist($input: ExperimentHypothesisBuilderAssistInput!) {
    experiment_hypothesis_builder_assist(input: $input) {
      conversation_id
      text
      turn
      is_final
    }
  }
`;
export type ExperimentHypothesisBuilderAssistMutationFn = Apollo.MutationFunction<
  Types.ExperimentHypothesisBuilderAssistMutation,
  Types.ExperimentHypothesisBuilderAssistMutationVariables
>;

/**
 * __useExperimentHypothesisBuilderAssistMutation__
 *
 * To run a mutation, you first call `useExperimentHypothesisBuilderAssistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExperimentHypothesisBuilderAssistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [experimentHypothesisBuilderAssistMutation, { data, loading, error }] = useExperimentHypothesisBuilderAssistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExperimentHypothesisBuilderAssistMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.ExperimentHypothesisBuilderAssistMutation,
    Types.ExperimentHypothesisBuilderAssistMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.ExperimentHypothesisBuilderAssistMutation,
    Types.ExperimentHypothesisBuilderAssistMutationVariables
  >(ExperimentHypothesisBuilderAssistDocument, options);
}
export type ExperimentHypothesisBuilderAssistMutationHookResult = ReturnType<
  typeof useExperimentHypothesisBuilderAssistMutation
>;
export type ExperimentHypothesisBuilderAssistMutationResult =
  Apollo.MutationResult<Types.ExperimentHypothesisBuilderAssistMutation>;
export type ExperimentHypothesisBuilderAssistMutationOptions = Apollo.BaseMutationOptions<
  Types.ExperimentHypothesisBuilderAssistMutation,
  Types.ExperimentHypothesisBuilderAssistMutationVariables
>;
export const EditServiceSettingsDocument = gql`
  mutation EditServiceSettings($service_id: Int64ID!, $project_id: StringID!, $input: EditServiceSettingsInput!) {
    editServiceSettings(service_id: $service_id, project_id: $project_id, input: $input) {
      serviceID
      projectID
      rootSpanFilter
    }
  }
`;
export type EditServiceSettingsMutationFn = Apollo.MutationFunction<
  Types.EditServiceSettingsMutation,
  Types.EditServiceSettingsMutationVariables
>;

/**
 * __useEditServiceSettingsMutation__
 *
 * To run a mutation, you first call `useEditServiceSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditServiceSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editServiceSettingsMutation, { data, loading, error }] = useEditServiceSettingsMutation({
 *   variables: {
 *      service_id: // value for 'service_id'
 *      project_id: // value for 'project_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditServiceSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.EditServiceSettingsMutation,
    Types.EditServiceSettingsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Types.EditServiceSettingsMutation, Types.EditServiceSettingsMutationVariables>(
    EditServiceSettingsDocument,
    options,
  );
}
export type EditServiceSettingsMutationHookResult = ReturnType<typeof useEditServiceSettingsMutation>;
export type EditServiceSettingsMutationResult = Apollo.MutationResult<Types.EditServiceSettingsMutation>;
export type EditServiceSettingsMutationOptions = Apollo.BaseMutationOptions<
  Types.EditServiceSettingsMutation,
  Types.EditServiceSettingsMutationVariables
>;
export const GetNetworkHistogramDocument = gql`
  query GetNetworkHistogram($project_id: ID!, $params: NetworkHistogramParamsInput!) {
    network_histogram(project_id: $project_id, params: $params) {
      buckets {
        category
        count
      }
    }
  }
`;

/**
 * __useGetNetworkHistogramQuery__
 *
 * To run a query within a React component, call `useGetNetworkHistogramQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNetworkHistogramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNetworkHistogramQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetNetworkHistogramQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetNetworkHistogramQuery, Types.GetNetworkHistogramQueryVariables> &
    ({ variables: Types.GetNetworkHistogramQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetNetworkHistogramQuery, Types.GetNetworkHistogramQueryVariables>(
    GetNetworkHistogramDocument,
    options,
  );
}
export function useGetNetworkHistogramLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetNetworkHistogramQuery, Types.GetNetworkHistogramQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetNetworkHistogramQuery, Types.GetNetworkHistogramQueryVariables>(
    GetNetworkHistogramDocument,
    options,
  );
}
export function useGetNetworkHistogramSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetNetworkHistogramQuery, Types.GetNetworkHistogramQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetNetworkHistogramQuery, Types.GetNetworkHistogramQueryVariables>(
    GetNetworkHistogramDocument,
    options,
  );
}
export type GetNetworkHistogramQueryHookResult = ReturnType<typeof useGetNetworkHistogramQuery>;
export type GetNetworkHistogramLazyQueryHookResult = ReturnType<typeof useGetNetworkHistogramLazyQuery>;
export type GetNetworkHistogramSuspenseQueryHookResult = ReturnType<typeof useGetNetworkHistogramSuspenseQuery>;
export type GetNetworkHistogramQueryResult = Apollo.QueryResult<
  Types.GetNetworkHistogramQuery,
  Types.GetNetworkHistogramQueryVariables
>;
export const GetSessionPayloadDocument = gql`
  query GetSessionPayload($session_secure_id: String!, $skip_events: Boolean!) {
    events(session_secure_id: $session_secure_id) @skip(if: $skip_events)
    errors(session_secure_id: $session_secure_id) {
      id
      error_group_secure_id
      event
      type
      url
      source
      stack_trace
      structured_stack_trace {
        fileName
        lineNumber
        functionName
        columnNumber
      }
      timestamp
      payload
      request_id
    }
    rage_clicks(session_secure_id: $session_secure_id) {
      start_timestamp
      end_timestamp
      total_clicks
    }
    session_comments(session_secure_id: $session_secure_id) {
      id
      timestamp
      session_id
      session_secure_id
      created_at
      updated_at
      project_id
      text
      author {
        id
        name
        email
        photo_url
      }
      x_coordinate
      y_coordinate
      type
      metadata
      tags
      attachments {
        id
        integration_type
        external_id
        title
      }
    }
  }
`;

/**
 * __useGetSessionPayloadQuery__
 *
 * To run a query within a React component, call `useGetSessionPayloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionPayloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionPayloadQuery({
 *   variables: {
 *      session_secure_id: // value for 'session_secure_id'
 *      skip_events: // value for 'skip_events'
 *   },
 * });
 */
export function useGetSessionPayloadQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetSessionPayloadQuery, Types.GetSessionPayloadQueryVariables> &
    ({ variables: Types.GetSessionPayloadQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetSessionPayloadQuery, Types.GetSessionPayloadQueryVariables>(
    GetSessionPayloadDocument,
    options,
  );
}
export function useGetSessionPayloadLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSessionPayloadQuery, Types.GetSessionPayloadQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetSessionPayloadQuery, Types.GetSessionPayloadQueryVariables>(
    GetSessionPayloadDocument,
    options,
  );
}
export function useGetSessionPayloadSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetSessionPayloadQuery, Types.GetSessionPayloadQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetSessionPayloadQuery, Types.GetSessionPayloadQueryVariables>(
    GetSessionPayloadDocument,
    options,
  );
}
export type GetSessionPayloadQueryHookResult = ReturnType<typeof useGetSessionPayloadQuery>;
export type GetSessionPayloadLazyQueryHookResult = ReturnType<typeof useGetSessionPayloadLazyQuery>;
export type GetSessionPayloadSuspenseQueryHookResult = ReturnType<typeof useGetSessionPayloadSuspenseQuery>;
export type GetSessionPayloadQueryResult = Apollo.QueryResult<
  Types.GetSessionPayloadQuery,
  Types.GetSessionPayloadQueryVariables
>;
export const GetEventChunkUrlDocument = gql`
  query GetEventChunkURL($secure_id: String!, $index: Int!) {
    event_chunk_url(secure_id: $secure_id, index: $index)
  }
`;

/**
 * __useGetEventChunkUrlQuery__
 *
 * To run a query within a React component, call `useGetEventChunkUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventChunkUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventChunkUrlQuery({
 *   variables: {
 *      secure_id: // value for 'secure_id'
 *      index: // value for 'index'
 *   },
 * });
 */
export function useGetEventChunkUrlQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetEventChunkUrlQuery, Types.GetEventChunkUrlQueryVariables> &
    ({ variables: Types.GetEventChunkUrlQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetEventChunkUrlQuery, Types.GetEventChunkUrlQueryVariables>(
    GetEventChunkUrlDocument,
    options,
  );
}
export function useGetEventChunkUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetEventChunkUrlQuery, Types.GetEventChunkUrlQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetEventChunkUrlQuery, Types.GetEventChunkUrlQueryVariables>(
    GetEventChunkUrlDocument,
    options,
  );
}
export function useGetEventChunkUrlSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetEventChunkUrlQuery, Types.GetEventChunkUrlQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetEventChunkUrlQuery, Types.GetEventChunkUrlQueryVariables>(
    GetEventChunkUrlDocument,
    options,
  );
}
export type GetEventChunkUrlQueryHookResult = ReturnType<typeof useGetEventChunkUrlQuery>;
export type GetEventChunkUrlLazyQueryHookResult = ReturnType<typeof useGetEventChunkUrlLazyQuery>;
export type GetEventChunkUrlSuspenseQueryHookResult = ReturnType<typeof useGetEventChunkUrlSuspenseQuery>;
export type GetEventChunkUrlQueryResult = Apollo.QueryResult<
  Types.GetEventChunkUrlQuery,
  Types.GetEventChunkUrlQueryVariables
>;
export const GetEventChunksDocument = gql`
  query GetEventChunks($secure_id: String!) {
    event_chunks(secure_id: $secure_id) {
      session_id
      chunk_index
      timestamp
    }
  }
`;

/**
 * __useGetEventChunksQuery__
 *
 * To run a query within a React component, call `useGetEventChunksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventChunksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventChunksQuery({
 *   variables: {
 *      secure_id: // value for 'secure_id'
 *   },
 * });
 */
export function useGetEventChunksQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetEventChunksQuery, Types.GetEventChunksQueryVariables> &
    ({ variables: Types.GetEventChunksQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetEventChunksQuery, Types.GetEventChunksQueryVariables>(
    GetEventChunksDocument,
    options,
  );
}
export function useGetEventChunksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetEventChunksQuery, Types.GetEventChunksQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetEventChunksQuery, Types.GetEventChunksQueryVariables>(
    GetEventChunksDocument,
    options,
  );
}
export function useGetEventChunksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetEventChunksQuery, Types.GetEventChunksQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetEventChunksQuery, Types.GetEventChunksQueryVariables>(
    GetEventChunksDocument,
    options,
  );
}
export type GetEventChunksQueryHookResult = ReturnType<typeof useGetEventChunksQuery>;
export type GetEventChunksLazyQueryHookResult = ReturnType<typeof useGetEventChunksLazyQuery>;
export type GetEventChunksSuspenseQueryHookResult = ReturnType<typeof useGetEventChunksSuspenseQuery>;
export type GetEventChunksQueryResult = Apollo.QueryResult<
  Types.GetEventChunksQuery,
  Types.GetEventChunksQueryVariables
>;
export const GetSessionDocument = gql`
  query GetSession($secure_id: String!) {
    session(secure_id: $secure_id) {
      secure_id
      ld_project_slug
      os_name
      os_version
      browser_name
      browser_version
      environment
      service_name
      app_version
      ip
      city
      state
      country
      postal
      fingerprint
      created_at
      payload_updated_at
      language
      user_object
      user_properties
      identifier
      identified
      client_id
      starred
      viewed
      enable_strict_privacy
      privacy_setting
      enable_recording_network_contents
      field_group
      fields {
        name
        value
        type
      }
      object_storage_enabled
      payload_size
      processed
      excluded
      excluded_reason
      has_rage_clicks
      has_errors
      first_time
      within_billing_quota
      client_version
      firstload_version
      client_config
      is_public
      event_counts
      direct_download_url
      resources_url
      web_socket_events_url
      timeline_indicators_url
      deviceMemory
      last_user_interaction_time
      length
      active_length
      chunked
      jira_issue_links {
        id
        issueKey
        issueUrl
        createdAt
      }
    }
  }
`;

/**
 * __useGetSessionQuery__
 *
 * To run a query within a React component, call `useGetSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionQuery({
 *   variables: {
 *      secure_id: // value for 'secure_id'
 *   },
 * });
 */
export function useGetSessionQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetSessionQuery, Types.GetSessionQueryVariables> &
    ({ variables: Types.GetSessionQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetSessionQuery, Types.GetSessionQueryVariables>(GetSessionDocument, options);
}
export function useGetSessionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSessionQuery, Types.GetSessionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetSessionQuery, Types.GetSessionQueryVariables>(GetSessionDocument, options);
}
export function useGetSessionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetSessionQuery, Types.GetSessionQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetSessionQuery, Types.GetSessionQueryVariables>(GetSessionDocument, options);
}
export type GetSessionQueryHookResult = ReturnType<typeof useGetSessionQuery>;
export type GetSessionLazyQueryHookResult = ReturnType<typeof useGetSessionLazyQuery>;
export type GetSessionSuspenseQueryHookResult = ReturnType<typeof useGetSessionSuspenseQuery>;
export type GetSessionQueryResult = Apollo.QueryResult<Types.GetSessionQuery, Types.GetSessionQueryVariables>;
export const GetWorkspaceAdminsByProjectIdDocument = gql`
  query GetWorkspaceAdminsByProjectId($project_id: ID!) {
    admins: workspace_admins_by_project_id(project_id: $project_id) {
      workspaceId
      admin {
        id
        name
        email
        photo_url
      }
      role
      projectIds
    }
  }
`;

/**
 * __useGetWorkspaceAdminsByProjectIdQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceAdminsByProjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceAdminsByProjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceAdminsByProjectIdQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *   },
 * });
 */
export function useGetWorkspaceAdminsByProjectIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetWorkspaceAdminsByProjectIdQuery,
    Types.GetWorkspaceAdminsByProjectIdQueryVariables
  > &
    ({ variables: Types.GetWorkspaceAdminsByProjectIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetWorkspaceAdminsByProjectIdQuery, Types.GetWorkspaceAdminsByProjectIdQueryVariables>(
    GetWorkspaceAdminsByProjectIdDocument,
    options,
  );
}
export function useGetWorkspaceAdminsByProjectIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetWorkspaceAdminsByProjectIdQuery,
    Types.GetWorkspaceAdminsByProjectIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetWorkspaceAdminsByProjectIdQuery,
    Types.GetWorkspaceAdminsByProjectIdQueryVariables
  >(GetWorkspaceAdminsByProjectIdDocument, options);
}
export function useGetWorkspaceAdminsByProjectIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types.GetWorkspaceAdminsByProjectIdQuery,
        Types.GetWorkspaceAdminsByProjectIdQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GetWorkspaceAdminsByProjectIdQuery,
    Types.GetWorkspaceAdminsByProjectIdQueryVariables
  >(GetWorkspaceAdminsByProjectIdDocument, options);
}
export type GetWorkspaceAdminsByProjectIdQueryHookResult = ReturnType<typeof useGetWorkspaceAdminsByProjectIdQuery>;
export type GetWorkspaceAdminsByProjectIdLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceAdminsByProjectIdLazyQuery
>;
export type GetWorkspaceAdminsByProjectIdSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkspaceAdminsByProjectIdSuspenseQuery
>;
export type GetWorkspaceAdminsByProjectIdQueryResult = Apollo.QueryResult<
  Types.GetWorkspaceAdminsByProjectIdQuery,
  Types.GetWorkspaceAdminsByProjectIdQueryVariables
>;
export const GetWorkspaceAdminsDocument = gql`
  query GetWorkspaceAdmins($workspace_id: ID!) {
    admins: workspace_admins(workspace_id: $workspace_id) {
      workspaceId
      admin {
        id
        name
        email
        photo_url
      }
      role
      projectIds
    }
    workspace(id: $workspace_id) {
      id
      name
      allowed_auto_join_email_origins
    }
    workspace_invite_links(workspace_id: $workspace_id) {
      id
      invitee_email
      invitee_role
      expiration_date
      secret
    }
  }
`;

/**
 * __useGetWorkspaceAdminsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceAdminsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceAdminsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceAdminsQuery({
 *   variables: {
 *      workspace_id: // value for 'workspace_id'
 *   },
 * });
 */
export function useGetWorkspaceAdminsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetWorkspaceAdminsQuery, Types.GetWorkspaceAdminsQueryVariables> &
    ({ variables: Types.GetWorkspaceAdminsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetWorkspaceAdminsQuery, Types.GetWorkspaceAdminsQueryVariables>(
    GetWorkspaceAdminsDocument,
    options,
  );
}
export function useGetWorkspaceAdminsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetWorkspaceAdminsQuery, Types.GetWorkspaceAdminsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetWorkspaceAdminsQuery, Types.GetWorkspaceAdminsQueryVariables>(
    GetWorkspaceAdminsDocument,
    options,
  );
}
export function useGetWorkspaceAdminsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetWorkspaceAdminsQuery, Types.GetWorkspaceAdminsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetWorkspaceAdminsQuery, Types.GetWorkspaceAdminsQueryVariables>(
    GetWorkspaceAdminsDocument,
    options,
  );
}
export type GetWorkspaceAdminsQueryHookResult = ReturnType<typeof useGetWorkspaceAdminsQuery>;
export type GetWorkspaceAdminsLazyQueryHookResult = ReturnType<typeof useGetWorkspaceAdminsLazyQuery>;
export type GetWorkspaceAdminsSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceAdminsSuspenseQuery>;
export type GetWorkspaceAdminsQueryResult = Apollo.QueryResult<
  Types.GetWorkspaceAdminsQuery,
  Types.GetWorkspaceAdminsQueryVariables
>;
export const GetSessionInsightDocument = gql`
  query GetSessionInsight($secure_id: String!) {
    session_insight(secure_id: $secure_id) {
      id
      insight
    }
  }
`;

/**
 * __useGetSessionInsightQuery__
 *
 * To run a query within a React component, call `useGetSessionInsightQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionInsightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionInsightQuery({
 *   variables: {
 *      secure_id: // value for 'secure_id'
 *   },
 * });
 */
export function useGetSessionInsightQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetSessionInsightQuery, Types.GetSessionInsightQueryVariables> &
    ({ variables: Types.GetSessionInsightQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetSessionInsightQuery, Types.GetSessionInsightQueryVariables>(
    GetSessionInsightDocument,
    options,
  );
}
export function useGetSessionInsightLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSessionInsightQuery, Types.GetSessionInsightQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetSessionInsightQuery, Types.GetSessionInsightQueryVariables>(
    GetSessionInsightDocument,
    options,
  );
}
export function useGetSessionInsightSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetSessionInsightQuery, Types.GetSessionInsightQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetSessionInsightQuery, Types.GetSessionInsightQueryVariables>(
    GetSessionInsightDocument,
    options,
  );
}
export type GetSessionInsightQueryHookResult = ReturnType<typeof useGetSessionInsightQuery>;
export type GetSessionInsightLazyQueryHookResult = ReturnType<typeof useGetSessionInsightLazyQuery>;
export type GetSessionInsightSuspenseQueryHookResult = ReturnType<typeof useGetSessionInsightSuspenseQuery>;
export type GetSessionInsightQueryResult = Apollo.QueryResult<
  Types.GetSessionInsightQuery,
  Types.GetSessionInsightQueryVariables
>;
export const GetSessionExportsDocument = gql`
  query GetSessionExports($project_id: StringID!) {
    session_exports(project_id: $project_id) {
      created_at
      type
      url
      error
      secure_id
      identifier
      active_length
    }
  }
`;

/**
 * __useGetSessionExportsQuery__
 *
 * To run a query within a React component, call `useGetSessionExportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionExportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionExportsQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *   },
 * });
 */
export function useGetSessionExportsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetSessionExportsQuery, Types.GetSessionExportsQueryVariables> &
    ({ variables: Types.GetSessionExportsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetSessionExportsQuery, Types.GetSessionExportsQueryVariables>(
    GetSessionExportsDocument,
    options,
  );
}
export function useGetSessionExportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSessionExportsQuery, Types.GetSessionExportsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetSessionExportsQuery, Types.GetSessionExportsQueryVariables>(
    GetSessionExportsDocument,
    options,
  );
}
export function useGetSessionExportsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetSessionExportsQuery, Types.GetSessionExportsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetSessionExportsQuery, Types.GetSessionExportsQueryVariables>(
    GetSessionExportsDocument,
    options,
  );
}
export type GetSessionExportsQueryHookResult = ReturnType<typeof useGetSessionExportsQuery>;
export type GetSessionExportsLazyQueryHookResult = ReturnType<typeof useGetSessionExportsLazyQuery>;
export type GetSessionExportsSuspenseQueryHookResult = ReturnType<typeof useGetSessionExportsSuspenseQuery>;
export type GetSessionExportsQueryResult = Apollo.QueryResult<
  Types.GetSessionExportsQuery,
  Types.GetSessionExportsQueryVariables
>;
export const GetSessionCommentsDocument = gql`
  query GetSessionComments($session_secure_id: String!) {
    session_comments(session_secure_id: $session_secure_id) {
      id
      timestamp
      text
      author {
        email
      }
    }
  }
`;

/**
 * __useGetSessionCommentsQuery__
 *
 * To run a query within a React component, call `useGetSessionCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionCommentsQuery({
 *   variables: {
 *      session_secure_id: // value for 'session_secure_id'
 *   },
 * });
 */
export function useGetSessionCommentsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetSessionCommentsQuery, Types.GetSessionCommentsQueryVariables> &
    ({ variables: Types.GetSessionCommentsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetSessionCommentsQuery, Types.GetSessionCommentsQueryVariables>(
    GetSessionCommentsDocument,
    options,
  );
}
export function useGetSessionCommentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSessionCommentsQuery, Types.GetSessionCommentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetSessionCommentsQuery, Types.GetSessionCommentsQueryVariables>(
    GetSessionCommentsDocument,
    options,
  );
}
export function useGetSessionCommentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetSessionCommentsQuery, Types.GetSessionCommentsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetSessionCommentsQuery, Types.GetSessionCommentsQueryVariables>(
    GetSessionCommentsDocument,
    options,
  );
}
export type GetSessionCommentsQueryHookResult = ReturnType<typeof useGetSessionCommentsQuery>;
export type GetSessionCommentsLazyQueryHookResult = ReturnType<typeof useGetSessionCommentsLazyQuery>;
export type GetSessionCommentsSuspenseQueryHookResult = ReturnType<typeof useGetSessionCommentsSuspenseQuery>;
export type GetSessionCommentsQueryResult = Apollo.QueryResult<
  Types.GetSessionCommentsQuery,
  Types.GetSessionCommentsQueryVariables
>;
export const IsSessionPendingDocument = gql`
  query isSessionPending($session_secure_id: String!) {
    isSessionPending(session_secure_id: $session_secure_id)
  }
`;

/**
 * __useIsSessionPendingQuery__
 *
 * To run a query within a React component, call `useIsSessionPendingQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsSessionPendingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsSessionPendingQuery({
 *   variables: {
 *      session_secure_id: // value for 'session_secure_id'
 *   },
 * });
 */
export function useIsSessionPendingQuery(
  baseOptions: Apollo.QueryHookOptions<Types.IsSessionPendingQuery, Types.IsSessionPendingQueryVariables> &
    ({ variables: Types.IsSessionPendingQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.IsSessionPendingQuery, Types.IsSessionPendingQueryVariables>(
    IsSessionPendingDocument,
    options,
  );
}
export function useIsSessionPendingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.IsSessionPendingQuery, Types.IsSessionPendingQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.IsSessionPendingQuery, Types.IsSessionPendingQueryVariables>(
    IsSessionPendingDocument,
    options,
  );
}
export function useIsSessionPendingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.IsSessionPendingQuery, Types.IsSessionPendingQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.IsSessionPendingQuery, Types.IsSessionPendingQueryVariables>(
    IsSessionPendingDocument,
    options,
  );
}
export type IsSessionPendingQueryHookResult = ReturnType<typeof useIsSessionPendingQuery>;
export type IsSessionPendingLazyQueryHookResult = ReturnType<typeof useIsSessionPendingLazyQuery>;
export type IsSessionPendingSuspenseQueryHookResult = ReturnType<typeof useIsSessionPendingSuspenseQuery>;
export type IsSessionPendingQueryResult = Apollo.QueryResult<
  Types.IsSessionPendingQuery,
  Types.IsSessionPendingQueryVariables
>;
export const GetSessionIntervalsDocument = gql`
  query GetSessionIntervals($session_secure_id: String!) {
    session_intervals(session_secure_id: $session_secure_id) {
      start_time
      end_time
      active
      duration
    }
  }
`;

/**
 * __useGetSessionIntervalsQuery__
 *
 * To run a query within a React component, call `useGetSessionIntervalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionIntervalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionIntervalsQuery({
 *   variables: {
 *      session_secure_id: // value for 'session_secure_id'
 *   },
 * });
 */
export function useGetSessionIntervalsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetSessionIntervalsQuery, Types.GetSessionIntervalsQueryVariables> &
    ({ variables: Types.GetSessionIntervalsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetSessionIntervalsQuery, Types.GetSessionIntervalsQueryVariables>(
    GetSessionIntervalsDocument,
    options,
  );
}
export function useGetSessionIntervalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSessionIntervalsQuery, Types.GetSessionIntervalsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetSessionIntervalsQuery, Types.GetSessionIntervalsQueryVariables>(
    GetSessionIntervalsDocument,
    options,
  );
}
export function useGetSessionIntervalsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetSessionIntervalsQuery, Types.GetSessionIntervalsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetSessionIntervalsQuery, Types.GetSessionIntervalsQueryVariables>(
    GetSessionIntervalsDocument,
    options,
  );
}
export type GetSessionIntervalsQueryHookResult = ReturnType<typeof useGetSessionIntervalsQuery>;
export type GetSessionIntervalsLazyQueryHookResult = ReturnType<typeof useGetSessionIntervalsLazyQuery>;
export type GetSessionIntervalsSuspenseQueryHookResult = ReturnType<typeof useGetSessionIntervalsSuspenseQuery>;
export type GetSessionIntervalsQueryResult = Apollo.QueryResult<
  Types.GetSessionIntervalsQuery,
  Types.GetSessionIntervalsQueryVariables
>;
export const GetTimelineIndicatorEventsDocument = gql`
  query GetTimelineIndicatorEvents($session_secure_id: String!) {
    timeline_indicator_events(session_secure_id: $session_secure_id) {
      timestamp
      data
      type
      sid
    }
  }
`;

/**
 * __useGetTimelineIndicatorEventsQuery__
 *
 * To run a query within a React component, call `useGetTimelineIndicatorEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimelineIndicatorEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimelineIndicatorEventsQuery({
 *   variables: {
 *      session_secure_id: // value for 'session_secure_id'
 *   },
 * });
 */
export function useGetTimelineIndicatorEventsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetTimelineIndicatorEventsQuery,
    Types.GetTimelineIndicatorEventsQueryVariables
  > &
    ({ variables: Types.GetTimelineIndicatorEventsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetTimelineIndicatorEventsQuery, Types.GetTimelineIndicatorEventsQueryVariables>(
    GetTimelineIndicatorEventsDocument,
    options,
  );
}
export function useGetTimelineIndicatorEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetTimelineIndicatorEventsQuery,
    Types.GetTimelineIndicatorEventsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetTimelineIndicatorEventsQuery, Types.GetTimelineIndicatorEventsQueryVariables>(
    GetTimelineIndicatorEventsDocument,
    options,
  );
}
export function useGetTimelineIndicatorEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types.GetTimelineIndicatorEventsQuery,
        Types.GetTimelineIndicatorEventsQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetTimelineIndicatorEventsQuery, Types.GetTimelineIndicatorEventsQueryVariables>(
    GetTimelineIndicatorEventsDocument,
    options,
  );
}
export type GetTimelineIndicatorEventsQueryHookResult = ReturnType<typeof useGetTimelineIndicatorEventsQuery>;
export type GetTimelineIndicatorEventsLazyQueryHookResult = ReturnType<typeof useGetTimelineIndicatorEventsLazyQuery>;
export type GetTimelineIndicatorEventsSuspenseQueryHookResult = ReturnType<
  typeof useGetTimelineIndicatorEventsSuspenseQuery
>;
export type GetTimelineIndicatorEventsQueryResult = Apollo.QueryResult<
  Types.GetTimelineIndicatorEventsQuery,
  Types.GetTimelineIndicatorEventsQueryVariables
>;
export const GetSessionChunkPreviewFramesDocument = gql`
  query GetSessionChunkPreviewFrames($session_secure_id: String!, $timestamp_ms: Int!) {
    sessionChunkPreviewFrames(session_secure_id: $session_secure_id, timestamp_ms: $timestamp_ms) {
      chunk_index
      chunk_start_ms
      frame_interval_ms
      is_complete
      frames {
        ts_ms
        url
      }
    }
  }
`;

/**
 * __useGetSessionChunkPreviewFramesQuery__
 *
 * To run a query within a React component, call `useGetSessionChunkPreviewFramesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionChunkPreviewFramesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionChunkPreviewFramesQuery({
 *   variables: {
 *      session_secure_id: // value for 'session_secure_id'
 *      timestamp_ms: // value for 'timestamp_ms'
 *   },
 * });
 */
export function useGetSessionChunkPreviewFramesQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetSessionChunkPreviewFramesQuery,
    Types.GetSessionChunkPreviewFramesQueryVariables
  > &
    ({ variables: Types.GetSessionChunkPreviewFramesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetSessionChunkPreviewFramesQuery, Types.GetSessionChunkPreviewFramesQueryVariables>(
    GetSessionChunkPreviewFramesDocument,
    options,
  );
}
export function useGetSessionChunkPreviewFramesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetSessionChunkPreviewFramesQuery,
    Types.GetSessionChunkPreviewFramesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetSessionChunkPreviewFramesQuery, Types.GetSessionChunkPreviewFramesQueryVariables>(
    GetSessionChunkPreviewFramesDocument,
    options,
  );
}
export function useGetSessionChunkPreviewFramesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types.GetSessionChunkPreviewFramesQuery,
        Types.GetSessionChunkPreviewFramesQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GetSessionChunkPreviewFramesQuery,
    Types.GetSessionChunkPreviewFramesQueryVariables
  >(GetSessionChunkPreviewFramesDocument, options);
}
export type GetSessionChunkPreviewFramesQueryHookResult = ReturnType<typeof useGetSessionChunkPreviewFramesQuery>;
export type GetSessionChunkPreviewFramesLazyQueryHookResult = ReturnType<
  typeof useGetSessionChunkPreviewFramesLazyQuery
>;
export type GetSessionChunkPreviewFramesSuspenseQueryHookResult = ReturnType<
  typeof useGetSessionChunkPreviewFramesSuspenseQuery
>;
export type GetSessionChunkPreviewFramesQueryResult = Apollo.QueryResult<
  Types.GetSessionChunkPreviewFramesQuery,
  Types.GetSessionChunkPreviewFramesQueryVariables
>;
export const GetWebSocketEventsDocument = gql`
  query GetWebSocketEvents($session_secure_id: String!) {
    websocket_events(session_secure_id: $session_secure_id)
  }
`;

/**
 * __useGetWebSocketEventsQuery__
 *
 * To run a query within a React component, call `useGetWebSocketEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebSocketEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebSocketEventsQuery({
 *   variables: {
 *      session_secure_id: // value for 'session_secure_id'
 *   },
 * });
 */
export function useGetWebSocketEventsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetWebSocketEventsQuery, Types.GetWebSocketEventsQueryVariables> &
    ({ variables: Types.GetWebSocketEventsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetWebSocketEventsQuery, Types.GetWebSocketEventsQueryVariables>(
    GetWebSocketEventsDocument,
    options,
  );
}
export function useGetWebSocketEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetWebSocketEventsQuery, Types.GetWebSocketEventsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetWebSocketEventsQuery, Types.GetWebSocketEventsQueryVariables>(
    GetWebSocketEventsDocument,
    options,
  );
}
export function useGetWebSocketEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetWebSocketEventsQuery, Types.GetWebSocketEventsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetWebSocketEventsQuery, Types.GetWebSocketEventsQueryVariables>(
    GetWebSocketEventsDocument,
    options,
  );
}
export type GetWebSocketEventsQueryHookResult = ReturnType<typeof useGetWebSocketEventsQuery>;
export type GetWebSocketEventsLazyQueryHookResult = ReturnType<typeof useGetWebSocketEventsLazyQuery>;
export type GetWebSocketEventsSuspenseQueryHookResult = ReturnType<typeof useGetWebSocketEventsSuspenseQuery>;
export type GetWebSocketEventsQueryResult = Apollo.QueryResult<
  Types.GetWebSocketEventsQuery,
  Types.GetWebSocketEventsQueryVariables
>;
export const GetSessionsDocument = gql`
  query GetSessions(
    $project_id: StringID!
    $count: Int!
    $params: QueryInput!
    $sort_desc: Boolean!
    $sort_field: String
    $page: Int
    $query_settings: QuerySettingsInput
  ) {
    sessions(
      project_id: $project_id
      count: $count
      params: $params
      sort_field: $sort_field
      sort_desc: $sort_desc
      page: $page
      query_settings: $query_settings
    ) {
      sessions {
        id
        project_id
        secure_id
        client_id
        fingerprint
        identifier
        identified
        os_name
        os_version
        browser_name
        browser_version
        ip
        city
        state
        country
        postal
        created_at
        language
        length
        active_length
        enable_recording_network_contents
        viewed
        starred
        processed
        has_rage_clicks
        has_errors
        fields {
          name
          value
          type
          id
        }
        first_time
        user_properties
        event_counts
        last_user_interaction_time
        is_public
        excluded
        email
      }
      totalCount
      totalLength
      totalActiveLength
    }
  }
`;

/**
 * __useGetSessionsQuery__
 *
 * To run a query within a React component, call `useGetSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionsQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      count: // value for 'count'
 *      params: // value for 'params'
 *      sort_desc: // value for 'sort_desc'
 *      sort_field: // value for 'sort_field'
 *      page: // value for 'page'
 *      query_settings: // value for 'query_settings'
 *   },
 * });
 */
export function useGetSessionsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetSessionsQuery, Types.GetSessionsQueryVariables> &
    ({ variables: Types.GetSessionsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetSessionsQuery, Types.GetSessionsQueryVariables>(GetSessionsDocument, options);
}
export function useGetSessionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSessionsQuery, Types.GetSessionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetSessionsQuery, Types.GetSessionsQueryVariables>(GetSessionsDocument, options);
}
export function useGetSessionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetSessionsQuery, Types.GetSessionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetSessionsQuery, Types.GetSessionsQueryVariables>(GetSessionsDocument, options);
}
export type GetSessionsQueryHookResult = ReturnType<typeof useGetSessionsQuery>;
export type GetSessionsLazyQueryHookResult = ReturnType<typeof useGetSessionsLazyQuery>;
export type GetSessionsSuspenseQueryHookResult = ReturnType<typeof useGetSessionsSuspenseQuery>;
export type GetSessionsQueryResult = Apollo.QueryResult<Types.GetSessionsQuery, Types.GetSessionsQueryVariables>;
export const GetEventSessionsDocument = gql`
  query GetEventSessions(
    $project_id: StringID!
    $count: Int!
    $params: QueryInput!
    $sort_desc: Boolean!
    $sort_field: String
    $page: Int
  ) {
    event_sessions(
      project_id: $project_id
      count: $count
      params: $params
      sort_field: $sort_field
      sort_desc: $sort_desc
      page: $page
    ) {
      sessions {
        id
        project_id
        secure_id
        client_id
        fingerprint
        identifier
        identified
        os_name
        os_version
        browser_name
        browser_version
        ip
        city
        state
        country
        postal
        created_at
        language
        length
        active_length
        enable_recording_network_contents
        viewed
        starred
        processed
        has_rage_clicks
        has_errors
        fields {
          name
          value
          type
          id
        }
        first_time
        user_properties
        event_counts
        last_user_interaction_time
        is_public
        excluded
        email
      }
      totalCount
    }
  }
`;

/**
 * __useGetEventSessionsQuery__
 *
 * To run a query within a React component, call `useGetEventSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventSessionsQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      count: // value for 'count'
 *      params: // value for 'params'
 *      sort_desc: // value for 'sort_desc'
 *      sort_field: // value for 'sort_field'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetEventSessionsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetEventSessionsQuery, Types.GetEventSessionsQueryVariables> &
    ({ variables: Types.GetEventSessionsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetEventSessionsQuery, Types.GetEventSessionsQueryVariables>(
    GetEventSessionsDocument,
    options,
  );
}
export function useGetEventSessionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetEventSessionsQuery, Types.GetEventSessionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetEventSessionsQuery, Types.GetEventSessionsQueryVariables>(
    GetEventSessionsDocument,
    options,
  );
}
export function useGetEventSessionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetEventSessionsQuery, Types.GetEventSessionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetEventSessionsQuery, Types.GetEventSessionsQueryVariables>(
    GetEventSessionsDocument,
    options,
  );
}
export type GetEventSessionsQueryHookResult = ReturnType<typeof useGetEventSessionsQuery>;
export type GetEventSessionsLazyQueryHookResult = ReturnType<typeof useGetEventSessionsLazyQuery>;
export type GetEventSessionsSuspenseQueryHookResult = ReturnType<typeof useGetEventSessionsSuspenseQuery>;
export type GetEventSessionsQueryResult = Apollo.QueryResult<
  Types.GetEventSessionsQuery,
  Types.GetEventSessionsQueryVariables
>;
export const GetSessionsHistogramDocument = gql`
  query GetSessionsHistogram($project_id: StringID!, $params: QueryInput!, $histogram_options: DateHistogramOptions!) {
    sessions_histogram(project_id: $project_id, params: $params, histogram_options: $histogram_options) {
      bucket_times
      sessions_without_errors
      sessions_with_errors
      total_sessions
      inactive_lengths
      active_lengths
    }
  }
`;

/**
 * __useGetSessionsHistogramQuery__
 *
 * To run a query within a React component, call `useGetSessionsHistogramQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionsHistogramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionsHistogramQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      params: // value for 'params'
 *      histogram_options: // value for 'histogram_options'
 *   },
 * });
 */
export function useGetSessionsHistogramQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetSessionsHistogramQuery, Types.GetSessionsHistogramQueryVariables> &
    ({ variables: Types.GetSessionsHistogramQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetSessionsHistogramQuery, Types.GetSessionsHistogramQueryVariables>(
    GetSessionsHistogramDocument,
    options,
  );
}
export function useGetSessionsHistogramLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSessionsHistogramQuery, Types.GetSessionsHistogramQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetSessionsHistogramQuery, Types.GetSessionsHistogramQueryVariables>(
    GetSessionsHistogramDocument,
    options,
  );
}
export function useGetSessionsHistogramSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetSessionsHistogramQuery, Types.GetSessionsHistogramQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetSessionsHistogramQuery, Types.GetSessionsHistogramQueryVariables>(
    GetSessionsHistogramDocument,
    options,
  );
}
export type GetSessionsHistogramQueryHookResult = ReturnType<typeof useGetSessionsHistogramQuery>;
export type GetSessionsHistogramLazyQueryHookResult = ReturnType<typeof useGetSessionsHistogramLazyQuery>;
export type GetSessionsHistogramSuspenseQueryHookResult = ReturnType<typeof useGetSessionsHistogramSuspenseQuery>;
export type GetSessionsHistogramQueryResult = Apollo.QueryResult<
  Types.GetSessionsHistogramQuery,
  Types.GetSessionsHistogramQueryVariables
>;
export const GetSessionUsersReportsDocument = gql`
  query GetSessionUsersReports($project_id: StringID!, $params: QueryInput!, $timezone: String) {
    session_users_report(project_id: $project_id, params: $params, timezone: $timezone) {
      key
      email
      first_session
      last_session
      num_sessions
      num_days_visited
      num_months_visited
      avg_active_length_mins
      max_active_length_mins
      total_active_length_mins
      avg_length_mins
      max_length_mins
      total_length_mins
      location
      daily_sessions {
        day
        num_sessions
      }
    }
  }
`;

/**
 * __useGetSessionUsersReportsQuery__
 *
 * To run a query within a React component, call `useGetSessionUsersReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionUsersReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionUsersReportsQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      params: // value for 'params'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useGetSessionUsersReportsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetSessionUsersReportsQuery, Types.GetSessionUsersReportsQueryVariables> &
    ({ variables: Types.GetSessionUsersReportsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetSessionUsersReportsQuery, Types.GetSessionUsersReportsQueryVariables>(
    GetSessionUsersReportsDocument,
    options,
  );
}
export function useGetSessionUsersReportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetSessionUsersReportsQuery,
    Types.GetSessionUsersReportsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetSessionUsersReportsQuery, Types.GetSessionUsersReportsQueryVariables>(
    GetSessionUsersReportsDocument,
    options,
  );
}
export function useGetSessionUsersReportsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetSessionUsersReportsQuery, Types.GetSessionUsersReportsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetSessionUsersReportsQuery, Types.GetSessionUsersReportsQueryVariables>(
    GetSessionUsersReportsDocument,
    options,
  );
}
export type GetSessionUsersReportsQueryHookResult = ReturnType<typeof useGetSessionUsersReportsQuery>;
export type GetSessionUsersReportsLazyQueryHookResult = ReturnType<typeof useGetSessionUsersReportsLazyQuery>;
export type GetSessionUsersReportsSuspenseQueryHookResult = ReturnType<typeof useGetSessionUsersReportsSuspenseQuery>;
export type GetSessionUsersReportsQueryResult = Apollo.QueryResult<
  Types.GetSessionUsersReportsQuery,
  Types.GetSessionUsersReportsQueryVariables
>;
export const GetErrorGroupsDocument = gql`
  query GetErrorGroups($project_id: StringID!, $count: Int!, $params: QueryInput!, $page: Int) {
    error_groups(project_id: $project_id, count: $count, params: $params, page: $page) {
      error_groups {
        created_at
        updated_at
        id
        secure_id
        type
        event
        state
        first_occurrence
        last_occurrence
        snoozed_until
        environments
        structured_stack_trace {
          fileName
        }
        error_frequency
        error_metrics {
          error_group_id
          date
          name
          value
        }
        is_public
        project_id
      }
      totalCount
    }
  }
`;

/**
 * __useGetErrorGroupsQuery__
 *
 * To run a query within a React component, call `useGetErrorGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetErrorGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetErrorGroupsQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      count: // value for 'count'
 *      params: // value for 'params'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetErrorGroupsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetErrorGroupsQuery, Types.GetErrorGroupsQueryVariables> &
    ({ variables: Types.GetErrorGroupsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetErrorGroupsQuery, Types.GetErrorGroupsQueryVariables>(
    GetErrorGroupsDocument,
    options,
  );
}
export function useGetErrorGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetErrorGroupsQuery, Types.GetErrorGroupsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetErrorGroupsQuery, Types.GetErrorGroupsQueryVariables>(
    GetErrorGroupsDocument,
    options,
  );
}
export function useGetErrorGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetErrorGroupsQuery, Types.GetErrorGroupsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetErrorGroupsQuery, Types.GetErrorGroupsQueryVariables>(
    GetErrorGroupsDocument,
    options,
  );
}
export type GetErrorGroupsQueryHookResult = ReturnType<typeof useGetErrorGroupsQuery>;
export type GetErrorGroupsLazyQueryHookResult = ReturnType<typeof useGetErrorGroupsLazyQuery>;
export type GetErrorGroupsSuspenseQueryHookResult = ReturnType<typeof useGetErrorGroupsSuspenseQuery>;
export type GetErrorGroupsQueryResult = Apollo.QueryResult<
  Types.GetErrorGroupsQuery,
  Types.GetErrorGroupsQueryVariables
>;
export const GetErrorGroupsForFlagVariationDocument = gql`
  query GetErrorGroupsForFlagVariation(
    $ld_project_id: String!
    $ld_environment_id: String!
    $flag_key: String!
    $flag_variation_value_json: String!
    $count: Int!
    $params: QueryInput!
    $page: Int
  ) {
    error_groups_for_flag_variation(
      ld_project_id: $ld_project_id
      ld_environment_id: $ld_environment_id
      flag_key: $flag_key
      flag_variation_value_json: $flag_variation_value_json
      count: $count
      params: $params
      page: $page
    ) {
      error_groups {
        created_at
        updated_at
        id
        secure_id
        type
        event
        state
        first_occurrence
        last_occurrence
        snoozed_until
        environments
        error_frequency
        error_metrics {
          error_group_id
          date
          name
          value
        }
        is_public
        project_id
      }
      totalCount
    }
  }
`;

/**
 * __useGetErrorGroupsForFlagVariationQuery__
 *
 * To run a query within a React component, call `useGetErrorGroupsForFlagVariationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetErrorGroupsForFlagVariationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetErrorGroupsForFlagVariationQuery({
 *   variables: {
 *      ld_project_id: // value for 'ld_project_id'
 *      ld_environment_id: // value for 'ld_environment_id'
 *      flag_key: // value for 'flag_key'
 *      flag_variation_value_json: // value for 'flag_variation_value_json'
 *      count: // value for 'count'
 *      params: // value for 'params'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetErrorGroupsForFlagVariationQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetErrorGroupsForFlagVariationQuery,
    Types.GetErrorGroupsForFlagVariationQueryVariables
  > &
    ({ variables: Types.GetErrorGroupsForFlagVariationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetErrorGroupsForFlagVariationQuery, Types.GetErrorGroupsForFlagVariationQueryVariables>(
    GetErrorGroupsForFlagVariationDocument,
    options,
  );
}
export function useGetErrorGroupsForFlagVariationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetErrorGroupsForFlagVariationQuery,
    Types.GetErrorGroupsForFlagVariationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetErrorGroupsForFlagVariationQuery,
    Types.GetErrorGroupsForFlagVariationQueryVariables
  >(GetErrorGroupsForFlagVariationDocument, options);
}
export function useGetErrorGroupsForFlagVariationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types.GetErrorGroupsForFlagVariationQuery,
        Types.GetErrorGroupsForFlagVariationQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GetErrorGroupsForFlagVariationQuery,
    Types.GetErrorGroupsForFlagVariationQueryVariables
  >(GetErrorGroupsForFlagVariationDocument, options);
}
export type GetErrorGroupsForFlagVariationQueryHookResult = ReturnType<typeof useGetErrorGroupsForFlagVariationQuery>;
export type GetErrorGroupsForFlagVariationLazyQueryHookResult = ReturnType<
  typeof useGetErrorGroupsForFlagVariationLazyQuery
>;
export type GetErrorGroupsForFlagVariationSuspenseQueryHookResult = ReturnType<
  typeof useGetErrorGroupsForFlagVariationSuspenseQuery
>;
export type GetErrorGroupsForFlagVariationQueryResult = Apollo.QueryResult<
  Types.GetErrorGroupsForFlagVariationQuery,
  Types.GetErrorGroupsForFlagVariationQueryVariables
>;
export const GetErrorsHistogramDocument = gql`
  query GetErrorsHistogram($project_id: StringID!, $params: QueryInput!, $histogram_options: DateHistogramOptions!) {
    errors_histogram(project_id: $project_id, params: $params, histogram_options: $histogram_options) {
      bucket_times
      error_objects
    }
  }
`;

/**
 * __useGetErrorsHistogramQuery__
 *
 * To run a query within a React component, call `useGetErrorsHistogramQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetErrorsHistogramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetErrorsHistogramQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      params: // value for 'params'
 *      histogram_options: // value for 'histogram_options'
 *   },
 * });
 */
export function useGetErrorsHistogramQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetErrorsHistogramQuery, Types.GetErrorsHistogramQueryVariables> &
    ({ variables: Types.GetErrorsHistogramQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetErrorsHistogramQuery, Types.GetErrorsHistogramQueryVariables>(
    GetErrorsHistogramDocument,
    options,
  );
}
export function useGetErrorsHistogramLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetErrorsHistogramQuery, Types.GetErrorsHistogramQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetErrorsHistogramQuery, Types.GetErrorsHistogramQueryVariables>(
    GetErrorsHistogramDocument,
    options,
  );
}
export function useGetErrorsHistogramSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetErrorsHistogramQuery, Types.GetErrorsHistogramQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetErrorsHistogramQuery, Types.GetErrorsHistogramQueryVariables>(
    GetErrorsHistogramDocument,
    options,
  );
}
export type GetErrorsHistogramQueryHookResult = ReturnType<typeof useGetErrorsHistogramQuery>;
export type GetErrorsHistogramLazyQueryHookResult = ReturnType<typeof useGetErrorsHistogramLazyQuery>;
export type GetErrorsHistogramSuspenseQueryHookResult = ReturnType<typeof useGetErrorsHistogramSuspenseQuery>;
export type GetErrorsHistogramQueryResult = Apollo.QueryResult<
  Types.GetErrorsHistogramQuery,
  Types.GetErrorsHistogramQueryVariables
>;
export const GetProjectsDocument = gql`
  query GetProjects {
    projects {
      ...Project
    }
  }
  ${ProjectFragmentDoc}
`;

/**
 * __useGetProjectsQuery__
 *
 * To run a query within a React component, call `useGetProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProjectsQuery(
  baseOptions?: Apollo.QueryHookOptions<Types.GetProjectsQuery, Types.GetProjectsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetProjectsQuery, Types.GetProjectsQueryVariables>(GetProjectsDocument, options);
}
export function useGetProjectsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetProjectsQuery, Types.GetProjectsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetProjectsQuery, Types.GetProjectsQueryVariables>(GetProjectsDocument, options);
}
export function useGetProjectsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetProjectsQuery, Types.GetProjectsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetProjectsQuery, Types.GetProjectsQueryVariables>(GetProjectsDocument, options);
}
export type GetProjectsQueryHookResult = ReturnType<typeof useGetProjectsQuery>;
export type GetProjectsLazyQueryHookResult = ReturnType<typeof useGetProjectsLazyQuery>;
export type GetProjectsSuspenseQueryHookResult = ReturnType<typeof useGetProjectsSuspenseQuery>;
export type GetProjectsQueryResult = Apollo.QueryResult<Types.GetProjectsQuery, Types.GetProjectsQueryVariables>;
export const GetWorkspaceDocument = gql`
  query GetWorkspace($id: ID!) {
    workspace(id: $id) {
      id
      name
      plan_tier
      unlimited_members
      projects {
        ...Project
      }
    }
  }
  ${ProjectFragmentDoc}
`;

/**
 * __useGetWorkspaceQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWorkspaceQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetWorkspaceQuery, Types.GetWorkspaceQueryVariables> &
    ({ variables: Types.GetWorkspaceQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetWorkspaceQuery, Types.GetWorkspaceQueryVariables>(GetWorkspaceDocument, options);
}
export function useGetWorkspaceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetWorkspaceQuery, Types.GetWorkspaceQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetWorkspaceQuery, Types.GetWorkspaceQueryVariables>(GetWorkspaceDocument, options);
}
export function useGetWorkspaceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetWorkspaceQuery, Types.GetWorkspaceQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetWorkspaceQuery, Types.GetWorkspaceQueryVariables>(
    GetWorkspaceDocument,
    options,
  );
}
export type GetWorkspaceQueryHookResult = ReturnType<typeof useGetWorkspaceQuery>;
export type GetWorkspaceLazyQueryHookResult = ReturnType<typeof useGetWorkspaceLazyQuery>;
export type GetWorkspaceSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceSuspenseQuery>;
export type GetWorkspaceQueryResult = Apollo.QueryResult<Types.GetWorkspaceQuery, Types.GetWorkspaceQueryVariables>;
export const GetWorkspaceForInviteLinkDocument = gql`
  query GetWorkspaceForInviteLink($secret: String!) {
    workspace_for_invite_link(secret: $secret) {
      expiration_date
      existing_account
      invitee_email
      secret
      workspace_id
      workspace_name
      project_id
    }
  }
`;

/**
 * __useGetWorkspaceForInviteLinkQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceForInviteLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceForInviteLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceForInviteLinkQuery({
 *   variables: {
 *      secret: // value for 'secret'
 *   },
 * });
 */
export function useGetWorkspaceForInviteLinkQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetWorkspaceForInviteLinkQuery,
    Types.GetWorkspaceForInviteLinkQueryVariables
  > &
    ({ variables: Types.GetWorkspaceForInviteLinkQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetWorkspaceForInviteLinkQuery, Types.GetWorkspaceForInviteLinkQueryVariables>(
    GetWorkspaceForInviteLinkDocument,
    options,
  );
}
export function useGetWorkspaceForInviteLinkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetWorkspaceForInviteLinkQuery,
    Types.GetWorkspaceForInviteLinkQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetWorkspaceForInviteLinkQuery, Types.GetWorkspaceForInviteLinkQueryVariables>(
    GetWorkspaceForInviteLinkDocument,
    options,
  );
}
export function useGetWorkspaceForInviteLinkSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types.GetWorkspaceForInviteLinkQuery,
        Types.GetWorkspaceForInviteLinkQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetWorkspaceForInviteLinkQuery, Types.GetWorkspaceForInviteLinkQueryVariables>(
    GetWorkspaceForInviteLinkDocument,
    options,
  );
}
export type GetWorkspaceForInviteLinkQueryHookResult = ReturnType<typeof useGetWorkspaceForInviteLinkQuery>;
export type GetWorkspaceForInviteLinkLazyQueryHookResult = ReturnType<typeof useGetWorkspaceForInviteLinkLazyQuery>;
export type GetWorkspaceForInviteLinkSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkspaceForInviteLinkSuspenseQuery
>;
export type GetWorkspaceForInviteLinkQueryResult = Apollo.QueryResult<
  Types.GetWorkspaceForInviteLinkQuery,
  Types.GetWorkspaceForInviteLinkQueryVariables
>;
export const GetWorkspacesDocument = gql`
  query GetWorkspaces {
    workspaces {
      id
      name
      retention_period
      errors_retention_period
      logs_retention_period
      traces_retention_period
      metrics_retention_period
    }
    joinable_workspaces {
      id
      name
      projects {
        ...Project
      }
    }
  }
  ${ProjectFragmentDoc}
`;

/**
 * __useGetWorkspacesQuery__
 *
 * To run a query within a React component, call `useGetWorkspacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspacesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorkspacesQuery(
  baseOptions?: Apollo.QueryHookOptions<Types.GetWorkspacesQuery, Types.GetWorkspacesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetWorkspacesQuery, Types.GetWorkspacesQueryVariables>(GetWorkspacesDocument, options);
}
export function useGetWorkspacesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetWorkspacesQuery, Types.GetWorkspacesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetWorkspacesQuery, Types.GetWorkspacesQueryVariables>(
    GetWorkspacesDocument,
    options,
  );
}
export function useGetWorkspacesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetWorkspacesQuery, Types.GetWorkspacesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetWorkspacesQuery, Types.GetWorkspacesQueryVariables>(
    GetWorkspacesDocument,
    options,
  );
}
export type GetWorkspacesQueryHookResult = ReturnType<typeof useGetWorkspacesQuery>;
export type GetWorkspacesLazyQueryHookResult = ReturnType<typeof useGetWorkspacesLazyQuery>;
export type GetWorkspacesSuspenseQueryHookResult = ReturnType<typeof useGetWorkspacesSuspenseQuery>;
export type GetWorkspacesQueryResult = Apollo.QueryResult<Types.GetWorkspacesQuery, Types.GetWorkspacesQueryVariables>;
export const GetWorkspacesCountDocument = gql`
  query GetWorkspacesCount {
    workspaces_count
  }
`;

/**
 * __useGetWorkspacesCountQuery__
 *
 * To run a query within a React component, call `useGetWorkspacesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspacesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspacesCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorkspacesCountQuery(
  baseOptions?: Apollo.QueryHookOptions<Types.GetWorkspacesCountQuery, Types.GetWorkspacesCountQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetWorkspacesCountQuery, Types.GetWorkspacesCountQueryVariables>(
    GetWorkspacesCountDocument,
    options,
  );
}
export function useGetWorkspacesCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetWorkspacesCountQuery, Types.GetWorkspacesCountQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetWorkspacesCountQuery, Types.GetWorkspacesCountQueryVariables>(
    GetWorkspacesCountDocument,
    options,
  );
}
export function useGetWorkspacesCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetWorkspacesCountQuery, Types.GetWorkspacesCountQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetWorkspacesCountQuery, Types.GetWorkspacesCountQueryVariables>(
    GetWorkspacesCountDocument,
    options,
  );
}
export type GetWorkspacesCountQueryHookResult = ReturnType<typeof useGetWorkspacesCountQuery>;
export type GetWorkspacesCountLazyQueryHookResult = ReturnType<typeof useGetWorkspacesCountLazyQuery>;
export type GetWorkspacesCountSuspenseQueryHookResult = ReturnType<typeof useGetWorkspacesCountSuspenseQuery>;
export type GetWorkspacesCountQueryResult = Apollo.QueryResult<
  Types.GetWorkspacesCountQuery,
  Types.GetWorkspacesCountQueryVariables
>;
export const GetProjectsAndWorkspacesDocument = gql`
  query GetProjectsAndWorkspaces {
    projects {
      ...Project
    }
    workspaces {
      id
      name
    }
  }
  ${ProjectFragmentDoc}
`;

/**
 * __useGetProjectsAndWorkspacesQuery__
 *
 * To run a query within a React component, call `useGetProjectsAndWorkspacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectsAndWorkspacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectsAndWorkspacesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProjectsAndWorkspacesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.GetProjectsAndWorkspacesQuery,
    Types.GetProjectsAndWorkspacesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetProjectsAndWorkspacesQuery, Types.GetProjectsAndWorkspacesQueryVariables>(
    GetProjectsAndWorkspacesDocument,
    options,
  );
}
export function useGetProjectsAndWorkspacesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetProjectsAndWorkspacesQuery,
    Types.GetProjectsAndWorkspacesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetProjectsAndWorkspacesQuery, Types.GetProjectsAndWorkspacesQueryVariables>(
    GetProjectsAndWorkspacesDocument,
    options,
  );
}
export function useGetProjectsAndWorkspacesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types.GetProjectsAndWorkspacesQuery,
        Types.GetProjectsAndWorkspacesQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetProjectsAndWorkspacesQuery, Types.GetProjectsAndWorkspacesQueryVariables>(
    GetProjectsAndWorkspacesDocument,
    options,
  );
}
export type GetProjectsAndWorkspacesQueryHookResult = ReturnType<typeof useGetProjectsAndWorkspacesQuery>;
export type GetProjectsAndWorkspacesLazyQueryHookResult = ReturnType<typeof useGetProjectsAndWorkspacesLazyQuery>;
export type GetProjectsAndWorkspacesSuspenseQueryHookResult = ReturnType<
  typeof useGetProjectsAndWorkspacesSuspenseQuery
>;
export type GetProjectsAndWorkspacesQueryResult = Apollo.QueryResult<
  Types.GetProjectsAndWorkspacesQuery,
  Types.GetProjectsAndWorkspacesQueryVariables
>;
export const GetProjectOrWorkspaceDocument = gql`
  query GetProjectOrWorkspace($project_id: StringID!, $workspace_id: ID!, $is_workspace: Boolean!) {
    project(id: $project_id) @skip(if: $is_workspace) {
      ...Project
      workspace {
        id
        name
        retention_period
        errors_retention_period
        metrics_retention_period
        projects {
          ...Project
        }
      }
    }
    workspace(id: $workspace_id) @include(if: $is_workspace) {
      id
      name
      cloudflare_proxy
      projects {
        ...Project
      }
      retention_period
      errors_retention_period
      metrics_retention_period
    }
  }
  ${ProjectFragmentDoc}
`;

/**
 * __useGetProjectOrWorkspaceQuery__
 *
 * To run a query within a React component, call `useGetProjectOrWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectOrWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectOrWorkspaceQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      workspace_id: // value for 'workspace_id'
 *      is_workspace: // value for 'is_workspace'
 *   },
 * });
 */
export function useGetProjectOrWorkspaceQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetProjectOrWorkspaceQuery, Types.GetProjectOrWorkspaceQueryVariables> &
    ({ variables: Types.GetProjectOrWorkspaceQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetProjectOrWorkspaceQuery, Types.GetProjectOrWorkspaceQueryVariables>(
    GetProjectOrWorkspaceDocument,
    options,
  );
}
export function useGetProjectOrWorkspaceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetProjectOrWorkspaceQuery,
    Types.GetProjectOrWorkspaceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetProjectOrWorkspaceQuery, Types.GetProjectOrWorkspaceQueryVariables>(
    GetProjectOrWorkspaceDocument,
    options,
  );
}
export function useGetProjectOrWorkspaceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetProjectOrWorkspaceQuery, Types.GetProjectOrWorkspaceQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetProjectOrWorkspaceQuery, Types.GetProjectOrWorkspaceQueryVariables>(
    GetProjectOrWorkspaceDocument,
    options,
  );
}
export type GetProjectOrWorkspaceQueryHookResult = ReturnType<typeof useGetProjectOrWorkspaceQuery>;
export type GetProjectOrWorkspaceLazyQueryHookResult = ReturnType<typeof useGetProjectOrWorkspaceLazyQuery>;
export type GetProjectOrWorkspaceSuspenseQueryHookResult = ReturnType<typeof useGetProjectOrWorkspaceSuspenseQuery>;
export type GetProjectOrWorkspaceQueryResult = Apollo.QueryResult<
  Types.GetProjectOrWorkspaceQuery,
  Types.GetProjectOrWorkspaceQueryVariables
>;
export const GetDropdownOptionsDocument = gql`
  query GetDropdownOptions {
    projects {
      ...Project
    }
    workspaces {
      id
      name
      cloudflare_proxy
      projects {
        id
      }
      retention_period
      errors_retention_period
    }
    joinable_workspaces {
      id
      name
      projects {
        ...Project
      }
    }
  }
  ${ProjectFragmentDoc}
`;

/**
 * __useGetDropdownOptionsQuery__
 *
 * To run a query within a React component, call `useGetDropdownOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDropdownOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDropdownOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDropdownOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<Types.GetDropdownOptionsQuery, Types.GetDropdownOptionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetDropdownOptionsQuery, Types.GetDropdownOptionsQueryVariables>(
    GetDropdownOptionsDocument,
    options,
  );
}
export function useGetDropdownOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetDropdownOptionsQuery, Types.GetDropdownOptionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetDropdownOptionsQuery, Types.GetDropdownOptionsQueryVariables>(
    GetDropdownOptionsDocument,
    options,
  );
}
export function useGetDropdownOptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetDropdownOptionsQuery, Types.GetDropdownOptionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetDropdownOptionsQuery, Types.GetDropdownOptionsQueryVariables>(
    GetDropdownOptionsDocument,
    options,
  );
}
export type GetDropdownOptionsQueryHookResult = ReturnType<typeof useGetDropdownOptionsQuery>;
export type GetDropdownOptionsLazyQueryHookResult = ReturnType<typeof useGetDropdownOptionsLazyQuery>;
export type GetDropdownOptionsSuspenseQueryHookResult = ReturnType<typeof useGetDropdownOptionsSuspenseQuery>;
export type GetDropdownOptionsQueryResult = Apollo.QueryResult<
  Types.GetDropdownOptionsQuery,
  Types.GetDropdownOptionsQueryVariables
>;
export const GetAdminDocument = gql`
  query GetAdmin {
    admin {
      id
      uid
      name
      email
      phone
      photo_url
      slack_im_channel_id
      email_verified
      user_defined_role
      about_you_details_filled
    }
  }
`;

/**
 * __useGetAdminQuery__
 *
 * To run a query within a React component, call `useGetAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdminQuery(
  baseOptions?: Apollo.QueryHookOptions<Types.GetAdminQuery, Types.GetAdminQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetAdminQuery, Types.GetAdminQueryVariables>(GetAdminDocument, options);
}
export function useGetAdminLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAdminQuery, Types.GetAdminQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetAdminQuery, Types.GetAdminQueryVariables>(GetAdminDocument, options);
}
export function useGetAdminSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAdminQuery, Types.GetAdminQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetAdminQuery, Types.GetAdminQueryVariables>(GetAdminDocument, options);
}
export type GetAdminQueryHookResult = ReturnType<typeof useGetAdminQuery>;
export type GetAdminLazyQueryHookResult = ReturnType<typeof useGetAdminLazyQuery>;
export type GetAdminSuspenseQueryHookResult = ReturnType<typeof useGetAdminSuspenseQuery>;
export type GetAdminQueryResult = Apollo.QueryResult<Types.GetAdminQuery, Types.GetAdminQueryVariables>;
export const GetAdminRoleDocument = gql`
  query GetAdminRole($workspace_id: ID!) {
    admin_role(workspace_id: $workspace_id) {
      workspaceId
      admin {
        id
        uid
        name
        email
        phone
        photo_url
        slack_im_channel_id
        email_verified
        user_defined_role
        about_you_details_filled
      }
      role
      projectIds
    }
  }
`;

/**
 * __useGetAdminRoleQuery__
 *
 * To run a query within a React component, call `useGetAdminRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminRoleQuery({
 *   variables: {
 *      workspace_id: // value for 'workspace_id'
 *   },
 * });
 */
export function useGetAdminRoleQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetAdminRoleQuery, Types.GetAdminRoleQueryVariables> &
    ({ variables: Types.GetAdminRoleQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetAdminRoleQuery, Types.GetAdminRoleQueryVariables>(GetAdminRoleDocument, options);
}
export function useGetAdminRoleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAdminRoleQuery, Types.GetAdminRoleQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetAdminRoleQuery, Types.GetAdminRoleQueryVariables>(GetAdminRoleDocument, options);
}
export function useGetAdminRoleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetAdminRoleQuery, Types.GetAdminRoleQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetAdminRoleQuery, Types.GetAdminRoleQueryVariables>(
    GetAdminRoleDocument,
    options,
  );
}
export type GetAdminRoleQueryHookResult = ReturnType<typeof useGetAdminRoleQuery>;
export type GetAdminRoleLazyQueryHookResult = ReturnType<typeof useGetAdminRoleLazyQuery>;
export type GetAdminRoleSuspenseQueryHookResult = ReturnType<typeof useGetAdminRoleSuspenseQuery>;
export type GetAdminRoleQueryResult = Apollo.QueryResult<Types.GetAdminRoleQuery, Types.GetAdminRoleQueryVariables>;
export const GetAdminRoleByProjectDocument = gql`
  query GetAdminRoleByProject($project_id: ID!) {
    admin_role_by_project(project_id: $project_id) {
      workspaceId
      admin {
        id
        uid
        name
        email
        phone
        photo_url
        slack_im_channel_id
        email_verified
        user_defined_role
        about_you_details_filled
      }
      role
      projectIds
    }
  }
`;

/**
 * __useGetAdminRoleByProjectQuery__
 *
 * To run a query within a React component, call `useGetAdminRoleByProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminRoleByProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminRoleByProjectQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *   },
 * });
 */
export function useGetAdminRoleByProjectQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetAdminRoleByProjectQuery, Types.GetAdminRoleByProjectQueryVariables> &
    ({ variables: Types.GetAdminRoleByProjectQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetAdminRoleByProjectQuery, Types.GetAdminRoleByProjectQueryVariables>(
    GetAdminRoleByProjectDocument,
    options,
  );
}
export function useGetAdminRoleByProjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetAdminRoleByProjectQuery,
    Types.GetAdminRoleByProjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetAdminRoleByProjectQuery, Types.GetAdminRoleByProjectQueryVariables>(
    GetAdminRoleByProjectDocument,
    options,
  );
}
export function useGetAdminRoleByProjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetAdminRoleByProjectQuery, Types.GetAdminRoleByProjectQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetAdminRoleByProjectQuery, Types.GetAdminRoleByProjectQueryVariables>(
    GetAdminRoleByProjectDocument,
    options,
  );
}
export type GetAdminRoleByProjectQueryHookResult = ReturnType<typeof useGetAdminRoleByProjectQuery>;
export type GetAdminRoleByProjectLazyQueryHookResult = ReturnType<typeof useGetAdminRoleByProjectLazyQuery>;
export type GetAdminRoleByProjectSuspenseQueryHookResult = ReturnType<typeof useGetAdminRoleByProjectSuspenseQuery>;
export type GetAdminRoleByProjectQueryResult = Apollo.QueryResult<
  Types.GetAdminRoleByProjectQuery,
  Types.GetAdminRoleByProjectQueryVariables
>;
export const GetAdminAboutYouDocument = gql`
  query GetAdminAboutYou {
    admin {
      id
      name
      user_defined_role
      referral
    }
  }
`;

/**
 * __useGetAdminAboutYouQuery__
 *
 * To run a query within a React component, call `useGetAdminAboutYouQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminAboutYouQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminAboutYouQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdminAboutYouQuery(
  baseOptions?: Apollo.QueryHookOptions<Types.GetAdminAboutYouQuery, Types.GetAdminAboutYouQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetAdminAboutYouQuery, Types.GetAdminAboutYouQueryVariables>(
    GetAdminAboutYouDocument,
    options,
  );
}
export function useGetAdminAboutYouLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAdminAboutYouQuery, Types.GetAdminAboutYouQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetAdminAboutYouQuery, Types.GetAdminAboutYouQueryVariables>(
    GetAdminAboutYouDocument,
    options,
  );
}
export function useGetAdminAboutYouSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetAdminAboutYouQuery, Types.GetAdminAboutYouQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetAdminAboutYouQuery, Types.GetAdminAboutYouQueryVariables>(
    GetAdminAboutYouDocument,
    options,
  );
}
export type GetAdminAboutYouQueryHookResult = ReturnType<typeof useGetAdminAboutYouQuery>;
export type GetAdminAboutYouLazyQueryHookResult = ReturnType<typeof useGetAdminAboutYouLazyQuery>;
export type GetAdminAboutYouSuspenseQueryHookResult = ReturnType<typeof useGetAdminAboutYouSuspenseQuery>;
export type GetAdminAboutYouQueryResult = Apollo.QueryResult<
  Types.GetAdminAboutYouQuery,
  Types.GetAdminAboutYouQueryVariables
>;
export const GetProjectDocument = gql`
  query GetProject($id: StringID!) {
    project(id: $id) {
      ...Project
      workspace {
        id
        slack_webhook_channel
        retention_period
        errors_retention_period
        logs_retention_period
        traces_retention_period
        metrics_retention_period
      }
    }
  }
  ${ProjectFragmentDoc}
`;

/**
 * __useGetProjectQuery__
 *
 * To run a query within a React component, call `useGetProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetProjectQuery, Types.GetProjectQueryVariables> &
    ({ variables: Types.GetProjectQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetProjectQuery, Types.GetProjectQueryVariables>(GetProjectDocument, options);
}
export function useGetProjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetProjectQuery, Types.GetProjectQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetProjectQuery, Types.GetProjectQueryVariables>(GetProjectDocument, options);
}
export function useGetProjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetProjectQuery, Types.GetProjectQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetProjectQuery, Types.GetProjectQueryVariables>(GetProjectDocument, options);
}
export type GetProjectQueryHookResult = ReturnType<typeof useGetProjectQuery>;
export type GetProjectLazyQueryHookResult = ReturnType<typeof useGetProjectLazyQuery>;
export type GetProjectSuspenseQueryHookResult = ReturnType<typeof useGetProjectSuspenseQuery>;
export type GetProjectQueryResult = Apollo.QueryResult<Types.GetProjectQuery, Types.GetProjectQueryVariables>;
export const GetBillingDetailsForProjectDocument = gql`
  query GetBillingDetailsForProject($project_id: StringID!) {
    billingDetailsForProject(project_id: $project_id) {
      plan {
        aws_mp_subscription {
          customer_identifier
          customer_aws_account_id
          product_code
        }
        type
        interval
        membersLimit
        sessionsLimit
        errorsLimit
        logsLimit
        tracesLimit
        metricsLimit
        sessionsRate
        errorsRate
        logsRate
        tracesRate
        metricsRate
      }
      meter
      membersMeter
      errorsMeter
      logsMeter
      tracesMeter
      metricsMeter
      sessionsBillingLimit
      errorsBillingLimit
      logsBillingLimit
      tracesBillingLimit
      metricsBillingLimit
    }
    project(id: $project_id) {
      workspace {
        id
        billing_period_end
        next_invoice_date
        allow_meter_overage
      }
    }
  }
`;

/**
 * __useGetBillingDetailsForProjectQuery__
 *
 * To run a query within a React component, call `useGetBillingDetailsForProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingDetailsForProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingDetailsForProjectQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *   },
 * });
 */
export function useGetBillingDetailsForProjectQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetBillingDetailsForProjectQuery,
    Types.GetBillingDetailsForProjectQueryVariables
  > &
    ({ variables: Types.GetBillingDetailsForProjectQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetBillingDetailsForProjectQuery, Types.GetBillingDetailsForProjectQueryVariables>(
    GetBillingDetailsForProjectDocument,
    options,
  );
}
export function useGetBillingDetailsForProjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetBillingDetailsForProjectQuery,
    Types.GetBillingDetailsForProjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetBillingDetailsForProjectQuery, Types.GetBillingDetailsForProjectQueryVariables>(
    GetBillingDetailsForProjectDocument,
    options,
  );
}
export function useGetBillingDetailsForProjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types.GetBillingDetailsForProjectQuery,
        Types.GetBillingDetailsForProjectQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GetBillingDetailsForProjectQuery,
    Types.GetBillingDetailsForProjectQueryVariables
  >(GetBillingDetailsForProjectDocument, options);
}
export type GetBillingDetailsForProjectQueryHookResult = ReturnType<typeof useGetBillingDetailsForProjectQuery>;
export type GetBillingDetailsForProjectLazyQueryHookResult = ReturnType<typeof useGetBillingDetailsForProjectLazyQuery>;
export type GetBillingDetailsForProjectSuspenseQueryHookResult = ReturnType<
  typeof useGetBillingDetailsForProjectSuspenseQuery
>;
export type GetBillingDetailsForProjectQueryResult = Apollo.QueryResult<
  Types.GetBillingDetailsForProjectQuery,
  Types.GetBillingDetailsForProjectQueryVariables
>;
export const GetWorkspaceUsageHistoryDocument = gql`
  query GetWorkspaceUsageHistory($workspace_id: ID!, $product_type: ProductType!, $date_range: DateRangeRequiredInput) {
    usageHistory(workspace_id: $workspace_id, product_type: $product_type, date_range: $date_range) {
      usage {
        buckets {
          bucket_id
          bucket_min
          bucket_max
          column
          group
          metric_type
          metric_value
        }
        bucket_count
        sample_factor
      }
    }
  }
`;

/**
 * __useGetWorkspaceUsageHistoryQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceUsageHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceUsageHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceUsageHistoryQuery({
 *   variables: {
 *      workspace_id: // value for 'workspace_id'
 *      product_type: // value for 'product_type'
 *      date_range: // value for 'date_range'
 *   },
 * });
 */
export function useGetWorkspaceUsageHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetWorkspaceUsageHistoryQuery,
    Types.GetWorkspaceUsageHistoryQueryVariables
  > &
    ({ variables: Types.GetWorkspaceUsageHistoryQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetWorkspaceUsageHistoryQuery, Types.GetWorkspaceUsageHistoryQueryVariables>(
    GetWorkspaceUsageHistoryDocument,
    options,
  );
}
export function useGetWorkspaceUsageHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetWorkspaceUsageHistoryQuery,
    Types.GetWorkspaceUsageHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetWorkspaceUsageHistoryQuery, Types.GetWorkspaceUsageHistoryQueryVariables>(
    GetWorkspaceUsageHistoryDocument,
    options,
  );
}
export function useGetWorkspaceUsageHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types.GetWorkspaceUsageHistoryQuery,
        Types.GetWorkspaceUsageHistoryQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetWorkspaceUsageHistoryQuery, Types.GetWorkspaceUsageHistoryQueryVariables>(
    GetWorkspaceUsageHistoryDocument,
    options,
  );
}
export type GetWorkspaceUsageHistoryQueryHookResult = ReturnType<typeof useGetWorkspaceUsageHistoryQuery>;
export type GetWorkspaceUsageHistoryLazyQueryHookResult = ReturnType<typeof useGetWorkspaceUsageHistoryLazyQuery>;
export type GetWorkspaceUsageHistorySuspenseQueryHookResult = ReturnType<
  typeof useGetWorkspaceUsageHistorySuspenseQuery
>;
export type GetWorkspaceUsageHistoryQueryResult = Apollo.QueryResult<
  Types.GetWorkspaceUsageHistoryQuery,
  Types.GetWorkspaceUsageHistoryQueryVariables
>;
export const GetBillingDetailsDocument = gql`
  query GetBillingDetails($workspace_id: ID!) {
    billingDetails(workspace_id: $workspace_id) {
      plan {
        aws_mp_subscription {
          customer_identifier
          customer_aws_account_id
          product_code
        }
        type
        interval
        membersLimit
        sessionsLimit
        errorsLimit
        logsLimit
        tracesLimit
        metricsLimit
        sessionsRate
        errorsRate
        logsRate
        tracesRate
        metricsRate
        enableBillingLimits
      }
      meter
      membersMeter
      errorsMeter
      logsMeter
      tracesMeter
      metricsMeter
      sessionsBillingLimit
      errorsBillingLimit
      logsBillingLimit
      tracesBillingLimit
      metricsBillingLimit
      sessionsDailyAverage
      errorsDailyAverage
      logsDailyAverage
      tracesDailyAverage
      metricsDailyAverage
    }
    subscription_details(workspace_id: $workspace_id) {
      baseAmount
      discount {
        name
        amount
        percent
        until
      }
      lastInvoice {
        amountDue
        amountPaid
        attemptCount
        date
        url
        status
      }
      billingIssue
      billingIngestBlocked
    }
    workspace(id: $workspace_id) {
      id
      billing_period_end
      next_invoice_date
      allow_meter_overage
      retention_period
      errors_retention_period
      logs_retention_period
      traces_retention_period
      metrics_retention_period
      sessions_max_cents
      errors_max_cents
      logs_max_cents
      traces_max_cents
      metrics_max_cents
    }
  }
`;

/**
 * __useGetBillingDetailsQuery__
 *
 * To run a query within a React component, call `useGetBillingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingDetailsQuery({
 *   variables: {
 *      workspace_id: // value for 'workspace_id'
 *   },
 * });
 */
export function useGetBillingDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetBillingDetailsQuery, Types.GetBillingDetailsQueryVariables> &
    ({ variables: Types.GetBillingDetailsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetBillingDetailsQuery, Types.GetBillingDetailsQueryVariables>(
    GetBillingDetailsDocument,
    options,
  );
}
export function useGetBillingDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetBillingDetailsQuery, Types.GetBillingDetailsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetBillingDetailsQuery, Types.GetBillingDetailsQueryVariables>(
    GetBillingDetailsDocument,
    options,
  );
}
export function useGetBillingDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetBillingDetailsQuery, Types.GetBillingDetailsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetBillingDetailsQuery, Types.GetBillingDetailsQueryVariables>(
    GetBillingDetailsDocument,
    options,
  );
}
export type GetBillingDetailsQueryHookResult = ReturnType<typeof useGetBillingDetailsQuery>;
export type GetBillingDetailsLazyQueryHookResult = ReturnType<typeof useGetBillingDetailsLazyQuery>;
export type GetBillingDetailsSuspenseQueryHookResult = ReturnType<typeof useGetBillingDetailsSuspenseQuery>;
export type GetBillingDetailsQueryResult = Apollo.QueryResult<
  Types.GetBillingDetailsQuery,
  Types.GetBillingDetailsQueryVariables
>;
export const GetSubscriptionDetailsDocument = gql`
  query GetSubscriptionDetails($workspace_id: ID!) {
    subscription_details(workspace_id: $workspace_id) {
      baseAmount
      discount {
        name
        amount
        percent
        until
      }
      lastInvoice {
        amountDue
        amountPaid
        attemptCount
        date
        url
        status
      }
      billingIssue
      billingIngestBlocked
    }
  }
`;

/**
 * __useGetSubscriptionDetailsQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionDetailsQuery({
 *   variables: {
 *      workspace_id: // value for 'workspace_id'
 *   },
 * });
 */
export function useGetSubscriptionDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetSubscriptionDetailsQuery, Types.GetSubscriptionDetailsQueryVariables> &
    ({ variables: Types.GetSubscriptionDetailsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetSubscriptionDetailsQuery, Types.GetSubscriptionDetailsQueryVariables>(
    GetSubscriptionDetailsDocument,
    options,
  );
}
export function useGetSubscriptionDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetSubscriptionDetailsQuery,
    Types.GetSubscriptionDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetSubscriptionDetailsQuery, Types.GetSubscriptionDetailsQueryVariables>(
    GetSubscriptionDetailsDocument,
    options,
  );
}
export function useGetSubscriptionDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetSubscriptionDetailsQuery, Types.GetSubscriptionDetailsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetSubscriptionDetailsQuery, Types.GetSubscriptionDetailsQueryVariables>(
    GetSubscriptionDetailsDocument,
    options,
  );
}
export type GetSubscriptionDetailsQueryHookResult = ReturnType<typeof useGetSubscriptionDetailsQuery>;
export type GetSubscriptionDetailsLazyQueryHookResult = ReturnType<typeof useGetSubscriptionDetailsLazyQuery>;
export type GetSubscriptionDetailsSuspenseQueryHookResult = ReturnType<typeof useGetSubscriptionDetailsSuspenseQuery>;
export type GetSubscriptionDetailsQueryResult = Apollo.QueryResult<
  Types.GetSubscriptionDetailsQuery,
  Types.GetSubscriptionDetailsQueryVariables
>;
export const GetErrorGroupDocument = gql`
  query GetErrorGroup($secure_id: String!, $use_clickhouse: Boolean) {
    error_group(secure_id: $secure_id, use_clickhouse: $use_clickhouse) {
      created_at
      updated_at
      id
      secure_id
      type
      project_id
      event
      state
      snoozed_until
      structured_stack_trace {
        fileName
        lineNumber
        functionName
        columnNumber
        lineContent
        linesBefore
        linesAfter
        error
      }
      mapped_stack_trace
      stack_trace
      error_frequency
      error_metrics {
        error_group_id
        date
        name
        value
      }
      is_public
      last_occurrence
      first_occurrence
      serviceName
      jira_issue_links {
        id
        issueKey
        issueUrl
        createdAt
      }
    }
  }
`;

/**
 * __useGetErrorGroupQuery__
 *
 * To run a query within a React component, call `useGetErrorGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetErrorGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetErrorGroupQuery({
 *   variables: {
 *      secure_id: // value for 'secure_id'
 *      use_clickhouse: // value for 'use_clickhouse'
 *   },
 * });
 */
export function useGetErrorGroupQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetErrorGroupQuery, Types.GetErrorGroupQueryVariables> &
    ({ variables: Types.GetErrorGroupQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetErrorGroupQuery, Types.GetErrorGroupQueryVariables>(GetErrorGroupDocument, options);
}
export function useGetErrorGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetErrorGroupQuery, Types.GetErrorGroupQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetErrorGroupQuery, Types.GetErrorGroupQueryVariables>(
    GetErrorGroupDocument,
    options,
  );
}
export function useGetErrorGroupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetErrorGroupQuery, Types.GetErrorGroupQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetErrorGroupQuery, Types.GetErrorGroupQueryVariables>(
    GetErrorGroupDocument,
    options,
  );
}
export type GetErrorGroupQueryHookResult = ReturnType<typeof useGetErrorGroupQuery>;
export type GetErrorGroupLazyQueryHookResult = ReturnType<typeof useGetErrorGroupLazyQuery>;
export type GetErrorGroupSuspenseQueryHookResult = ReturnType<typeof useGetErrorGroupSuspenseQuery>;
export type GetErrorGroupQueryResult = Apollo.QueryResult<Types.GetErrorGroupQuery, Types.GetErrorGroupQueryVariables>;
export const GetErrorObjectForLogDocument = gql`
  query GetErrorObjectForLog($log_cursor: String!) {
    error_object_for_log(log_cursor: $log_cursor) {
      id
      error_group_secure_id
      project_id
    }
  }
`;

/**
 * __useGetErrorObjectForLogQuery__
 *
 * To run a query within a React component, call `useGetErrorObjectForLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetErrorObjectForLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetErrorObjectForLogQuery({
 *   variables: {
 *      log_cursor: // value for 'log_cursor'
 *   },
 * });
 */
export function useGetErrorObjectForLogQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetErrorObjectForLogQuery, Types.GetErrorObjectForLogQueryVariables> &
    ({ variables: Types.GetErrorObjectForLogQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetErrorObjectForLogQuery, Types.GetErrorObjectForLogQueryVariables>(
    GetErrorObjectForLogDocument,
    options,
  );
}
export function useGetErrorObjectForLogLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetErrorObjectForLogQuery, Types.GetErrorObjectForLogQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetErrorObjectForLogQuery, Types.GetErrorObjectForLogQueryVariables>(
    GetErrorObjectForLogDocument,
    options,
  );
}
export function useGetErrorObjectForLogSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetErrorObjectForLogQuery, Types.GetErrorObjectForLogQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetErrorObjectForLogQuery, Types.GetErrorObjectForLogQueryVariables>(
    GetErrorObjectForLogDocument,
    options,
  );
}
export type GetErrorObjectForLogQueryHookResult = ReturnType<typeof useGetErrorObjectForLogQuery>;
export type GetErrorObjectForLogLazyQueryHookResult = ReturnType<typeof useGetErrorObjectForLogLazyQuery>;
export type GetErrorObjectForLogSuspenseQueryHookResult = ReturnType<typeof useGetErrorObjectForLogSuspenseQuery>;
export type GetErrorObjectForLogQueryResult = Apollo.QueryResult<
  Types.GetErrorObjectForLogQuery,
  Types.GetErrorObjectForLogQueryVariables
>;
export const GetErrorObjectDocument = gql`
  query GetErrorObject($id: Int64ID!) {
    error_object(id: $id) {
      ...ErrorObject
    }
  }
  ${ErrorObjectFragmentDoc}
`;

/**
 * __useGetErrorObjectQuery__
 *
 * To run a query within a React component, call `useGetErrorObjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetErrorObjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetErrorObjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetErrorObjectQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetErrorObjectQuery, Types.GetErrorObjectQueryVariables> &
    ({ variables: Types.GetErrorObjectQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetErrorObjectQuery, Types.GetErrorObjectQueryVariables>(
    GetErrorObjectDocument,
    options,
  );
}
export function useGetErrorObjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetErrorObjectQuery, Types.GetErrorObjectQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetErrorObjectQuery, Types.GetErrorObjectQueryVariables>(
    GetErrorObjectDocument,
    options,
  );
}
export function useGetErrorObjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetErrorObjectQuery, Types.GetErrorObjectQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetErrorObjectQuery, Types.GetErrorObjectQueryVariables>(
    GetErrorObjectDocument,
    options,
  );
}
export type GetErrorObjectQueryHookResult = ReturnType<typeof useGetErrorObjectQuery>;
export type GetErrorObjectLazyQueryHookResult = ReturnType<typeof useGetErrorObjectLazyQuery>;
export type GetErrorObjectSuspenseQueryHookResult = ReturnType<typeof useGetErrorObjectSuspenseQuery>;
export type GetErrorObjectQueryResult = Apollo.QueryResult<
  Types.GetErrorObjectQuery,
  Types.GetErrorObjectQueryVariables
>;
export const GetErrorInstanceDocument = gql`
  query GetErrorInstance($error_group_secure_id: String!, $error_object_id: ID, $params: QueryInput) {
    error_instance(error_group_secure_id: $error_group_secure_id, error_object_id: $error_object_id, params: $params) {
      error_object {
        ...ErrorObject
      }
      next_id
      previous_id
    }
  }
  ${ErrorObjectFragmentDoc}
`;

/**
 * __useGetErrorInstanceQuery__
 *
 * To run a query within a React component, call `useGetErrorInstanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetErrorInstanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetErrorInstanceQuery({
 *   variables: {
 *      error_group_secure_id: // value for 'error_group_secure_id'
 *      error_object_id: // value for 'error_object_id'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetErrorInstanceQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetErrorInstanceQuery, Types.GetErrorInstanceQueryVariables> &
    ({ variables: Types.GetErrorInstanceQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetErrorInstanceQuery, Types.GetErrorInstanceQueryVariables>(
    GetErrorInstanceDocument,
    options,
  );
}
export function useGetErrorInstanceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetErrorInstanceQuery, Types.GetErrorInstanceQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetErrorInstanceQuery, Types.GetErrorInstanceQueryVariables>(
    GetErrorInstanceDocument,
    options,
  );
}
export function useGetErrorInstanceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetErrorInstanceQuery, Types.GetErrorInstanceQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetErrorInstanceQuery, Types.GetErrorInstanceQueryVariables>(
    GetErrorInstanceDocument,
    options,
  );
}
export type GetErrorInstanceQueryHookResult = ReturnType<typeof useGetErrorInstanceQuery>;
export type GetErrorInstanceLazyQueryHookResult = ReturnType<typeof useGetErrorInstanceLazyQuery>;
export type GetErrorInstanceSuspenseQueryHookResult = ReturnType<typeof useGetErrorInstanceSuspenseQuery>;
export type GetErrorInstanceQueryResult = Apollo.QueryResult<
  Types.GetErrorInstanceQuery,
  Types.GetErrorInstanceQueryVariables
>;
export const GetResourcesDocument = gql`
  query GetResources($session_secure_id: String!) {
    resources(session_secure_id: $session_secure_id)
  }
`;

/**
 * __useGetResourcesQuery__
 *
 * To run a query within a React component, call `useGetResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourcesQuery({
 *   variables: {
 *      session_secure_id: // value for 'session_secure_id'
 *   },
 * });
 */
export function useGetResourcesQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetResourcesQuery, Types.GetResourcesQueryVariables> &
    ({ variables: Types.GetResourcesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetResourcesQuery, Types.GetResourcesQueryVariables>(GetResourcesDocument, options);
}
export function useGetResourcesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetResourcesQuery, Types.GetResourcesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetResourcesQuery, Types.GetResourcesQueryVariables>(GetResourcesDocument, options);
}
export function useGetResourcesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetResourcesQuery, Types.GetResourcesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetResourcesQuery, Types.GetResourcesQueryVariables>(
    GetResourcesDocument,
    options,
  );
}
export type GetResourcesQueryHookResult = ReturnType<typeof useGetResourcesQuery>;
export type GetResourcesLazyQueryHookResult = ReturnType<typeof useGetResourcesLazyQuery>;
export type GetResourcesSuspenseQueryHookResult = ReturnType<typeof useGetResourcesSuspenseQuery>;
export type GetResourcesQueryResult = Apollo.QueryResult<Types.GetResourcesQuery, Types.GetResourcesQueryVariables>;
export const GetProjectSuggestionDocument = gql`
  query GetProjectSuggestion($query: String!) {
    projectSuggestion(query: $query) {
      id
      name
      workspace_id
    }
  }
`;

/**
 * __useGetProjectSuggestionQuery__
 *
 * To run a query within a React component, call `useGetProjectSuggestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectSuggestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectSuggestionQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetProjectSuggestionQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetProjectSuggestionQuery, Types.GetProjectSuggestionQueryVariables> &
    ({ variables: Types.GetProjectSuggestionQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetProjectSuggestionQuery, Types.GetProjectSuggestionQueryVariables>(
    GetProjectSuggestionDocument,
    options,
  );
}
export function useGetProjectSuggestionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetProjectSuggestionQuery, Types.GetProjectSuggestionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetProjectSuggestionQuery, Types.GetProjectSuggestionQueryVariables>(
    GetProjectSuggestionDocument,
    options,
  );
}
export function useGetProjectSuggestionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetProjectSuggestionQuery, Types.GetProjectSuggestionQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetProjectSuggestionQuery, Types.GetProjectSuggestionQueryVariables>(
    GetProjectSuggestionDocument,
    options,
  );
}
export type GetProjectSuggestionQueryHookResult = ReturnType<typeof useGetProjectSuggestionQuery>;
export type GetProjectSuggestionLazyQueryHookResult = ReturnType<typeof useGetProjectSuggestionLazyQuery>;
export type GetProjectSuggestionSuspenseQueryHookResult = ReturnType<typeof useGetProjectSuggestionSuspenseQuery>;
export type GetProjectSuggestionQueryResult = Apollo.QueryResult<
  Types.GetProjectSuggestionQuery,
  Types.GetProjectSuggestionQueryVariables
>;
export const GetSavedSegmentsDocument = gql`
  query GetSavedSegments($project_id: StringID!, $entity_type: SavedSegmentEntityType!) {
    saved_segments(project_id: $project_id, entity_type: $entity_type) {
      id
      name
      params {
        bucket_by_key
        bucket_count
        bucket_interval
        expressions {
          aggregator
          column
        }
        graph_type
        group_by_keys
        limit
        limit_function_type
        limit_metric
        query
      }
    }
  }
`;

/**
 * __useGetSavedSegmentsQuery__
 *
 * To run a query within a React component, call `useGetSavedSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedSegmentsQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      entity_type: // value for 'entity_type'
 *   },
 * });
 */
export function useGetSavedSegmentsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetSavedSegmentsQuery, Types.GetSavedSegmentsQueryVariables> &
    ({ variables: Types.GetSavedSegmentsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetSavedSegmentsQuery, Types.GetSavedSegmentsQueryVariables>(
    GetSavedSegmentsDocument,
    options,
  );
}
export function useGetSavedSegmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSavedSegmentsQuery, Types.GetSavedSegmentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetSavedSegmentsQuery, Types.GetSavedSegmentsQueryVariables>(
    GetSavedSegmentsDocument,
    options,
  );
}
export function useGetSavedSegmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetSavedSegmentsQuery, Types.GetSavedSegmentsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetSavedSegmentsQuery, Types.GetSavedSegmentsQueryVariables>(
    GetSavedSegmentsDocument,
    options,
  );
}
export type GetSavedSegmentsQueryHookResult = ReturnType<typeof useGetSavedSegmentsQuery>;
export type GetSavedSegmentsLazyQueryHookResult = ReturnType<typeof useGetSavedSegmentsLazyQuery>;
export type GetSavedSegmentsSuspenseQueryHookResult = ReturnType<typeof useGetSavedSegmentsSuspenseQuery>;
export type GetSavedSegmentsQueryResult = Apollo.QueryResult<
  Types.GetSavedSegmentsQuery,
  Types.GetSavedSegmentsQueryVariables
>;
export const GetClientIntegrationDocument = gql`
  query GetClientIntegration($project_id: StringID!) {
    clientIntegration(project_id: $project_id) {
      integrated
      resourceType
      createdAt
    }
  }
`;

/**
 * __useGetClientIntegrationQuery__
 *
 * To run a query within a React component, call `useGetClientIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientIntegrationQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *   },
 * });
 */
export function useGetClientIntegrationQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetClientIntegrationQuery, Types.GetClientIntegrationQueryVariables> &
    ({ variables: Types.GetClientIntegrationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetClientIntegrationQuery, Types.GetClientIntegrationQueryVariables>(
    GetClientIntegrationDocument,
    options,
  );
}
export function useGetClientIntegrationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetClientIntegrationQuery, Types.GetClientIntegrationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetClientIntegrationQuery, Types.GetClientIntegrationQueryVariables>(
    GetClientIntegrationDocument,
    options,
  );
}
export function useGetClientIntegrationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetClientIntegrationQuery, Types.GetClientIntegrationQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetClientIntegrationQuery, Types.GetClientIntegrationQueryVariables>(
    GetClientIntegrationDocument,
    options,
  );
}
export type GetClientIntegrationQueryHookResult = ReturnType<typeof useGetClientIntegrationQuery>;
export type GetClientIntegrationLazyQueryHookResult = ReturnType<typeof useGetClientIntegrationLazyQuery>;
export type GetClientIntegrationSuspenseQueryHookResult = ReturnType<typeof useGetClientIntegrationSuspenseQuery>;
export type GetClientIntegrationQueryResult = Apollo.QueryResult<
  Types.GetClientIntegrationQuery,
  Types.GetClientIntegrationQueryVariables
>;
export const GetServerIntegrationDocument = gql`
  query GetServerIntegration($project_id: StringID!) {
    serverIntegration(project_id: $project_id) {
      integrated
      resourceType
      createdAt
    }
  }
`;

/**
 * __useGetServerIntegrationQuery__
 *
 * To run a query within a React component, call `useGetServerIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServerIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServerIntegrationQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *   },
 * });
 */
export function useGetServerIntegrationQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetServerIntegrationQuery, Types.GetServerIntegrationQueryVariables> &
    ({ variables: Types.GetServerIntegrationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetServerIntegrationQuery, Types.GetServerIntegrationQueryVariables>(
    GetServerIntegrationDocument,
    options,
  );
}
export function useGetServerIntegrationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetServerIntegrationQuery, Types.GetServerIntegrationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetServerIntegrationQuery, Types.GetServerIntegrationQueryVariables>(
    GetServerIntegrationDocument,
    options,
  );
}
export function useGetServerIntegrationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetServerIntegrationQuery, Types.GetServerIntegrationQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetServerIntegrationQuery, Types.GetServerIntegrationQueryVariables>(
    GetServerIntegrationDocument,
    options,
  );
}
export type GetServerIntegrationQueryHookResult = ReturnType<typeof useGetServerIntegrationQuery>;
export type GetServerIntegrationLazyQueryHookResult = ReturnType<typeof useGetServerIntegrationLazyQuery>;
export type GetServerIntegrationSuspenseQueryHookResult = ReturnType<typeof useGetServerIntegrationSuspenseQuery>;
export type GetServerIntegrationQueryResult = Apollo.QueryResult<
  Types.GetServerIntegrationQuery,
  Types.GetServerIntegrationQueryVariables
>;
export const GetLogsIntegrationDocument = gql`
  query GetLogsIntegration($project_id: StringID!) {
    logsIntegration(project_id: $project_id) {
      integrated
      resourceType
      createdAt
    }
  }
`;

/**
 * __useGetLogsIntegrationQuery__
 *
 * To run a query within a React component, call `useGetLogsIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLogsIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLogsIntegrationQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *   },
 * });
 */
export function useGetLogsIntegrationQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetLogsIntegrationQuery, Types.GetLogsIntegrationQueryVariables> &
    ({ variables: Types.GetLogsIntegrationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetLogsIntegrationQuery, Types.GetLogsIntegrationQueryVariables>(
    GetLogsIntegrationDocument,
    options,
  );
}
export function useGetLogsIntegrationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetLogsIntegrationQuery, Types.GetLogsIntegrationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetLogsIntegrationQuery, Types.GetLogsIntegrationQueryVariables>(
    GetLogsIntegrationDocument,
    options,
  );
}
export function useGetLogsIntegrationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetLogsIntegrationQuery, Types.GetLogsIntegrationQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetLogsIntegrationQuery, Types.GetLogsIntegrationQueryVariables>(
    GetLogsIntegrationDocument,
    options,
  );
}
export type GetLogsIntegrationQueryHookResult = ReturnType<typeof useGetLogsIntegrationQuery>;
export type GetLogsIntegrationLazyQueryHookResult = ReturnType<typeof useGetLogsIntegrationLazyQuery>;
export type GetLogsIntegrationSuspenseQueryHookResult = ReturnType<typeof useGetLogsIntegrationSuspenseQuery>;
export type GetLogsIntegrationQueryResult = Apollo.QueryResult<
  Types.GetLogsIntegrationQuery,
  Types.GetLogsIntegrationQueryVariables
>;
export const GetTracesIntegrationDocument = gql`
  query GetTracesIntegration($project_id: StringID!) {
    tracesIntegration(project_id: $project_id) {
      integrated
      resourceType
      createdAt
    }
  }
`;

/**
 * __useGetTracesIntegrationQuery__
 *
 * To run a query within a React component, call `useGetTracesIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTracesIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTracesIntegrationQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *   },
 * });
 */
export function useGetTracesIntegrationQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetTracesIntegrationQuery, Types.GetTracesIntegrationQueryVariables> &
    ({ variables: Types.GetTracesIntegrationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetTracesIntegrationQuery, Types.GetTracesIntegrationQueryVariables>(
    GetTracesIntegrationDocument,
    options,
  );
}
export function useGetTracesIntegrationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetTracesIntegrationQuery, Types.GetTracesIntegrationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetTracesIntegrationQuery, Types.GetTracesIntegrationQueryVariables>(
    GetTracesIntegrationDocument,
    options,
  );
}
export function useGetTracesIntegrationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetTracesIntegrationQuery, Types.GetTracesIntegrationQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetTracesIntegrationQuery, Types.GetTracesIntegrationQueryVariables>(
    GetTracesIntegrationDocument,
    options,
  );
}
export type GetTracesIntegrationQueryHookResult = ReturnType<typeof useGetTracesIntegrationQuery>;
export type GetTracesIntegrationLazyQueryHookResult = ReturnType<typeof useGetTracesIntegrationLazyQuery>;
export type GetTracesIntegrationSuspenseQueryHookResult = ReturnType<typeof useGetTracesIntegrationSuspenseQuery>;
export type GetTracesIntegrationQueryResult = Apollo.QueryResult<
  Types.GetTracesIntegrationQuery,
  Types.GetTracesIntegrationQueryVariables
>;
export const GetMetricsIntegrationDocument = gql`
  query GetMetricsIntegration($project_id: StringID!) {
    metricsIntegration(project_id: $project_id) {
      integrated
      resourceType
      createdAt
    }
  }
`;

/**
 * __useGetMetricsIntegrationQuery__
 *
 * To run a query within a React component, call `useGetMetricsIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricsIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricsIntegrationQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *   },
 * });
 */
export function useGetMetricsIntegrationQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetMetricsIntegrationQuery, Types.GetMetricsIntegrationQueryVariables> &
    ({ variables: Types.GetMetricsIntegrationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetMetricsIntegrationQuery, Types.GetMetricsIntegrationQueryVariables>(
    GetMetricsIntegrationDocument,
    options,
  );
}
export function useGetMetricsIntegrationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetMetricsIntegrationQuery,
    Types.GetMetricsIntegrationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetMetricsIntegrationQuery, Types.GetMetricsIntegrationQueryVariables>(
    GetMetricsIntegrationDocument,
    options,
  );
}
export function useGetMetricsIntegrationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetMetricsIntegrationQuery, Types.GetMetricsIntegrationQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetMetricsIntegrationQuery, Types.GetMetricsIntegrationQueryVariables>(
    GetMetricsIntegrationDocument,
    options,
  );
}
export type GetMetricsIntegrationQueryHookResult = ReturnType<typeof useGetMetricsIntegrationQuery>;
export type GetMetricsIntegrationLazyQueryHookResult = ReturnType<typeof useGetMetricsIntegrationLazyQuery>;
export type GetMetricsIntegrationSuspenseQueryHookResult = ReturnType<typeof useGetMetricsIntegrationSuspenseQuery>;
export type GetMetricsIntegrationQueryResult = Apollo.QueryResult<
  Types.GetMetricsIntegrationQuery,
  Types.GetMetricsIntegrationQueryVariables
>;
export const GetKeyPerformanceIndicatorsDocument = gql`
  query GetKeyPerformanceIndicators($project_id: ID!, $lookback_days: Float!) {
    unprocessedSessionsCount(project_id: $project_id)
    liveUsersCount(project_id: $project_id)
    newUsersCount(project_id: $project_id, lookback_days: $lookback_days) {
      count
    }
    averageSessionLength(project_id: $project_id, lookback_days: $lookback_days) {
      length
    }
    userFingerprintCount(project_id: $project_id, lookback_days: $lookback_days) {
      count
    }
  }
`;

/**
 * __useGetKeyPerformanceIndicatorsQuery__
 *
 * To run a query within a React component, call `useGetKeyPerformanceIndicatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKeyPerformanceIndicatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKeyPerformanceIndicatorsQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      lookback_days: // value for 'lookback_days'
 *   },
 * });
 */
export function useGetKeyPerformanceIndicatorsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetKeyPerformanceIndicatorsQuery,
    Types.GetKeyPerformanceIndicatorsQueryVariables
  > &
    ({ variables: Types.GetKeyPerformanceIndicatorsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetKeyPerformanceIndicatorsQuery, Types.GetKeyPerformanceIndicatorsQueryVariables>(
    GetKeyPerformanceIndicatorsDocument,
    options,
  );
}
export function useGetKeyPerformanceIndicatorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetKeyPerformanceIndicatorsQuery,
    Types.GetKeyPerformanceIndicatorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetKeyPerformanceIndicatorsQuery, Types.GetKeyPerformanceIndicatorsQueryVariables>(
    GetKeyPerformanceIndicatorsDocument,
    options,
  );
}
export function useGetKeyPerformanceIndicatorsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types.GetKeyPerformanceIndicatorsQuery,
        Types.GetKeyPerformanceIndicatorsQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GetKeyPerformanceIndicatorsQuery,
    Types.GetKeyPerformanceIndicatorsQueryVariables
  >(GetKeyPerformanceIndicatorsDocument, options);
}
export type GetKeyPerformanceIndicatorsQueryHookResult = ReturnType<typeof useGetKeyPerformanceIndicatorsQuery>;
export type GetKeyPerformanceIndicatorsLazyQueryHookResult = ReturnType<typeof useGetKeyPerformanceIndicatorsLazyQuery>;
export type GetKeyPerformanceIndicatorsSuspenseQueryHookResult = ReturnType<
  typeof useGetKeyPerformanceIndicatorsSuspenseQuery
>;
export type GetKeyPerformanceIndicatorsQueryResult = Apollo.QueryResult<
  Types.GetKeyPerformanceIndicatorsQuery,
  Types.GetKeyPerformanceIndicatorsQueryVariables
>;
export const GetReferrersCountDocument = gql`
  query GetReferrersCount($project_id: ID!, $lookback_days: Float!) {
    referrers(project_id: $project_id, lookback_days: $lookback_days) {
      host
      count
      percent
    }
  }
`;

/**
 * __useGetReferrersCountQuery__
 *
 * To run a query within a React component, call `useGetReferrersCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferrersCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferrersCountQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      lookback_days: // value for 'lookback_days'
 *   },
 * });
 */
export function useGetReferrersCountQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetReferrersCountQuery, Types.GetReferrersCountQueryVariables> &
    ({ variables: Types.GetReferrersCountQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetReferrersCountQuery, Types.GetReferrersCountQueryVariables>(
    GetReferrersCountDocument,
    options,
  );
}
export function useGetReferrersCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetReferrersCountQuery, Types.GetReferrersCountQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetReferrersCountQuery, Types.GetReferrersCountQueryVariables>(
    GetReferrersCountDocument,
    options,
  );
}
export function useGetReferrersCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetReferrersCountQuery, Types.GetReferrersCountQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetReferrersCountQuery, Types.GetReferrersCountQueryVariables>(
    GetReferrersCountDocument,
    options,
  );
}
export type GetReferrersCountQueryHookResult = ReturnType<typeof useGetReferrersCountQuery>;
export type GetReferrersCountLazyQueryHookResult = ReturnType<typeof useGetReferrersCountLazyQuery>;
export type GetReferrersCountSuspenseQueryHookResult = ReturnType<typeof useGetReferrersCountSuspenseQuery>;
export type GetReferrersCountQueryResult = Apollo.QueryResult<
  Types.GetReferrersCountQuery,
  Types.GetReferrersCountQueryVariables
>;
export const GetNewUsersCountDocument = gql`
  query GetNewUsersCount($project_id: ID!, $lookback_days: Float!) {
    newUsersCount(project_id: $project_id, lookback_days: $lookback_days) {
      count
    }
  }
`;

/**
 * __useGetNewUsersCountQuery__
 *
 * To run a query within a React component, call `useGetNewUsersCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewUsersCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewUsersCountQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      lookback_days: // value for 'lookback_days'
 *   },
 * });
 */
export function useGetNewUsersCountQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetNewUsersCountQuery, Types.GetNewUsersCountQueryVariables> &
    ({ variables: Types.GetNewUsersCountQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetNewUsersCountQuery, Types.GetNewUsersCountQueryVariables>(
    GetNewUsersCountDocument,
    options,
  );
}
export function useGetNewUsersCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetNewUsersCountQuery, Types.GetNewUsersCountQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetNewUsersCountQuery, Types.GetNewUsersCountQueryVariables>(
    GetNewUsersCountDocument,
    options,
  );
}
export function useGetNewUsersCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetNewUsersCountQuery, Types.GetNewUsersCountQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetNewUsersCountQuery, Types.GetNewUsersCountQueryVariables>(
    GetNewUsersCountDocument,
    options,
  );
}
export type GetNewUsersCountQueryHookResult = ReturnType<typeof useGetNewUsersCountQuery>;
export type GetNewUsersCountLazyQueryHookResult = ReturnType<typeof useGetNewUsersCountLazyQuery>;
export type GetNewUsersCountSuspenseQueryHookResult = ReturnType<typeof useGetNewUsersCountSuspenseQuery>;
export type GetNewUsersCountQueryResult = Apollo.QueryResult<
  Types.GetNewUsersCountQuery,
  Types.GetNewUsersCountQueryVariables
>;
export const GetAverageSessionLengthDocument = gql`
  query GetAverageSessionLength($project_id: ID!, $lookback_days: Float!) {
    averageSessionLength(project_id: $project_id, lookback_days: $lookback_days) {
      length
    }
  }
`;

/**
 * __useGetAverageSessionLengthQuery__
 *
 * To run a query within a React component, call `useGetAverageSessionLengthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAverageSessionLengthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAverageSessionLengthQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      lookback_days: // value for 'lookback_days'
 *   },
 * });
 */
export function useGetAverageSessionLengthQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetAverageSessionLengthQuery,
    Types.GetAverageSessionLengthQueryVariables
  > &
    ({ variables: Types.GetAverageSessionLengthQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetAverageSessionLengthQuery, Types.GetAverageSessionLengthQueryVariables>(
    GetAverageSessionLengthDocument,
    options,
  );
}
export function useGetAverageSessionLengthLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetAverageSessionLengthQuery,
    Types.GetAverageSessionLengthQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetAverageSessionLengthQuery, Types.GetAverageSessionLengthQueryVariables>(
    GetAverageSessionLengthDocument,
    options,
  );
}
export function useGetAverageSessionLengthSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetAverageSessionLengthQuery, Types.GetAverageSessionLengthQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetAverageSessionLengthQuery, Types.GetAverageSessionLengthQueryVariables>(
    GetAverageSessionLengthDocument,
    options,
  );
}
export type GetAverageSessionLengthQueryHookResult = ReturnType<typeof useGetAverageSessionLengthQuery>;
export type GetAverageSessionLengthLazyQueryHookResult = ReturnType<typeof useGetAverageSessionLengthLazyQuery>;
export type GetAverageSessionLengthSuspenseQueryHookResult = ReturnType<typeof useGetAverageSessionLengthSuspenseQuery>;
export type GetAverageSessionLengthQueryResult = Apollo.QueryResult<
  Types.GetAverageSessionLengthQuery,
  Types.GetAverageSessionLengthQueryVariables
>;
export const GetTopUsersDocument = gql`
  query GetTopUsers($project_id: ID!, $lookback_days: Float!) {
    topUsers(project_id: $project_id, lookback_days: $lookback_days) {
      identifier
      total_active_time
      active_time_percentage
      id
      user_properties
    }
  }
`;

/**
 * __useGetTopUsersQuery__
 *
 * To run a query within a React component, call `useGetTopUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopUsersQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      lookback_days: // value for 'lookback_days'
 *   },
 * });
 */
export function useGetTopUsersQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetTopUsersQuery, Types.GetTopUsersQueryVariables> &
    ({ variables: Types.GetTopUsersQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetTopUsersQuery, Types.GetTopUsersQueryVariables>(GetTopUsersDocument, options);
}
export function useGetTopUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetTopUsersQuery, Types.GetTopUsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetTopUsersQuery, Types.GetTopUsersQueryVariables>(GetTopUsersDocument, options);
}
export function useGetTopUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetTopUsersQuery, Types.GetTopUsersQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetTopUsersQuery, Types.GetTopUsersQueryVariables>(GetTopUsersDocument, options);
}
export type GetTopUsersQueryHookResult = ReturnType<typeof useGetTopUsersQuery>;
export type GetTopUsersLazyQueryHookResult = ReturnType<typeof useGetTopUsersLazyQuery>;
export type GetTopUsersSuspenseQueryHookResult = ReturnType<typeof useGetTopUsersSuspenseQuery>;
export type GetTopUsersQueryResult = Apollo.QueryResult<Types.GetTopUsersQuery, Types.GetTopUsersQueryVariables>;
export const GetDailySessionsCountDocument = gql`
  query GetDailySessionsCount($project_id: ID!, $date_range: DateRangeInput!) {
    dailySessionsCount(project_id: $project_id, date_range: $date_range) {
      date
      count
    }
  }
`;

/**
 * __useGetDailySessionsCountQuery__
 *
 * To run a query within a React component, call `useGetDailySessionsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailySessionsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailySessionsCountQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      date_range: // value for 'date_range'
 *   },
 * });
 */
export function useGetDailySessionsCountQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetDailySessionsCountQuery, Types.GetDailySessionsCountQueryVariables> &
    ({ variables: Types.GetDailySessionsCountQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetDailySessionsCountQuery, Types.GetDailySessionsCountQueryVariables>(
    GetDailySessionsCountDocument,
    options,
  );
}
export function useGetDailySessionsCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetDailySessionsCountQuery,
    Types.GetDailySessionsCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetDailySessionsCountQuery, Types.GetDailySessionsCountQueryVariables>(
    GetDailySessionsCountDocument,
    options,
  );
}
export function useGetDailySessionsCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetDailySessionsCountQuery, Types.GetDailySessionsCountQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetDailySessionsCountQuery, Types.GetDailySessionsCountQueryVariables>(
    GetDailySessionsCountDocument,
    options,
  );
}
export type GetDailySessionsCountQueryHookResult = ReturnType<typeof useGetDailySessionsCountQuery>;
export type GetDailySessionsCountLazyQueryHookResult = ReturnType<typeof useGetDailySessionsCountLazyQuery>;
export type GetDailySessionsCountSuspenseQueryHookResult = ReturnType<typeof useGetDailySessionsCountSuspenseQuery>;
export type GetDailySessionsCountQueryResult = Apollo.QueryResult<
  Types.GetDailySessionsCountQuery,
  Types.GetDailySessionsCountQueryVariables
>;
export const GetDailyErrorsCountDocument = gql`
  query GetDailyErrorsCount($project_id: ID!, $date_range: DateRangeInput!) {
    dailyErrorsCount(project_id: $project_id, date_range: $date_range) {
      date
      count
    }
  }
`;

/**
 * __useGetDailyErrorsCountQuery__
 *
 * To run a query within a React component, call `useGetDailyErrorsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyErrorsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyErrorsCountQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      date_range: // value for 'date_range'
 *   },
 * });
 */
export function useGetDailyErrorsCountQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetDailyErrorsCountQuery, Types.GetDailyErrorsCountQueryVariables> &
    ({ variables: Types.GetDailyErrorsCountQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetDailyErrorsCountQuery, Types.GetDailyErrorsCountQueryVariables>(
    GetDailyErrorsCountDocument,
    options,
  );
}
export function useGetDailyErrorsCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetDailyErrorsCountQuery, Types.GetDailyErrorsCountQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetDailyErrorsCountQuery, Types.GetDailyErrorsCountQueryVariables>(
    GetDailyErrorsCountDocument,
    options,
  );
}
export function useGetDailyErrorsCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetDailyErrorsCountQuery, Types.GetDailyErrorsCountQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetDailyErrorsCountQuery, Types.GetDailyErrorsCountQueryVariables>(
    GetDailyErrorsCountDocument,
    options,
  );
}
export type GetDailyErrorsCountQueryHookResult = ReturnType<typeof useGetDailyErrorsCountQuery>;
export type GetDailyErrorsCountLazyQueryHookResult = ReturnType<typeof useGetDailyErrorsCountLazyQuery>;
export type GetDailyErrorsCountSuspenseQueryHookResult = ReturnType<typeof useGetDailyErrorsCountSuspenseQuery>;
export type GetDailyErrorsCountQueryResult = Apollo.QueryResult<
  Types.GetDailyErrorsCountQuery,
  Types.GetDailyErrorsCountQueryVariables
>;
export const GetRageClicksForProjectDocument = gql`
  query GetRageClicksForProject($project_id: ID!, $lookback_days: Float!) {
    rageClicksForProject(project_id: $project_id, lookback_days: $lookback_days) {
      identifier
      session_secure_id
      total_clicks
      user_properties
    }
  }
`;

/**
 * __useGetRageClicksForProjectQuery__
 *
 * To run a query within a React component, call `useGetRageClicksForProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRageClicksForProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRageClicksForProjectQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      lookback_days: // value for 'lookback_days'
 *   },
 * });
 */
export function useGetRageClicksForProjectQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetRageClicksForProjectQuery,
    Types.GetRageClicksForProjectQueryVariables
  > &
    ({ variables: Types.GetRageClicksForProjectQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetRageClicksForProjectQuery, Types.GetRageClicksForProjectQueryVariables>(
    GetRageClicksForProjectDocument,
    options,
  );
}
export function useGetRageClicksForProjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetRageClicksForProjectQuery,
    Types.GetRageClicksForProjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetRageClicksForProjectQuery, Types.GetRageClicksForProjectQueryVariables>(
    GetRageClicksForProjectDocument,
    options,
  );
}
export function useGetRageClicksForProjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetRageClicksForProjectQuery, Types.GetRageClicksForProjectQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetRageClicksForProjectQuery, Types.GetRageClicksForProjectQueryVariables>(
    GetRageClicksForProjectDocument,
    options,
  );
}
export type GetRageClicksForProjectQueryHookResult = ReturnType<typeof useGetRageClicksForProjectQuery>;
export type GetRageClicksForProjectLazyQueryHookResult = ReturnType<typeof useGetRageClicksForProjectLazyQuery>;
export type GetRageClicksForProjectSuspenseQueryHookResult = ReturnType<typeof useGetRageClicksForProjectSuspenseQuery>;
export type GetRageClicksForProjectQueryResult = Apollo.QueryResult<
  Types.GetRageClicksForProjectQuery,
  Types.GetRageClicksForProjectQueryVariables
>;
export const GetDailyErrorFrequencyDocument = gql`
  query GetDailyErrorFrequency($project_id: ID!, $error_group_secure_id: String!, $date_offset: Int!) {
    dailyErrorFrequency(
      project_id: $project_id
      error_group_secure_id: $error_group_secure_id
      date_offset: $date_offset
    )
  }
`;

/**
 * __useGetDailyErrorFrequencyQuery__
 *
 * To run a query within a React component, call `useGetDailyErrorFrequencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyErrorFrequencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyErrorFrequencyQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      error_group_secure_id: // value for 'error_group_secure_id'
 *      date_offset: // value for 'date_offset'
 *   },
 * });
 */
export function useGetDailyErrorFrequencyQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetDailyErrorFrequencyQuery, Types.GetDailyErrorFrequencyQueryVariables> &
    ({ variables: Types.GetDailyErrorFrequencyQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetDailyErrorFrequencyQuery, Types.GetDailyErrorFrequencyQueryVariables>(
    GetDailyErrorFrequencyDocument,
    options,
  );
}
export function useGetDailyErrorFrequencyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetDailyErrorFrequencyQuery,
    Types.GetDailyErrorFrequencyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetDailyErrorFrequencyQuery, Types.GetDailyErrorFrequencyQueryVariables>(
    GetDailyErrorFrequencyDocument,
    options,
  );
}
export function useGetDailyErrorFrequencySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetDailyErrorFrequencyQuery, Types.GetDailyErrorFrequencyQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetDailyErrorFrequencyQuery, Types.GetDailyErrorFrequencyQueryVariables>(
    GetDailyErrorFrequencyDocument,
    options,
  );
}
export type GetDailyErrorFrequencyQueryHookResult = ReturnType<typeof useGetDailyErrorFrequencyQuery>;
export type GetDailyErrorFrequencyLazyQueryHookResult = ReturnType<typeof useGetDailyErrorFrequencyLazyQuery>;
export type GetDailyErrorFrequencySuspenseQueryHookResult = ReturnType<typeof useGetDailyErrorFrequencySuspenseQuery>;
export type GetDailyErrorFrequencyQueryResult = Apollo.QueryResult<
  Types.GetDailyErrorFrequencyQuery,
  Types.GetDailyErrorFrequencyQueryVariables
>;
export const GetSlackChannelSuggestionDocument = gql`
  query GetSlackChannelSuggestion($project_id: ID!) {
    slack_channel_suggestion(project_id: $project_id) {
      webhook_channel
      webhook_channel_id
    }
  }
`;

/**
 * __useGetSlackChannelSuggestionQuery__
 *
 * To run a query within a React component, call `useGetSlackChannelSuggestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSlackChannelSuggestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSlackChannelSuggestionQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *   },
 * });
 */
export function useGetSlackChannelSuggestionQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetSlackChannelSuggestionQuery,
    Types.GetSlackChannelSuggestionQueryVariables
  > &
    ({ variables: Types.GetSlackChannelSuggestionQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetSlackChannelSuggestionQuery, Types.GetSlackChannelSuggestionQueryVariables>(
    GetSlackChannelSuggestionDocument,
    options,
  );
}
export function useGetSlackChannelSuggestionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetSlackChannelSuggestionQuery,
    Types.GetSlackChannelSuggestionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetSlackChannelSuggestionQuery, Types.GetSlackChannelSuggestionQueryVariables>(
    GetSlackChannelSuggestionDocument,
    options,
  );
}
export function useGetSlackChannelSuggestionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types.GetSlackChannelSuggestionQuery,
        Types.GetSlackChannelSuggestionQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetSlackChannelSuggestionQuery, Types.GetSlackChannelSuggestionQueryVariables>(
    GetSlackChannelSuggestionDocument,
    options,
  );
}
export type GetSlackChannelSuggestionQueryHookResult = ReturnType<typeof useGetSlackChannelSuggestionQuery>;
export type GetSlackChannelSuggestionLazyQueryHookResult = ReturnType<typeof useGetSlackChannelSuggestionLazyQuery>;
export type GetSlackChannelSuggestionSuspenseQueryHookResult = ReturnType<
  typeof useGetSlackChannelSuggestionSuspenseQuery
>;
export type GetSlackChannelSuggestionQueryResult = Apollo.QueryResult<
  Types.GetSlackChannelSuggestionQuery,
  Types.GetSlackChannelSuggestionQueryVariables
>;
export const GetWorkspaceIsIntegratedWithSlackDocument = gql`
  query GetWorkspaceIsIntegratedWithSlack($project_id: StringID!) {
    is_integrated_with_slack: is_integrated_with(integration_type: Slack, project_id: $project_id)
  }
`;

/**
 * __useGetWorkspaceIsIntegratedWithSlackQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceIsIntegratedWithSlackQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceIsIntegratedWithSlackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceIsIntegratedWithSlackQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *   },
 * });
 */
export function useGetWorkspaceIsIntegratedWithSlackQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetWorkspaceIsIntegratedWithSlackQuery,
    Types.GetWorkspaceIsIntegratedWithSlackQueryVariables
  > &
    ({ variables: Types.GetWorkspaceIsIntegratedWithSlackQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GetWorkspaceIsIntegratedWithSlackQuery,
    Types.GetWorkspaceIsIntegratedWithSlackQueryVariables
  >(GetWorkspaceIsIntegratedWithSlackDocument, options);
}
export function useGetWorkspaceIsIntegratedWithSlackLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetWorkspaceIsIntegratedWithSlackQuery,
    Types.GetWorkspaceIsIntegratedWithSlackQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetWorkspaceIsIntegratedWithSlackQuery,
    Types.GetWorkspaceIsIntegratedWithSlackQueryVariables
  >(GetWorkspaceIsIntegratedWithSlackDocument, options);
}
export function useGetWorkspaceIsIntegratedWithSlackSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types.GetWorkspaceIsIntegratedWithSlackQuery,
        Types.GetWorkspaceIsIntegratedWithSlackQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GetWorkspaceIsIntegratedWithSlackQuery,
    Types.GetWorkspaceIsIntegratedWithSlackQueryVariables
  >(GetWorkspaceIsIntegratedWithSlackDocument, options);
}
export type GetWorkspaceIsIntegratedWithSlackQueryHookResult = ReturnType<
  typeof useGetWorkspaceIsIntegratedWithSlackQuery
>;
export type GetWorkspaceIsIntegratedWithSlackLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceIsIntegratedWithSlackLazyQuery
>;
export type GetWorkspaceIsIntegratedWithSlackSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkspaceIsIntegratedWithSlackSuspenseQuery
>;
export type GetWorkspaceIsIntegratedWithSlackQueryResult = Apollo.QueryResult<
  Types.GetWorkspaceIsIntegratedWithSlackQuery,
  Types.GetWorkspaceIsIntegratedWithSlackQueryVariables
>;
export const GetWorkspaceIsIntegratedWithCloudflareDocument = gql`
  query GetWorkspaceIsIntegratedWithCloudflare($workspace_id: ID!) {
    is_integrated_with_cloudflare: is_workspace_integrated_with(
      integration_type: Cloudflare
      workspace_id: $workspace_id
    )
  }
`;

/**
 * __useGetWorkspaceIsIntegratedWithCloudflareQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceIsIntegratedWithCloudflareQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceIsIntegratedWithCloudflareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceIsIntegratedWithCloudflareQuery({
 *   variables: {
 *      workspace_id: // value for 'workspace_id'
 *   },
 * });
 */
export function useGetWorkspaceIsIntegratedWithCloudflareQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetWorkspaceIsIntegratedWithCloudflareQuery,
    Types.GetWorkspaceIsIntegratedWithCloudflareQueryVariables
  > &
    ({ variables: Types.GetWorkspaceIsIntegratedWithCloudflareQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GetWorkspaceIsIntegratedWithCloudflareQuery,
    Types.GetWorkspaceIsIntegratedWithCloudflareQueryVariables
  >(GetWorkspaceIsIntegratedWithCloudflareDocument, options);
}
export function useGetWorkspaceIsIntegratedWithCloudflareLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetWorkspaceIsIntegratedWithCloudflareQuery,
    Types.GetWorkspaceIsIntegratedWithCloudflareQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetWorkspaceIsIntegratedWithCloudflareQuery,
    Types.GetWorkspaceIsIntegratedWithCloudflareQueryVariables
  >(GetWorkspaceIsIntegratedWithCloudflareDocument, options);
}
export function useGetWorkspaceIsIntegratedWithCloudflareSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types.GetWorkspaceIsIntegratedWithCloudflareQuery,
        Types.GetWorkspaceIsIntegratedWithCloudflareQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GetWorkspaceIsIntegratedWithCloudflareQuery,
    Types.GetWorkspaceIsIntegratedWithCloudflareQueryVariables
  >(GetWorkspaceIsIntegratedWithCloudflareDocument, options);
}
export type GetWorkspaceIsIntegratedWithCloudflareQueryHookResult = ReturnType<
  typeof useGetWorkspaceIsIntegratedWithCloudflareQuery
>;
export type GetWorkspaceIsIntegratedWithCloudflareLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceIsIntegratedWithCloudflareLazyQuery
>;
export type GetWorkspaceIsIntegratedWithCloudflareSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkspaceIsIntegratedWithCloudflareSuspenseQuery
>;
export type GetWorkspaceIsIntegratedWithCloudflareQueryResult = Apollo.QueryResult<
  Types.GetWorkspaceIsIntegratedWithCloudflareQuery,
  Types.GetWorkspaceIsIntegratedWithCloudflareQueryVariables
>;
export const GetJiraIntegrationSettingsDocument = gql`
  query GetJiraIntegrationSettings($project_id: StringID!) {
    jira_projects(project_id: $project_id) {
      id
      name
      key
      issueTypes {
        id
        name
        description
      }
    }
  }
`;

/**
 * __useGetJiraIntegrationSettingsQuery__
 *
 * To run a query within a React component, call `useGetJiraIntegrationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJiraIntegrationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJiraIntegrationSettingsQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *   },
 * });
 */
export function useGetJiraIntegrationSettingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetJiraIntegrationSettingsQuery,
    Types.GetJiraIntegrationSettingsQueryVariables
  > &
    ({ variables: Types.GetJiraIntegrationSettingsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetJiraIntegrationSettingsQuery, Types.GetJiraIntegrationSettingsQueryVariables>(
    GetJiraIntegrationSettingsDocument,
    options,
  );
}
export function useGetJiraIntegrationSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetJiraIntegrationSettingsQuery,
    Types.GetJiraIntegrationSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetJiraIntegrationSettingsQuery, Types.GetJiraIntegrationSettingsQueryVariables>(
    GetJiraIntegrationSettingsDocument,
    options,
  );
}
export function useGetJiraIntegrationSettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types.GetJiraIntegrationSettingsQuery,
        Types.GetJiraIntegrationSettingsQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetJiraIntegrationSettingsQuery, Types.GetJiraIntegrationSettingsQueryVariables>(
    GetJiraIntegrationSettingsDocument,
    options,
  );
}
export type GetJiraIntegrationSettingsQueryHookResult = ReturnType<typeof useGetJiraIntegrationSettingsQuery>;
export type GetJiraIntegrationSettingsLazyQueryHookResult = ReturnType<typeof useGetJiraIntegrationSettingsLazyQuery>;
export type GetJiraIntegrationSettingsSuspenseQueryHookResult = ReturnType<
  typeof useGetJiraIntegrationSettingsSuspenseQuery
>;
export type GetJiraIntegrationSettingsQueryResult = Apollo.QueryResult<
  Types.GetJiraIntegrationSettingsQuery,
  Types.GetJiraIntegrationSettingsQueryVariables
>;
export const GetGitHubIntegrationSettingsDocument = gql`
  query GetGitHubIntegrationSettings($workspace_id: ID!) {
    is_integrated: is_workspace_integrated_with(integration_type: GitHub, workspace_id: $workspace_id)
    github_repos(workspace_id: $workspace_id) {
      repo_id
      name
      key
      is_public
    }
  }
`;

/**
 * __useGetGitHubIntegrationSettingsQuery__
 *
 * To run a query within a React component, call `useGetGitHubIntegrationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGitHubIntegrationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGitHubIntegrationSettingsQuery({
 *   variables: {
 *      workspace_id: // value for 'workspace_id'
 *   },
 * });
 */
export function useGetGitHubIntegrationSettingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetGitHubIntegrationSettingsQuery,
    Types.GetGitHubIntegrationSettingsQueryVariables
  > &
    ({ variables: Types.GetGitHubIntegrationSettingsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetGitHubIntegrationSettingsQuery, Types.GetGitHubIntegrationSettingsQueryVariables>(
    GetGitHubIntegrationSettingsDocument,
    options,
  );
}
export function useGetGitHubIntegrationSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetGitHubIntegrationSettingsQuery,
    Types.GetGitHubIntegrationSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetGitHubIntegrationSettingsQuery, Types.GetGitHubIntegrationSettingsQueryVariables>(
    GetGitHubIntegrationSettingsDocument,
    options,
  );
}
export function useGetGitHubIntegrationSettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types.GetGitHubIntegrationSettingsQuery,
        Types.GetGitHubIntegrationSettingsQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GetGitHubIntegrationSettingsQuery,
    Types.GetGitHubIntegrationSettingsQueryVariables
  >(GetGitHubIntegrationSettingsDocument, options);
}
export type GetGitHubIntegrationSettingsQueryHookResult = ReturnType<typeof useGetGitHubIntegrationSettingsQuery>;
export type GetGitHubIntegrationSettingsLazyQueryHookResult = ReturnType<
  typeof useGetGitHubIntegrationSettingsLazyQuery
>;
export type GetGitHubIntegrationSettingsSuspenseQueryHookResult = ReturnType<
  typeof useGetGitHubIntegrationSettingsSuspenseQuery
>;
export type GetGitHubIntegrationSettingsQueryResult = Apollo.QueryResult<
  Types.GetGitHubIntegrationSettingsQuery,
  Types.GetGitHubIntegrationSettingsQueryVariables
>;
export const GetVegaIntegrationStatusDocument = gql`
  query GetVegaIntegrationStatus($project_id: StringID!) {
    vega_integration_status(project_id: $project_id) {
      installationId
      userTokenValid
      repositories {
        repo_id
        name
        key
        is_public
      }
      authLink
    }
  }
`;

/**
 * __useGetVegaIntegrationStatusQuery__
 *
 * To run a query within a React component, call `useGetVegaIntegrationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVegaIntegrationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVegaIntegrationStatusQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *   },
 * });
 */
export function useGetVegaIntegrationStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetVegaIntegrationStatusQuery,
    Types.GetVegaIntegrationStatusQueryVariables
  > &
    ({ variables: Types.GetVegaIntegrationStatusQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetVegaIntegrationStatusQuery, Types.GetVegaIntegrationStatusQueryVariables>(
    GetVegaIntegrationStatusDocument,
    options,
  );
}
export function useGetVegaIntegrationStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetVegaIntegrationStatusQuery,
    Types.GetVegaIntegrationStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetVegaIntegrationStatusQuery, Types.GetVegaIntegrationStatusQueryVariables>(
    GetVegaIntegrationStatusDocument,
    options,
  );
}
export function useGetVegaIntegrationStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types.GetVegaIntegrationStatusQuery,
        Types.GetVegaIntegrationStatusQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetVegaIntegrationStatusQuery, Types.GetVegaIntegrationStatusQueryVariables>(
    GetVegaIntegrationStatusDocument,
    options,
  );
}
export type GetVegaIntegrationStatusQueryHookResult = ReturnType<typeof useGetVegaIntegrationStatusQuery>;
export type GetVegaIntegrationStatusLazyQueryHookResult = ReturnType<typeof useGetVegaIntegrationStatusLazyQuery>;
export type GetVegaIntegrationStatusSuspenseQueryHookResult = ReturnType<
  typeof useGetVegaIntegrationStatusSuspenseQuery
>;
export type GetVegaIntegrationStatusQueryResult = Apollo.QueryResult<
  Types.GetVegaIntegrationStatusQuery,
  Types.GetVegaIntegrationStatusQueryVariables
>;
export const GetGitlabIntegrationSettingsDocument = gql`
  query GetGitlabIntegrationSettings($workspace_id: ID!) {
    is_integrated: is_workspace_integrated_with(integration_type: GitLab, workspace_id: $workspace_id)
    gitlab_projects(workspace_id: $workspace_id) {
      name
      id
      nameWithNameSpace
    }
  }
`;

/**
 * __useGetGitlabIntegrationSettingsQuery__
 *
 * To run a query within a React component, call `useGetGitlabIntegrationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGitlabIntegrationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGitlabIntegrationSettingsQuery({
 *   variables: {
 *      workspace_id: // value for 'workspace_id'
 *   },
 * });
 */
export function useGetGitlabIntegrationSettingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetGitlabIntegrationSettingsQuery,
    Types.GetGitlabIntegrationSettingsQueryVariables
  > &
    ({ variables: Types.GetGitlabIntegrationSettingsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetGitlabIntegrationSettingsQuery, Types.GetGitlabIntegrationSettingsQueryVariables>(
    GetGitlabIntegrationSettingsDocument,
    options,
  );
}
export function useGetGitlabIntegrationSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetGitlabIntegrationSettingsQuery,
    Types.GetGitlabIntegrationSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetGitlabIntegrationSettingsQuery, Types.GetGitlabIntegrationSettingsQueryVariables>(
    GetGitlabIntegrationSettingsDocument,
    options,
  );
}
export function useGetGitlabIntegrationSettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types.GetGitlabIntegrationSettingsQuery,
        Types.GetGitlabIntegrationSettingsQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GetGitlabIntegrationSettingsQuery,
    Types.GetGitlabIntegrationSettingsQueryVariables
  >(GetGitlabIntegrationSettingsDocument, options);
}
export type GetGitlabIntegrationSettingsQueryHookResult = ReturnType<typeof useGetGitlabIntegrationSettingsQuery>;
export type GetGitlabIntegrationSettingsLazyQueryHookResult = ReturnType<
  typeof useGetGitlabIntegrationSettingsLazyQuery
>;
export type GetGitlabIntegrationSettingsSuspenseQueryHookResult = ReturnType<
  typeof useGetGitlabIntegrationSettingsSuspenseQuery
>;
export type GetGitlabIntegrationSettingsQueryResult = Apollo.QueryResult<
  Types.GetGitlabIntegrationSettingsQuery,
  Types.GetGitlabIntegrationSettingsQueryVariables
>;
export const GetGitHubIssueLabelsDocument = gql`
  query GetGitHubIssueLabels($workspace_id: ID!, $repository: String!) {
    github_issue_labels(workspace_id: $workspace_id, repository: $repository)
  }
`;

/**
 * __useGetGitHubIssueLabelsQuery__
 *
 * To run a query within a React component, call `useGetGitHubIssueLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGitHubIssueLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGitHubIssueLabelsQuery({
 *   variables: {
 *      workspace_id: // value for 'workspace_id'
 *      repository: // value for 'repository'
 *   },
 * });
 */
export function useGetGitHubIssueLabelsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetGitHubIssueLabelsQuery, Types.GetGitHubIssueLabelsQueryVariables> &
    ({ variables: Types.GetGitHubIssueLabelsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetGitHubIssueLabelsQuery, Types.GetGitHubIssueLabelsQueryVariables>(
    GetGitHubIssueLabelsDocument,
    options,
  );
}
export function useGetGitHubIssueLabelsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetGitHubIssueLabelsQuery, Types.GetGitHubIssueLabelsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetGitHubIssueLabelsQuery, Types.GetGitHubIssueLabelsQueryVariables>(
    GetGitHubIssueLabelsDocument,
    options,
  );
}
export function useGetGitHubIssueLabelsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetGitHubIssueLabelsQuery, Types.GetGitHubIssueLabelsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetGitHubIssueLabelsQuery, Types.GetGitHubIssueLabelsQueryVariables>(
    GetGitHubIssueLabelsDocument,
    options,
  );
}
export type GetGitHubIssueLabelsQueryHookResult = ReturnType<typeof useGetGitHubIssueLabelsQuery>;
export type GetGitHubIssueLabelsLazyQueryHookResult = ReturnType<typeof useGetGitHubIssueLabelsLazyQuery>;
export type GetGitHubIssueLabelsSuspenseQueryHookResult = ReturnType<typeof useGetGitHubIssueLabelsSuspenseQuery>;
export type GetGitHubIssueLabelsQueryResult = Apollo.QueryResult<
  Types.GetGitHubIssueLabelsQuery,
  Types.GetGitHubIssueLabelsQueryVariables
>;
export const GetProjectIntegratedWithDocument = gql`
  query GetProjectIntegratedWith($project_id: ID!, $integration_type: IntegrationType!) {
    is_project_integrated_with(integration_type: $integration_type, project_id: $project_id)
  }
`;

/**
 * __useGetProjectIntegratedWithQuery__
 *
 * To run a query within a React component, call `useGetProjectIntegratedWithQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectIntegratedWithQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectIntegratedWithQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      integration_type: // value for 'integration_type'
 *   },
 * });
 */
export function useGetProjectIntegratedWithQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetProjectIntegratedWithQuery,
    Types.GetProjectIntegratedWithQueryVariables
  > &
    ({ variables: Types.GetProjectIntegratedWithQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetProjectIntegratedWithQuery, Types.GetProjectIntegratedWithQueryVariables>(
    GetProjectIntegratedWithDocument,
    options,
  );
}
export function useGetProjectIntegratedWithLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetProjectIntegratedWithQuery,
    Types.GetProjectIntegratedWithQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetProjectIntegratedWithQuery, Types.GetProjectIntegratedWithQueryVariables>(
    GetProjectIntegratedWithDocument,
    options,
  );
}
export function useGetProjectIntegratedWithSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types.GetProjectIntegratedWithQuery,
        Types.GetProjectIntegratedWithQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetProjectIntegratedWithQuery, Types.GetProjectIntegratedWithQueryVariables>(
    GetProjectIntegratedWithDocument,
    options,
  );
}
export type GetProjectIntegratedWithQueryHookResult = ReturnType<typeof useGetProjectIntegratedWithQuery>;
export type GetProjectIntegratedWithLazyQueryHookResult = ReturnType<typeof useGetProjectIntegratedWithLazyQuery>;
export type GetProjectIntegratedWithSuspenseQueryHookResult = ReturnType<
  typeof useGetProjectIntegratedWithSuspenseQuery
>;
export type GetProjectIntegratedWithQueryResult = Apollo.QueryResult<
  Types.GetProjectIntegratedWithQuery,
  Types.GetProjectIntegratedWithQueryVariables
>;
export const GetIdentifierSuggestionsDocument = gql`
  query GetIdentifierSuggestions($project_id: StringID!, $query: String!) {
    identifier_suggestion(project_id: $project_id, query: $query)
  }
`;

/**
 * __useGetIdentifierSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetIdentifierSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIdentifierSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIdentifierSuggestionsQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetIdentifierSuggestionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetIdentifierSuggestionsQuery,
    Types.GetIdentifierSuggestionsQueryVariables
  > &
    ({ variables: Types.GetIdentifierSuggestionsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetIdentifierSuggestionsQuery, Types.GetIdentifierSuggestionsQueryVariables>(
    GetIdentifierSuggestionsDocument,
    options,
  );
}
export function useGetIdentifierSuggestionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetIdentifierSuggestionsQuery,
    Types.GetIdentifierSuggestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetIdentifierSuggestionsQuery, Types.GetIdentifierSuggestionsQueryVariables>(
    GetIdentifierSuggestionsDocument,
    options,
  );
}
export function useGetIdentifierSuggestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types.GetIdentifierSuggestionsQuery,
        Types.GetIdentifierSuggestionsQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetIdentifierSuggestionsQuery, Types.GetIdentifierSuggestionsQueryVariables>(
    GetIdentifierSuggestionsDocument,
    options,
  );
}
export type GetIdentifierSuggestionsQueryHookResult = ReturnType<typeof useGetIdentifierSuggestionsQuery>;
export type GetIdentifierSuggestionsLazyQueryHookResult = ReturnType<typeof useGetIdentifierSuggestionsLazyQuery>;
export type GetIdentifierSuggestionsSuspenseQueryHookResult = ReturnType<
  typeof useGetIdentifierSuggestionsSuspenseQuery
>;
export type GetIdentifierSuggestionsQueryResult = Apollo.QueryResult<
  Types.GetIdentifierSuggestionsQuery,
  Types.GetIdentifierSuggestionsQueryVariables
>;
export const GetServiceAlertsDocument = gql`
  query GetServiceAlerts($project_id: StringID!) {
    alerts(project_id: $project_id) {
      id
      name
      product_type
      disabled
      query
    }
  }
`;

/**
 * __useGetServiceAlertsQuery__
 *
 * To run a query within a React component, call `useGetServiceAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceAlertsQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *   },
 * });
 */
export function useGetServiceAlertsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetServiceAlertsQuery, Types.GetServiceAlertsQueryVariables> &
    ({ variables: Types.GetServiceAlertsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetServiceAlertsQuery, Types.GetServiceAlertsQueryVariables>(
    GetServiceAlertsDocument,
    options,
  );
}
export function useGetServiceAlertsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetServiceAlertsQuery, Types.GetServiceAlertsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetServiceAlertsQuery, Types.GetServiceAlertsQueryVariables>(
    GetServiceAlertsDocument,
    options,
  );
}
export function useGetServiceAlertsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetServiceAlertsQuery, Types.GetServiceAlertsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetServiceAlertsQuery, Types.GetServiceAlertsQueryVariables>(
    GetServiceAlertsDocument,
    options,
  );
}
export type GetServiceAlertsQueryHookResult = ReturnType<typeof useGetServiceAlertsQuery>;
export type GetServiceAlertsLazyQueryHookResult = ReturnType<typeof useGetServiceAlertsLazyQuery>;
export type GetServiceAlertsSuspenseQueryHookResult = ReturnType<typeof useGetServiceAlertsSuspenseQuery>;
export type GetServiceAlertsQueryResult = Apollo.QueryResult<
  Types.GetServiceAlertsQuery,
  Types.GetServiceAlertsQueryVariables
>;
export const GetAlertsPagePayloadDocument = gql`
  query GetAlertsPagePayload($project_id: StringID!) {
    alerts(project_id: $project_id) {
      id
      updated_at
      name
      product_type
      disabled
      high_cardinality
      destinations {
        id
        destination_type
        type_id
        type_name
      }
      sql
    }
  }
`;

/**
 * __useGetAlertsPagePayloadQuery__
 *
 * To run a query within a React component, call `useGetAlertsPagePayloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlertsPagePayloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlertsPagePayloadQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *   },
 * });
 */
export function useGetAlertsPagePayloadQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetAlertsPagePayloadQuery, Types.GetAlertsPagePayloadQueryVariables> &
    ({ variables: Types.GetAlertsPagePayloadQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetAlertsPagePayloadQuery, Types.GetAlertsPagePayloadQueryVariables>(
    GetAlertsPagePayloadDocument,
    options,
  );
}
export function useGetAlertsPagePayloadLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAlertsPagePayloadQuery, Types.GetAlertsPagePayloadQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetAlertsPagePayloadQuery, Types.GetAlertsPagePayloadQueryVariables>(
    GetAlertsPagePayloadDocument,
    options,
  );
}
export function useGetAlertsPagePayloadSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetAlertsPagePayloadQuery, Types.GetAlertsPagePayloadQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetAlertsPagePayloadQuery, Types.GetAlertsPagePayloadQueryVariables>(
    GetAlertsPagePayloadDocument,
    options,
  );
}
export type GetAlertsPagePayloadQueryHookResult = ReturnType<typeof useGetAlertsPagePayloadQuery>;
export type GetAlertsPagePayloadLazyQueryHookResult = ReturnType<typeof useGetAlertsPagePayloadLazyQuery>;
export type GetAlertsPagePayloadSuspenseQueryHookResult = ReturnType<typeof useGetAlertsPagePayloadSuspenseQuery>;
export type GetAlertsPagePayloadQueryResult = Apollo.QueryResult<
  Types.GetAlertsPagePayloadQuery,
  Types.GetAlertsPagePayloadQueryVariables
>;
export const GetAlertDocument = gql`
  query GetAlert($id: ID!) {
    alert(id: $id) {
      id
      project_id
      updated_at
      name
      message_content
      product_type
      function_type
      population_function_type
      population_query
      population_window
      function_column
      query
      group_by_key
      group_by_keys
      disabled
      high_cardinality
      last_admin_to_edit_id
      last_admin_to_edit_uid
      threshold_value
      threshold_window
      threshold_cooldown
      threshold_type
      threshold_condition
      destinations {
        id
        destination_type
        type_id
        type_name
      }
      sql
      auto_investigation_enabled
      investigation_conversation_id
      investigation_started_at
      investigation_cooldown
      permission_mode
      investigation_repositories
      investigation_prompt
      evaluation_delay_seconds
      hide_graph
      warn_threshold_value
      no_data_behavior
      send_resolved_alert
      tags
    }
  }
`;

/**
 * __useGetAlertQuery__
 *
 * To run a query within a React component, call `useGetAlertQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlertQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlertQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAlertQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetAlertQuery, Types.GetAlertQueryVariables> &
    ({ variables: Types.GetAlertQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetAlertQuery, Types.GetAlertQueryVariables>(GetAlertDocument, options);
}
export function useGetAlertLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAlertQuery, Types.GetAlertQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetAlertQuery, Types.GetAlertQueryVariables>(GetAlertDocument, options);
}
export function useGetAlertSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAlertQuery, Types.GetAlertQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetAlertQuery, Types.GetAlertQueryVariables>(GetAlertDocument, options);
}
export type GetAlertQueryHookResult = ReturnType<typeof useGetAlertQuery>;
export type GetAlertLazyQueryHookResult = ReturnType<typeof useGetAlertLazyQuery>;
export type GetAlertSuspenseQueryHookResult = ReturnType<typeof useGetAlertSuspenseQuery>;
export type GetAlertQueryResult = Apollo.QueryResult<Types.GetAlertQuery, Types.GetAlertQueryVariables>;
export const GetAlertingAlertStateChangesDocument = gql`
  query GetAlertingAlertStateChanges($alert_id: ID!, $start_date: Timestamp!, $end_date: Timestamp!, $page: Int) {
    alerting_alert_state_changes(alert_id: $alert_id, start_date: $start_date, end_date: $end_date, page: $page) {
      totalCount
      alertStateChanges {
        timestamp
        state
        groupByKey
        investigationConversationId
      }
    }
  }
`;

/**
 * __useGetAlertingAlertStateChangesQuery__
 *
 * To run a query within a React component, call `useGetAlertingAlertStateChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlertingAlertStateChangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlertingAlertStateChangesQuery({
 *   variables: {
 *      alert_id: // value for 'alert_id'
 *      start_date: // value for 'start_date'
 *      end_date: // value for 'end_date'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetAlertingAlertStateChangesQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetAlertingAlertStateChangesQuery,
    Types.GetAlertingAlertStateChangesQueryVariables
  > &
    ({ variables: Types.GetAlertingAlertStateChangesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetAlertingAlertStateChangesQuery, Types.GetAlertingAlertStateChangesQueryVariables>(
    GetAlertingAlertStateChangesDocument,
    options,
  );
}
export function useGetAlertingAlertStateChangesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetAlertingAlertStateChangesQuery,
    Types.GetAlertingAlertStateChangesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetAlertingAlertStateChangesQuery, Types.GetAlertingAlertStateChangesQueryVariables>(
    GetAlertingAlertStateChangesDocument,
    options,
  );
}
export function useGetAlertingAlertStateChangesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types.GetAlertingAlertStateChangesQuery,
        Types.GetAlertingAlertStateChangesQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GetAlertingAlertStateChangesQuery,
    Types.GetAlertingAlertStateChangesQueryVariables
  >(GetAlertingAlertStateChangesDocument, options);
}
export type GetAlertingAlertStateChangesQueryHookResult = ReturnType<typeof useGetAlertingAlertStateChangesQuery>;
export type GetAlertingAlertStateChangesLazyQueryHookResult = ReturnType<
  typeof useGetAlertingAlertStateChangesLazyQuery
>;
export type GetAlertingAlertStateChangesSuspenseQueryHookResult = ReturnType<
  typeof useGetAlertingAlertStateChangesSuspenseQuery
>;
export type GetAlertingAlertStateChangesQueryResult = Apollo.QueryResult<
  Types.GetAlertingAlertStateChangesQuery,
  Types.GetAlertingAlertStateChangesQueryVariables
>;
export const GetLastAlertStateChangesDocument = gql`
  query GetLastAlertStateChanges($alert_id: ID!) {
    last_alert_state_changes(alert_id: $alert_id) {
      timestamp
      state
      groupByKey
    }
  }
`;

/**
 * __useGetLastAlertStateChangesQuery__
 *
 * To run a query within a React component, call `useGetLastAlertStateChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLastAlertStateChangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastAlertStateChangesQuery({
 *   variables: {
 *      alert_id: // value for 'alert_id'
 *   },
 * });
 */
export function useGetLastAlertStateChangesQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetLastAlertStateChangesQuery,
    Types.GetLastAlertStateChangesQueryVariables
  > &
    ({ variables: Types.GetLastAlertStateChangesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetLastAlertStateChangesQuery, Types.GetLastAlertStateChangesQueryVariables>(
    GetLastAlertStateChangesDocument,
    options,
  );
}
export function useGetLastAlertStateChangesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetLastAlertStateChangesQuery,
    Types.GetLastAlertStateChangesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetLastAlertStateChangesQuery, Types.GetLastAlertStateChangesQueryVariables>(
    GetLastAlertStateChangesDocument,
    options,
  );
}
export function useGetLastAlertStateChangesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types.GetLastAlertStateChangesQuery,
        Types.GetLastAlertStateChangesQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetLastAlertStateChangesQuery, Types.GetLastAlertStateChangesQueryVariables>(
    GetLastAlertStateChangesDocument,
    options,
  );
}
export type GetLastAlertStateChangesQueryHookResult = ReturnType<typeof useGetLastAlertStateChangesQuery>;
export type GetLastAlertStateChangesLazyQueryHookResult = ReturnType<typeof useGetLastAlertStateChangesLazyQuery>;
export type GetLastAlertStateChangesSuspenseQueryHookResult = ReturnType<
  typeof useGetLastAlertStateChangesSuspenseQuery
>;
export type GetLastAlertStateChangesQueryResult = Apollo.QueryResult<
  Types.GetLastAlertStateChangesQuery,
  Types.GetLastAlertStateChangesQueryVariables
>;
export const GetLastAlertingStateChangeDocument = gql`
  query GetLastAlertingStateChange($alert_id: ID!) {
    last_alerting_state_change(alert_id: $alert_id) {
      timestamp
      state
      groupByKey
    }
  }
`;

/**
 * __useGetLastAlertingStateChangeQuery__
 *
 * To run a query within a React component, call `useGetLastAlertingStateChangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLastAlertingStateChangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastAlertingStateChangeQuery({
 *   variables: {
 *      alert_id: // value for 'alert_id'
 *   },
 * });
 */
export function useGetLastAlertingStateChangeQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetLastAlertingStateChangeQuery,
    Types.GetLastAlertingStateChangeQueryVariables
  > &
    ({ variables: Types.GetLastAlertingStateChangeQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetLastAlertingStateChangeQuery, Types.GetLastAlertingStateChangeQueryVariables>(
    GetLastAlertingStateChangeDocument,
    options,
  );
}
export function useGetLastAlertingStateChangeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetLastAlertingStateChangeQuery,
    Types.GetLastAlertingStateChangeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetLastAlertingStateChangeQuery, Types.GetLastAlertingStateChangeQueryVariables>(
    GetLastAlertingStateChangeDocument,
    options,
  );
}
export function useGetLastAlertingStateChangeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types.GetLastAlertingStateChangeQuery,
        Types.GetLastAlertingStateChangeQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetLastAlertingStateChangeQuery, Types.GetLastAlertingStateChangeQueryVariables>(
    GetLastAlertingStateChangeDocument,
    options,
  );
}
export type GetLastAlertingStateChangeQueryHookResult = ReturnType<typeof useGetLastAlertingStateChangeQuery>;
export type GetLastAlertingStateChangeLazyQueryHookResult = ReturnType<typeof useGetLastAlertingStateChangeLazyQuery>;
export type GetLastAlertingStateChangeSuspenseQueryHookResult = ReturnType<
  typeof useGetLastAlertingStateChangeSuspenseQuery
>;
export type GetLastAlertingStateChangeQueryResult = Apollo.QueryResult<
  Types.GetLastAlertingStateChangeQuery,
  Types.GetLastAlertingStateChangeQueryVariables
>;
export const GetAlertingAlertGroupStatesDocument = gql`
  query GetAlertingAlertGroupStates(
    $alert_id: ID!
    $start_date: Timestamp!
    $end_date: Timestamp!
    $page: Int
    $count: Int
  ) {
    alerting_alert_group_states(
      alert_id: $alert_id
      start_date: $start_date
      end_date: $end_date
      page: $page
      count: $count
    ) {
      total_count
      states {
        group_by_key
        current_state
        last_state
        created_at
        investigation_conversation_id
      }
    }
  }
`;

/**
 * __useGetAlertingAlertGroupStatesQuery__
 *
 * To run a query within a React component, call `useGetAlertingAlertGroupStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlertingAlertGroupStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlertingAlertGroupStatesQuery({
 *   variables: {
 *      alert_id: // value for 'alert_id'
 *      start_date: // value for 'start_date'
 *      end_date: // value for 'end_date'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetAlertingAlertGroupStatesQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetAlertingAlertGroupStatesQuery,
    Types.GetAlertingAlertGroupStatesQueryVariables
  > &
    ({ variables: Types.GetAlertingAlertGroupStatesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetAlertingAlertGroupStatesQuery, Types.GetAlertingAlertGroupStatesQueryVariables>(
    GetAlertingAlertGroupStatesDocument,
    options,
  );
}
export function useGetAlertingAlertGroupStatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetAlertingAlertGroupStatesQuery,
    Types.GetAlertingAlertGroupStatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetAlertingAlertGroupStatesQuery, Types.GetAlertingAlertGroupStatesQueryVariables>(
    GetAlertingAlertGroupStatesDocument,
    options,
  );
}
export function useGetAlertingAlertGroupStatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types.GetAlertingAlertGroupStatesQuery,
        Types.GetAlertingAlertGroupStatesQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GetAlertingAlertGroupStatesQuery,
    Types.GetAlertingAlertGroupStatesQueryVariables
  >(GetAlertingAlertGroupStatesDocument, options);
}
export type GetAlertingAlertGroupStatesQueryHookResult = ReturnType<typeof useGetAlertingAlertGroupStatesQuery>;
export type GetAlertingAlertGroupStatesLazyQueryHookResult = ReturnType<typeof useGetAlertingAlertGroupStatesLazyQuery>;
export type GetAlertingAlertGroupStatesSuspenseQueryHookResult = ReturnType<
  typeof useGetAlertingAlertGroupStatesSuspenseQuery
>;
export type GetAlertingAlertGroupStatesQueryResult = Apollo.QueryResult<
  Types.GetAlertingAlertGroupStatesQuery,
  Types.GetAlertingAlertGroupStatesQueryVariables
>;
export const GetLastAlertGroupStatesDocument = gql`
  query GetLastAlertGroupStates($alert_id: ID!) {
    last_alert_group_states(alert_id: $alert_id) {
      group_by_key
      current_state
      last_state
      created_at
      last_notified_at
    }
  }
`;

/**
 * __useGetLastAlertGroupStatesQuery__
 *
 * To run a query within a React component, call `useGetLastAlertGroupStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLastAlertGroupStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastAlertGroupStatesQuery({
 *   variables: {
 *      alert_id: // value for 'alert_id'
 *   },
 * });
 */
export function useGetLastAlertGroupStatesQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetLastAlertGroupStatesQuery,
    Types.GetLastAlertGroupStatesQueryVariables
  > &
    ({ variables: Types.GetLastAlertGroupStatesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetLastAlertGroupStatesQuery, Types.GetLastAlertGroupStatesQueryVariables>(
    GetLastAlertGroupStatesDocument,
    options,
  );
}
export function useGetLastAlertGroupStatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetLastAlertGroupStatesQuery,
    Types.GetLastAlertGroupStatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetLastAlertGroupStatesQuery, Types.GetLastAlertGroupStatesQueryVariables>(
    GetLastAlertGroupStatesDocument,
    options,
  );
}
export function useGetLastAlertGroupStatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetLastAlertGroupStatesQuery, Types.GetLastAlertGroupStatesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetLastAlertGroupStatesQuery, Types.GetLastAlertGroupStatesQueryVariables>(
    GetLastAlertGroupStatesDocument,
    options,
  );
}
export type GetLastAlertGroupStatesQueryHookResult = ReturnType<typeof useGetLastAlertGroupStatesQuery>;
export type GetLastAlertGroupStatesLazyQueryHookResult = ReturnType<typeof useGetLastAlertGroupStatesLazyQuery>;
export type GetLastAlertGroupStatesSuspenseQueryHookResult = ReturnType<typeof useGetLastAlertGroupStatesSuspenseQuery>;
export type GetLastAlertGroupStatesQueryResult = Apollo.QueryResult<
  Types.GetLastAlertGroupStatesQuery,
  Types.GetLastAlertGroupStatesQueryVariables
>;
export const GetLastAlertingAlertGroupStateDocument = gql`
  query GetLastAlertingAlertGroupState($alert_id: ID!) {
    last_alerting_alert_group_state(alert_id: $alert_id) {
      group_by_key
      current_state
      last_state
      created_at
    }
  }
`;

/**
 * __useGetLastAlertingAlertGroupStateQuery__
 *
 * To run a query within a React component, call `useGetLastAlertingAlertGroupStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLastAlertingAlertGroupStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastAlertingAlertGroupStateQuery({
 *   variables: {
 *      alert_id: // value for 'alert_id'
 *   },
 * });
 */
export function useGetLastAlertingAlertGroupStateQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetLastAlertingAlertGroupStateQuery,
    Types.GetLastAlertingAlertGroupStateQueryVariables
  > &
    ({ variables: Types.GetLastAlertingAlertGroupStateQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetLastAlertingAlertGroupStateQuery, Types.GetLastAlertingAlertGroupStateQueryVariables>(
    GetLastAlertingAlertGroupStateDocument,
    options,
  );
}
export function useGetLastAlertingAlertGroupStateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetLastAlertingAlertGroupStateQuery,
    Types.GetLastAlertingAlertGroupStateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetLastAlertingAlertGroupStateQuery,
    Types.GetLastAlertingAlertGroupStateQueryVariables
  >(GetLastAlertingAlertGroupStateDocument, options);
}
export function useGetLastAlertingAlertGroupStateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types.GetLastAlertingAlertGroupStateQuery,
        Types.GetLastAlertingAlertGroupStateQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GetLastAlertingAlertGroupStateQuery,
    Types.GetLastAlertingAlertGroupStateQueryVariables
  >(GetLastAlertingAlertGroupStateDocument, options);
}
export type GetLastAlertingAlertGroupStateQueryHookResult = ReturnType<typeof useGetLastAlertingAlertGroupStateQuery>;
export type GetLastAlertingAlertGroupStateLazyQueryHookResult = ReturnType<
  typeof useGetLastAlertingAlertGroupStateLazyQuery
>;
export type GetLastAlertingAlertGroupStateSuspenseQueryHookResult = ReturnType<
  typeof useGetLastAlertingAlertGroupStateSuspenseQuery
>;
export type GetLastAlertingAlertGroupStateQueryResult = Apollo.QueryResult<
  Types.GetLastAlertingAlertGroupStateQuery,
  Types.GetLastAlertingAlertGroupStateQueryVariables
>;
export const GetCustomerPortalUrlDocument = gql`
  query GetCustomerPortalURL($workspace_id: ID!) {
    customer_portal_url(workspace_id: $workspace_id)
  }
`;

/**
 * __useGetCustomerPortalUrlQuery__
 *
 * To run a query within a React component, call `useGetCustomerPortalUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerPortalUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerPortalUrlQuery({
 *   variables: {
 *      workspace_id: // value for 'workspace_id'
 *   },
 * });
 */
export function useGetCustomerPortalUrlQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetCustomerPortalUrlQuery, Types.GetCustomerPortalUrlQueryVariables> &
    ({ variables: Types.GetCustomerPortalUrlQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetCustomerPortalUrlQuery, Types.GetCustomerPortalUrlQueryVariables>(
    GetCustomerPortalUrlDocument,
    options,
  );
}
export function useGetCustomerPortalUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetCustomerPortalUrlQuery, Types.GetCustomerPortalUrlQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetCustomerPortalUrlQuery, Types.GetCustomerPortalUrlQueryVariables>(
    GetCustomerPortalUrlDocument,
    options,
  );
}
export function useGetCustomerPortalUrlSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetCustomerPortalUrlQuery, Types.GetCustomerPortalUrlQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetCustomerPortalUrlQuery, Types.GetCustomerPortalUrlQueryVariables>(
    GetCustomerPortalUrlDocument,
    options,
  );
}
export type GetCustomerPortalUrlQueryHookResult = ReturnType<typeof useGetCustomerPortalUrlQuery>;
export type GetCustomerPortalUrlLazyQueryHookResult = ReturnType<typeof useGetCustomerPortalUrlLazyQuery>;
export type GetCustomerPortalUrlSuspenseQueryHookResult = ReturnType<typeof useGetCustomerPortalUrlSuspenseQuery>;
export type GetCustomerPortalUrlQueryResult = Apollo.QueryResult<
  Types.GetCustomerPortalUrlQuery,
  Types.GetCustomerPortalUrlQueryVariables
>;
export const OnSessionPayloadAppendedDocument = gql`
  subscription OnSessionPayloadAppended($session_secure_id: String!, $initial_events_count: Int!) {
    session_payload_appended(session_secure_id: $session_secure_id, initial_events_count: $initial_events_count) {
      ...SessionPayloadFragment
    }
  }
  ${SessionPayloadFragmentFragmentDoc}
`;

/**
 * __useOnSessionPayloadAppendedSubscription__
 *
 * To run a query within a React component, call `useOnSessionPayloadAppendedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnSessionPayloadAppendedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnSessionPayloadAppendedSubscription({
 *   variables: {
 *      session_secure_id: // value for 'session_secure_id'
 *      initial_events_count: // value for 'initial_events_count'
 *   },
 * });
 */
export function useOnSessionPayloadAppendedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    Types.OnSessionPayloadAppendedSubscription,
    Types.OnSessionPayloadAppendedSubscriptionVariables
  > &
    ({ variables: Types.OnSessionPayloadAppendedSubscriptionVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    Types.OnSessionPayloadAppendedSubscription,
    Types.OnSessionPayloadAppendedSubscriptionVariables
  >(OnSessionPayloadAppendedDocument, options);
}
export type OnSessionPayloadAppendedSubscriptionHookResult = ReturnType<typeof useOnSessionPayloadAppendedSubscription>;
export type OnSessionPayloadAppendedSubscriptionResult =
  Apollo.SubscriptionResult<Types.OnSessionPayloadAppendedSubscription>;
export const GetWebVitalsDocument = gql`
  query GetWebVitals($session_secure_id: String!) {
    web_vitals(session_secure_id: $session_secure_id) {
      buckets {
        bucket_id
        bucket_min
        bucket_max
        group
        column
        metric_type
        metric_value
        yhat_lower
        yhat_upper
      }
      bucket_count
      sample_factor
    }
  }
`;

/**
 * __useGetWebVitalsQuery__
 *
 * To run a query within a React component, call `useGetWebVitalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebVitalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebVitalsQuery({
 *   variables: {
 *      session_secure_id: // value for 'session_secure_id'
 *   },
 * });
 */
export function useGetWebVitalsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetWebVitalsQuery, Types.GetWebVitalsQueryVariables> &
    ({ variables: Types.GetWebVitalsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetWebVitalsQuery, Types.GetWebVitalsQueryVariables>(GetWebVitalsDocument, options);
}
export function useGetWebVitalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetWebVitalsQuery, Types.GetWebVitalsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetWebVitalsQuery, Types.GetWebVitalsQueryVariables>(GetWebVitalsDocument, options);
}
export function useGetWebVitalsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetWebVitalsQuery, Types.GetWebVitalsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetWebVitalsQuery, Types.GetWebVitalsQueryVariables>(
    GetWebVitalsDocument,
    options,
  );
}
export type GetWebVitalsQueryHookResult = ReturnType<typeof useGetWebVitalsQuery>;
export type GetWebVitalsLazyQueryHookResult = ReturnType<typeof useGetWebVitalsLazyQuery>;
export type GetWebVitalsSuspenseQueryHookResult = ReturnType<typeof useGetWebVitalsSuspenseQuery>;
export type GetWebVitalsQueryResult = Apollo.QueryResult<Types.GetWebVitalsQuery, Types.GetWebVitalsQueryVariables>;
export const GetSourcemapFilesDocument = gql`
  query GetSourcemapFiles($project_id: StringID!, $version: String) {
    sourcemap_files(project_id: $project_id, version: $version) {
      key
    }
  }
`;

/**
 * __useGetSourcemapFilesQuery__
 *
 * To run a query within a React component, call `useGetSourcemapFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSourcemapFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSourcemapFilesQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useGetSourcemapFilesQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetSourcemapFilesQuery, Types.GetSourcemapFilesQueryVariables> &
    ({ variables: Types.GetSourcemapFilesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetSourcemapFilesQuery, Types.GetSourcemapFilesQueryVariables>(
    GetSourcemapFilesDocument,
    options,
  );
}
export function useGetSourcemapFilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSourcemapFilesQuery, Types.GetSourcemapFilesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetSourcemapFilesQuery, Types.GetSourcemapFilesQueryVariables>(
    GetSourcemapFilesDocument,
    options,
  );
}
export function useGetSourcemapFilesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetSourcemapFilesQuery, Types.GetSourcemapFilesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetSourcemapFilesQuery, Types.GetSourcemapFilesQueryVariables>(
    GetSourcemapFilesDocument,
    options,
  );
}
export type GetSourcemapFilesQueryHookResult = ReturnType<typeof useGetSourcemapFilesQuery>;
export type GetSourcemapFilesLazyQueryHookResult = ReturnType<typeof useGetSourcemapFilesLazyQuery>;
export type GetSourcemapFilesSuspenseQueryHookResult = ReturnType<typeof useGetSourcemapFilesSuspenseQuery>;
export type GetSourcemapFilesQueryResult = Apollo.QueryResult<
  Types.GetSourcemapFilesQuery,
  Types.GetSourcemapFilesQueryVariables
>;
export const GetSourcemapVersionsDocument = gql`
  query GetSourcemapVersions($project_id: StringID!) {
    sourcemap_versions(project_id: $project_id)
  }
`;

/**
 * __useGetSourcemapVersionsQuery__
 *
 * To run a query within a React component, call `useGetSourcemapVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSourcemapVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSourcemapVersionsQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *   },
 * });
 */
export function useGetSourcemapVersionsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetSourcemapVersionsQuery, Types.GetSourcemapVersionsQueryVariables> &
    ({ variables: Types.GetSourcemapVersionsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetSourcemapVersionsQuery, Types.GetSourcemapVersionsQueryVariables>(
    GetSourcemapVersionsDocument,
    options,
  );
}
export function useGetSourcemapVersionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSourcemapVersionsQuery, Types.GetSourcemapVersionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetSourcemapVersionsQuery, Types.GetSourcemapVersionsQueryVariables>(
    GetSourcemapVersionsDocument,
    options,
  );
}
export function useGetSourcemapVersionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetSourcemapVersionsQuery, Types.GetSourcemapVersionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetSourcemapVersionsQuery, Types.GetSourcemapVersionsQueryVariables>(
    GetSourcemapVersionsDocument,
    options,
  );
}
export type GetSourcemapVersionsQueryHookResult = ReturnType<typeof useGetSourcemapVersionsQuery>;
export type GetSourcemapVersionsLazyQueryHookResult = ReturnType<typeof useGetSourcemapVersionsLazyQuery>;
export type GetSourcemapVersionsSuspenseQueryHookResult = ReturnType<typeof useGetSourcemapVersionsSuspenseQuery>;
export type GetSourcemapVersionsQueryResult = Apollo.QueryResult<
  Types.GetSourcemapVersionsQuery,
  Types.GetSourcemapVersionsQueryVariables
>;
export const GetOAuthClientMetadataDocument = gql`
  query GetOAuthClientMetadata($client_id: String!) {
    oauth_client_metadata(client_id: $client_id) {
      id
      created_at
      app_name
    }
  }
`;

/**
 * __useGetOAuthClientMetadataQuery__
 *
 * To run a query within a React component, call `useGetOAuthClientMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOAuthClientMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOAuthClientMetadataQuery({
 *   variables: {
 *      client_id: // value for 'client_id'
 *   },
 * });
 */
export function useGetOAuthClientMetadataQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetOAuthClientMetadataQuery, Types.GetOAuthClientMetadataQueryVariables> &
    ({ variables: Types.GetOAuthClientMetadataQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetOAuthClientMetadataQuery, Types.GetOAuthClientMetadataQueryVariables>(
    GetOAuthClientMetadataDocument,
    options,
  );
}
export function useGetOAuthClientMetadataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetOAuthClientMetadataQuery,
    Types.GetOAuthClientMetadataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetOAuthClientMetadataQuery, Types.GetOAuthClientMetadataQueryVariables>(
    GetOAuthClientMetadataDocument,
    options,
  );
}
export function useGetOAuthClientMetadataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetOAuthClientMetadataQuery, Types.GetOAuthClientMetadataQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetOAuthClientMetadataQuery, Types.GetOAuthClientMetadataQueryVariables>(
    GetOAuthClientMetadataDocument,
    options,
  );
}
export type GetOAuthClientMetadataQueryHookResult = ReturnType<typeof useGetOAuthClientMetadataQuery>;
export type GetOAuthClientMetadataLazyQueryHookResult = ReturnType<typeof useGetOAuthClientMetadataLazyQuery>;
export type GetOAuthClientMetadataSuspenseQueryHookResult = ReturnType<typeof useGetOAuthClientMetadataSuspenseQuery>;
export type GetOAuthClientMetadataQueryResult = Apollo.QueryResult<
  Types.GetOAuthClientMetadataQuery,
  Types.GetOAuthClientMetadataQueryVariables
>;
export const GetSsoLoginDocument = gql`
  query GetSSOLogin($domain: String!) {
    sso_login(domain: $domain) {
      domain
      client_id
    }
  }
`;

/**
 * __useGetSsoLoginQuery__
 *
 * To run a query within a React component, call `useGetSsoLoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSsoLoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSsoLoginQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useGetSsoLoginQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetSsoLoginQuery, Types.GetSsoLoginQueryVariables> &
    ({ variables: Types.GetSsoLoginQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetSsoLoginQuery, Types.GetSsoLoginQueryVariables>(GetSsoLoginDocument, options);
}
export function useGetSsoLoginLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSsoLoginQuery, Types.GetSsoLoginQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetSsoLoginQuery, Types.GetSsoLoginQueryVariables>(GetSsoLoginDocument, options);
}
export function useGetSsoLoginSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetSsoLoginQuery, Types.GetSsoLoginQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetSsoLoginQuery, Types.GetSsoLoginQueryVariables>(GetSsoLoginDocument, options);
}
export type GetSsoLoginQueryHookResult = ReturnType<typeof useGetSsoLoginQuery>;
export type GetSsoLoginLazyQueryHookResult = ReturnType<typeof useGetSsoLoginLazyQuery>;
export type GetSsoLoginSuspenseQueryHookResult = ReturnType<typeof useGetSsoLoginSuspenseQuery>;
export type GetSsoLoginQueryResult = Apollo.QueryResult<Types.GetSsoLoginQuery, Types.GetSsoLoginQueryVariables>;
export const SearchIssuesDocument = gql`
  query SearchIssues($project_id: ID!, $query: String!, $integration_type: IntegrationType!) {
    search_issues(integration_type: $integration_type, query: $query, project_id: $project_id) {
      id
      title
      issue_url
    }
  }
`;

/**
 * __useSearchIssuesQuery__
 *
 * To run a query within a React component, call `useSearchIssuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchIssuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchIssuesQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      query: // value for 'query'
 *      integration_type: // value for 'integration_type'
 *   },
 * });
 */
export function useSearchIssuesQuery(
  baseOptions: Apollo.QueryHookOptions<Types.SearchIssuesQuery, Types.SearchIssuesQueryVariables> &
    ({ variables: Types.SearchIssuesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.SearchIssuesQuery, Types.SearchIssuesQueryVariables>(SearchIssuesDocument, options);
}
export function useSearchIssuesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.SearchIssuesQuery, Types.SearchIssuesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.SearchIssuesQuery, Types.SearchIssuesQueryVariables>(SearchIssuesDocument, options);
}
export function useSearchIssuesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.SearchIssuesQuery, Types.SearchIssuesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.SearchIssuesQuery, Types.SearchIssuesQueryVariables>(
    SearchIssuesDocument,
    options,
  );
}
export type SearchIssuesQueryHookResult = ReturnType<typeof useSearchIssuesQuery>;
export type SearchIssuesLazyQueryHookResult = ReturnType<typeof useSearchIssuesLazyQuery>;
export type SearchIssuesSuspenseQueryHookResult = ReturnType<typeof useSearchIssuesSuspenseQuery>;
export type SearchIssuesQueryResult = Apollo.QueryResult<Types.SearchIssuesQuery, Types.SearchIssuesQueryVariables>;
export const GetErrorGroupTagsDocument = gql`
  query GetErrorGroupTags($error_group_secure_id: String!, $use_clickhouse: Boolean, $date_range: DateRangeInput) {
    errorGroupTags(
      error_group_secure_id: $error_group_secure_id
      use_clickhouse: $use_clickhouse
      date_range: $date_range
    ) {
      key
      buckets {
        key
        doc_count
        percent
      }
    }
  }
`;

/**
 * __useGetErrorGroupTagsQuery__
 *
 * To run a query within a React component, call `useGetErrorGroupTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetErrorGroupTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetErrorGroupTagsQuery({
 *   variables: {
 *      error_group_secure_id: // value for 'error_group_secure_id'
 *      use_clickhouse: // value for 'use_clickhouse'
 *      date_range: // value for 'date_range'
 *   },
 * });
 */
export function useGetErrorGroupTagsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetErrorGroupTagsQuery, Types.GetErrorGroupTagsQueryVariables> &
    ({ variables: Types.GetErrorGroupTagsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetErrorGroupTagsQuery, Types.GetErrorGroupTagsQueryVariables>(
    GetErrorGroupTagsDocument,
    options,
  );
}
export function useGetErrorGroupTagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetErrorGroupTagsQuery, Types.GetErrorGroupTagsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetErrorGroupTagsQuery, Types.GetErrorGroupTagsQueryVariables>(
    GetErrorGroupTagsDocument,
    options,
  );
}
export function useGetErrorGroupTagsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetErrorGroupTagsQuery, Types.GetErrorGroupTagsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetErrorGroupTagsQuery, Types.GetErrorGroupTagsQueryVariables>(
    GetErrorGroupTagsDocument,
    options,
  );
}
export type GetErrorGroupTagsQueryHookResult = ReturnType<typeof useGetErrorGroupTagsQuery>;
export type GetErrorGroupTagsLazyQueryHookResult = ReturnType<typeof useGetErrorGroupTagsLazyQuery>;
export type GetErrorGroupTagsSuspenseQueryHookResult = ReturnType<typeof useGetErrorGroupTagsSuspenseQuery>;
export type GetErrorGroupTagsQueryResult = Apollo.QueryResult<
  Types.GetErrorGroupTagsQuery,
  Types.GetErrorGroupTagsQueryVariables
>;
export const GetEmailOptOutsDocument = gql`
  query GetEmailOptOuts($token: String, $admin_id: ID) {
    email_opt_outs(token: $token, admin_id: $admin_id)
  }
`;

/**
 * __useGetEmailOptOutsQuery__
 *
 * To run a query within a React component, call `useGetEmailOptOutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailOptOutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailOptOutsQuery({
 *   variables: {
 *      token: // value for 'token'
 *      admin_id: // value for 'admin_id'
 *   },
 * });
 */
export function useGetEmailOptOutsQuery(
  baseOptions?: Apollo.QueryHookOptions<Types.GetEmailOptOutsQuery, Types.GetEmailOptOutsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetEmailOptOutsQuery, Types.GetEmailOptOutsQueryVariables>(
    GetEmailOptOutsDocument,
    options,
  );
}
export function useGetEmailOptOutsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetEmailOptOutsQuery, Types.GetEmailOptOutsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetEmailOptOutsQuery, Types.GetEmailOptOutsQueryVariables>(
    GetEmailOptOutsDocument,
    options,
  );
}
export function useGetEmailOptOutsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetEmailOptOutsQuery, Types.GetEmailOptOutsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetEmailOptOutsQuery, Types.GetEmailOptOutsQueryVariables>(
    GetEmailOptOutsDocument,
    options,
  );
}
export type GetEmailOptOutsQueryHookResult = ReturnType<typeof useGetEmailOptOutsQuery>;
export type GetEmailOptOutsLazyQueryHookResult = ReturnType<typeof useGetEmailOptOutsLazyQuery>;
export type GetEmailOptOutsSuspenseQueryHookResult = ReturnType<typeof useGetEmailOptOutsSuspenseQuery>;
export type GetEmailOptOutsQueryResult = Apollo.QueryResult<
  Types.GetEmailOptOutsQuery,
  Types.GetEmailOptOutsQueryVariables
>;
export const GetLogsDocument = gql`
  query GetLogs(
    $project_id: StringID!
    $params: QueryInput!
    $after: String
    $before: String
    $at: String
    $direction: SortDirection!
    $limit: Int
    $query_settings: QuerySettingsInput
  ) {
    logs(
      project_id: $project_id
      params: $params
      after: $after
      before: $before
      at: $at
      direction: $direction
      limit: $limit
      query_settings: $query_settings
    ) {
      edges {
        cursor
        node {
          timestamp
          level
          message
          logAttributes
          traceID
          spanID
          secureSessionID
          source
          serviceName
          serviceVersion
          environment
          projectID
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

/**
 * __useGetLogsQuery__
 *
 * To run a query within a React component, call `useGetLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLogsQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      params: // value for 'params'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      at: // value for 'at'
 *      direction: // value for 'direction'
 *      limit: // value for 'limit'
 *      query_settings: // value for 'query_settings'
 *   },
 * });
 */
export function useGetLogsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetLogsQuery, Types.GetLogsQueryVariables> &
    ({ variables: Types.GetLogsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetLogsQuery, Types.GetLogsQueryVariables>(GetLogsDocument, options);
}
export function useGetLogsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetLogsQuery, Types.GetLogsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetLogsQuery, Types.GetLogsQueryVariables>(GetLogsDocument, options);
}
export function useGetLogsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetLogsQuery, Types.GetLogsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetLogsQuery, Types.GetLogsQueryVariables>(GetLogsDocument, options);
}
export type GetLogsQueryHookResult = ReturnType<typeof useGetLogsQuery>;
export type GetLogsLazyQueryHookResult = ReturnType<typeof useGetLogsLazyQuery>;
export type GetLogsSuspenseQueryHookResult = ReturnType<typeof useGetLogsSuspenseQuery>;
export type GetLogsQueryResult = Apollo.QueryResult<Types.GetLogsQuery, Types.GetLogsQueryVariables>;
export const GetLogsHistogramDocument = gql`
  query GetLogsHistogram($project_id: ID!, $params: QueryInput!) {
    logs_histogram(project_id: $project_id, params: $params) {
      totalCount
      buckets {
        bucketId
        counts {
          count
          level
        }
      }
      objectCount
      sampleFactor
    }
  }
`;

/**
 * __useGetLogsHistogramQuery__
 *
 * To run a query within a React component, call `useGetLogsHistogramQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLogsHistogramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLogsHistogramQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetLogsHistogramQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetLogsHistogramQuery, Types.GetLogsHistogramQueryVariables> &
    ({ variables: Types.GetLogsHistogramQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetLogsHistogramQuery, Types.GetLogsHistogramQueryVariables>(
    GetLogsHistogramDocument,
    options,
  );
}
export function useGetLogsHistogramLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetLogsHistogramQuery, Types.GetLogsHistogramQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetLogsHistogramQuery, Types.GetLogsHistogramQueryVariables>(
    GetLogsHistogramDocument,
    options,
  );
}
export function useGetLogsHistogramSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetLogsHistogramQuery, Types.GetLogsHistogramQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetLogsHistogramQuery, Types.GetLogsHistogramQueryVariables>(
    GetLogsHistogramDocument,
    options,
  );
}
export type GetLogsHistogramQueryHookResult = ReturnType<typeof useGetLogsHistogramQuery>;
export type GetLogsHistogramLazyQueryHookResult = ReturnType<typeof useGetLogsHistogramLazyQuery>;
export type GetLogsHistogramSuspenseQueryHookResult = ReturnType<typeof useGetLogsHistogramSuspenseQuery>;
export type GetLogsHistogramQueryResult = Apollo.QueryResult<
  Types.GetLogsHistogramQuery,
  Types.GetLogsHistogramQueryVariables
>;
export const GetLogsRelatedResourcesDocument = gql`
  query GetLogsRelatedResources(
    $project_id: StringID!
    $log_cursors: [String!]!
    $trace_ids: [String!]!
    $date_range: DateRangeRequiredInput!
  ) {
    logs_error_objects(log_cursors: $log_cursors) {
      log_cursor
      error_group_secure_id
      id
    }
    existing_logs_traces(project_id: $project_id, trace_ids: $trace_ids, date_range: $date_range)
  }
`;

/**
 * __useGetLogsRelatedResourcesQuery__
 *
 * To run a query within a React component, call `useGetLogsRelatedResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLogsRelatedResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLogsRelatedResourcesQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      log_cursors: // value for 'log_cursors'
 *      trace_ids: // value for 'trace_ids'
 *      date_range: // value for 'date_range'
 *   },
 * });
 */
export function useGetLogsRelatedResourcesQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetLogsRelatedResourcesQuery,
    Types.GetLogsRelatedResourcesQueryVariables
  > &
    ({ variables: Types.GetLogsRelatedResourcesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetLogsRelatedResourcesQuery, Types.GetLogsRelatedResourcesQueryVariables>(
    GetLogsRelatedResourcesDocument,
    options,
  );
}
export function useGetLogsRelatedResourcesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetLogsRelatedResourcesQuery,
    Types.GetLogsRelatedResourcesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetLogsRelatedResourcesQuery, Types.GetLogsRelatedResourcesQueryVariables>(
    GetLogsRelatedResourcesDocument,
    options,
  );
}
export function useGetLogsRelatedResourcesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetLogsRelatedResourcesQuery, Types.GetLogsRelatedResourcesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetLogsRelatedResourcesQuery, Types.GetLogsRelatedResourcesQueryVariables>(
    GetLogsRelatedResourcesDocument,
    options,
  );
}
export type GetLogsRelatedResourcesQueryHookResult = ReturnType<typeof useGetLogsRelatedResourcesQuery>;
export type GetLogsRelatedResourcesLazyQueryHookResult = ReturnType<typeof useGetLogsRelatedResourcesLazyQuery>;
export type GetLogsRelatedResourcesSuspenseQueryHookResult = ReturnType<typeof useGetLogsRelatedResourcesSuspenseQuery>;
export type GetLogsRelatedResourcesQueryResult = Apollo.QueryResult<
  Types.GetLogsRelatedResourcesQuery,
  Types.GetLogsRelatedResourcesQueryVariables
>;
export const GetProjectSettingsDocument = gql`
  query GetProjectSettings($projectId: StringID!) {
    projectSettings(projectId: $projectId) {
      id
      name
      verbose_id
      billing_email
      excluded_users
      error_filters
      error_json_paths
      filter_chrome_extension
      rage_click_window_seconds
      rage_click_radius_pixels
      rage_click_count
      filterSessionsWithoutError
      autoResolveStaleErrorsDayInterval
      sampling {
        session_sampling_rate
        error_sampling_rate
        log_sampling_rate
        trace_sampling_rate
        metric_sampling_rate
        session_exclusion_query
        error_exclusion_query
        log_exclusion_query
        trace_exclusion_query
        metric_exclusion_query
        session_minute_rate_limit
        error_minute_rate_limit
        log_minute_rate_limit
        trace_minute_rate_limit
        metric_minute_rate_limit
      }
      filter_rules {
        session_filter_rules_order
        error_filter_rules_order
        log_filter_rules_order
        trace_filter_rules_order
      }
    }
  }
`;

/**
 * __useGetProjectSettingsQuery__
 *
 * To run a query within a React component, call `useGetProjectSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectSettingsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectSettingsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetProjectSettingsQuery, Types.GetProjectSettingsQueryVariables> &
    ({ variables: Types.GetProjectSettingsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetProjectSettingsQuery, Types.GetProjectSettingsQueryVariables>(
    GetProjectSettingsDocument,
    options,
  );
}
export function useGetProjectSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetProjectSettingsQuery, Types.GetProjectSettingsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetProjectSettingsQuery, Types.GetProjectSettingsQueryVariables>(
    GetProjectSettingsDocument,
    options,
  );
}
export function useGetProjectSettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetProjectSettingsQuery, Types.GetProjectSettingsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetProjectSettingsQuery, Types.GetProjectSettingsQueryVariables>(
    GetProjectSettingsDocument,
    options,
  );
}
export type GetProjectSettingsQueryHookResult = ReturnType<typeof useGetProjectSettingsQuery>;
export type GetProjectSettingsLazyQueryHookResult = ReturnType<typeof useGetProjectSettingsLazyQuery>;
export type GetProjectSettingsSuspenseQueryHookResult = ReturnType<typeof useGetProjectSettingsSuspenseQuery>;
export type GetProjectSettingsQueryResult = Apollo.QueryResult<
  Types.GetProjectSettingsQuery,
  Types.GetProjectSettingsQueryVariables
>;
export const GetWorkspacePendingInvitesDocument = gql`
  query GetWorkspacePendingInvites($workspace_id: ID!) {
    workspacePendingInvites(workspace_id: $workspace_id) {
      id
      invitee_email
      invitee_role
      created_at
    }
  }
`;

/**
 * __useGetWorkspacePendingInvitesQuery__
 *
 * To run a query within a React component, call `useGetWorkspacePendingInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspacePendingInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspacePendingInvitesQuery({
 *   variables: {
 *      workspace_id: // value for 'workspace_id'
 *   },
 * });
 */
export function useGetWorkspacePendingInvitesQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetWorkspacePendingInvitesQuery,
    Types.GetWorkspacePendingInvitesQueryVariables
  > &
    ({ variables: Types.GetWorkspacePendingInvitesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetWorkspacePendingInvitesQuery, Types.GetWorkspacePendingInvitesQueryVariables>(
    GetWorkspacePendingInvitesDocument,
    options,
  );
}
export function useGetWorkspacePendingInvitesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetWorkspacePendingInvitesQuery,
    Types.GetWorkspacePendingInvitesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetWorkspacePendingInvitesQuery, Types.GetWorkspacePendingInvitesQueryVariables>(
    GetWorkspacePendingInvitesDocument,
    options,
  );
}
export function useGetWorkspacePendingInvitesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types.GetWorkspacePendingInvitesQuery,
        Types.GetWorkspacePendingInvitesQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetWorkspacePendingInvitesQuery, Types.GetWorkspacePendingInvitesQueryVariables>(
    GetWorkspacePendingInvitesDocument,
    options,
  );
}
export type GetWorkspacePendingInvitesQueryHookResult = ReturnType<typeof useGetWorkspacePendingInvitesQuery>;
export type GetWorkspacePendingInvitesLazyQueryHookResult = ReturnType<typeof useGetWorkspacePendingInvitesLazyQuery>;
export type GetWorkspacePendingInvitesSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkspacePendingInvitesSuspenseQuery
>;
export type GetWorkspacePendingInvitesQueryResult = Apollo.QueryResult<
  Types.GetWorkspacePendingInvitesQuery,
  Types.GetWorkspacePendingInvitesQueryVariables
>;
export const GetErrorResolutionSuggestionDocument = gql`
  query GetErrorResolutionSuggestion($error_object_id: ID!) {
    error_resolution_suggestion(error_object_id: $error_object_id)
  }
`;

/**
 * __useGetErrorResolutionSuggestionQuery__
 *
 * To run a query within a React component, call `useGetErrorResolutionSuggestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetErrorResolutionSuggestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetErrorResolutionSuggestionQuery({
 *   variables: {
 *      error_object_id: // value for 'error_object_id'
 *   },
 * });
 */
export function useGetErrorResolutionSuggestionQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetErrorResolutionSuggestionQuery,
    Types.GetErrorResolutionSuggestionQueryVariables
  > &
    ({ variables: Types.GetErrorResolutionSuggestionQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetErrorResolutionSuggestionQuery, Types.GetErrorResolutionSuggestionQueryVariables>(
    GetErrorResolutionSuggestionDocument,
    options,
  );
}
export function useGetErrorResolutionSuggestionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetErrorResolutionSuggestionQuery,
    Types.GetErrorResolutionSuggestionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetErrorResolutionSuggestionQuery, Types.GetErrorResolutionSuggestionQueryVariables>(
    GetErrorResolutionSuggestionDocument,
    options,
  );
}
export function useGetErrorResolutionSuggestionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types.GetErrorResolutionSuggestionQuery,
        Types.GetErrorResolutionSuggestionQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GetErrorResolutionSuggestionQuery,
    Types.GetErrorResolutionSuggestionQueryVariables
  >(GetErrorResolutionSuggestionDocument, options);
}
export type GetErrorResolutionSuggestionQueryHookResult = ReturnType<typeof useGetErrorResolutionSuggestionQuery>;
export type GetErrorResolutionSuggestionLazyQueryHookResult = ReturnType<
  typeof useGetErrorResolutionSuggestionLazyQuery
>;
export type GetErrorResolutionSuggestionSuspenseQueryHookResult = ReturnType<
  typeof useGetErrorResolutionSuggestionSuspenseQuery
>;
export type GetErrorResolutionSuggestionQueryResult = Apollo.QueryResult<
  Types.GetErrorResolutionSuggestionQuery,
  Types.GetErrorResolutionSuggestionQueryVariables
>;
export const GetWorkspaceSettingsDocument = gql`
  query GetWorkspaceSettings($workspace_id: ID!) {
    workspaceSettings(workspace_id: $workspace_id) {
      workspace_id
      ai_insights
      enable_billing_limits
      enable_business_dashboards
      enable_business_projects
      enable_business_retention
      enable_business_seats
      enable_data_deletion
      enable_grafana_dashboard
      enable_ingest_filtering
      enable_ingest_sampling
      enable_jira_integration
      enable_network_traces
      enable_project_level_access
      enable_project_level_access
      enable_session_export
      enable_sso
      enable_teams_integration
      enable_unlisted_sharing
    }
  }
`;

/**
 * __useGetWorkspaceSettingsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceSettingsQuery({
 *   variables: {
 *      workspace_id: // value for 'workspace_id'
 *   },
 * });
 */
export function useGetWorkspaceSettingsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetWorkspaceSettingsQuery, Types.GetWorkspaceSettingsQueryVariables> &
    ({ variables: Types.GetWorkspaceSettingsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetWorkspaceSettingsQuery, Types.GetWorkspaceSettingsQueryVariables>(
    GetWorkspaceSettingsDocument,
    options,
  );
}
export function useGetWorkspaceSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetWorkspaceSettingsQuery, Types.GetWorkspaceSettingsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetWorkspaceSettingsQuery, Types.GetWorkspaceSettingsQueryVariables>(
    GetWorkspaceSettingsDocument,
    options,
  );
}
export function useGetWorkspaceSettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetWorkspaceSettingsQuery, Types.GetWorkspaceSettingsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetWorkspaceSettingsQuery, Types.GetWorkspaceSettingsQueryVariables>(
    GetWorkspaceSettingsDocument,
    options,
  );
}
export type GetWorkspaceSettingsQueryHookResult = ReturnType<typeof useGetWorkspaceSettingsQuery>;
export type GetWorkspaceSettingsLazyQueryHookResult = ReturnType<typeof useGetWorkspaceSettingsLazyQuery>;
export type GetWorkspaceSettingsSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceSettingsSuspenseQuery>;
export type GetWorkspaceSettingsQueryResult = Apollo.QueryResult<
  Types.GetWorkspaceSettingsQuery,
  Types.GetWorkspaceSettingsQueryVariables
>;
export const GetSystemConfigurationDocument = gql`
  query GetSystemConfiguration {
    system_configuration {
      maintenance_start
      maintenance_end
    }
  }
`;

/**
 * __useGetSystemConfigurationQuery__
 *
 * To run a query within a React component, call `useGetSystemConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSystemConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSystemConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSystemConfigurationQuery(
  baseOptions?: Apollo.QueryHookOptions<Types.GetSystemConfigurationQuery, Types.GetSystemConfigurationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetSystemConfigurationQuery, Types.GetSystemConfigurationQueryVariables>(
    GetSystemConfigurationDocument,
    options,
  );
}
export function useGetSystemConfigurationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetSystemConfigurationQuery,
    Types.GetSystemConfigurationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetSystemConfigurationQuery, Types.GetSystemConfigurationQueryVariables>(
    GetSystemConfigurationDocument,
    options,
  );
}
export function useGetSystemConfigurationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetSystemConfigurationQuery, Types.GetSystemConfigurationQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetSystemConfigurationQuery, Types.GetSystemConfigurationQueryVariables>(
    GetSystemConfigurationDocument,
    options,
  );
}
export type GetSystemConfigurationQueryHookResult = ReturnType<typeof useGetSystemConfigurationQuery>;
export type GetSystemConfigurationLazyQueryHookResult = ReturnType<typeof useGetSystemConfigurationLazyQuery>;
export type GetSystemConfigurationSuspenseQueryHookResult = ReturnType<typeof useGetSystemConfigurationSuspenseQuery>;
export type GetSystemConfigurationQueryResult = Apollo.QueryResult<
  Types.GetSystemConfigurationQuery,
  Types.GetSystemConfigurationQueryVariables
>;
export const GetErrorGroupInstancesDocument = gql`
  query GetErrorGroupInstances($errorGroupSecureID: String!, $count: Int!, $params: QueryInput!, $page: Int) {
    error_objects(error_group_secure_id: $errorGroupSecureID, count: $count, params: $params, page: $page) {
      error_objects {
        id
        createdAt
        event
        timestamp
        serviceVersion
        serviceName
        session {
          secureID
          email
          fingerprint
          excluded
        }
        errorGroupSecureID
        project_id
      }
      totalCount
    }
  }
`;

/**
 * __useGetErrorGroupInstancesQuery__
 *
 * To run a query within a React component, call `useGetErrorGroupInstancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetErrorGroupInstancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetErrorGroupInstancesQuery({
 *   variables: {
 *      errorGroupSecureID: // value for 'errorGroupSecureID'
 *      count: // value for 'count'
 *      params: // value for 'params'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetErrorGroupInstancesQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetErrorGroupInstancesQuery, Types.GetErrorGroupInstancesQueryVariables> &
    ({ variables: Types.GetErrorGroupInstancesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetErrorGroupInstancesQuery, Types.GetErrorGroupInstancesQueryVariables>(
    GetErrorGroupInstancesDocument,
    options,
  );
}
export function useGetErrorGroupInstancesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetErrorGroupInstancesQuery,
    Types.GetErrorGroupInstancesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetErrorGroupInstancesQuery, Types.GetErrorGroupInstancesQueryVariables>(
    GetErrorGroupInstancesDocument,
    options,
  );
}
export function useGetErrorGroupInstancesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetErrorGroupInstancesQuery, Types.GetErrorGroupInstancesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetErrorGroupInstancesQuery, Types.GetErrorGroupInstancesQueryVariables>(
    GetErrorGroupInstancesDocument,
    options,
  );
}
export type GetErrorGroupInstancesQueryHookResult = ReturnType<typeof useGetErrorGroupInstancesQuery>;
export type GetErrorGroupInstancesLazyQueryHookResult = ReturnType<typeof useGetErrorGroupInstancesLazyQuery>;
export type GetErrorGroupInstancesSuspenseQueryHookResult = ReturnType<typeof useGetErrorGroupInstancesSuspenseQuery>;
export type GetErrorGroupInstancesQueryResult = Apollo.QueryResult<
  Types.GetErrorGroupInstancesQuery,
  Types.GetErrorGroupInstancesQueryVariables
>;
export const GetErrorObjectsDocument = gql`
  query GetErrorObjects(
    $project_id: String!
    $count: Int!
    $params: QueryInput!
    $page: Int
    $query_settings: QuerySettingsInput
  ) {
    error_objects(
      project_id: $project_id
      count: $count
      params: $params
      page: $page
      query_settings: $query_settings
    ) {
      error_objects {
        id
        createdAt
        event
        timestamp
        serviceVersion
        serviceName
        session {
          secureID
          email
          fingerprint
          excluded
        }
        errorGroupSecureID
        project_id
      }
      totalCount
    }
  }
`;

/**
 * __useGetErrorObjectsQuery__
 *
 * To run a query within a React component, call `useGetErrorObjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetErrorObjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetErrorObjectsQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      count: // value for 'count'
 *      params: // value for 'params'
 *      page: // value for 'page'
 *      query_settings: // value for 'query_settings'
 *   },
 * });
 */
export function useGetErrorObjectsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetErrorObjectsQuery, Types.GetErrorObjectsQueryVariables> &
    ({ variables: Types.GetErrorObjectsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetErrorObjectsQuery, Types.GetErrorObjectsQueryVariables>(
    GetErrorObjectsDocument,
    options,
  );
}
export function useGetErrorObjectsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetErrorObjectsQuery, Types.GetErrorObjectsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetErrorObjectsQuery, Types.GetErrorObjectsQueryVariables>(
    GetErrorObjectsDocument,
    options,
  );
}
export function useGetErrorObjectsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetErrorObjectsQuery, Types.GetErrorObjectsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetErrorObjectsQuery, Types.GetErrorObjectsQueryVariables>(
    GetErrorObjectsDocument,
    options,
  );
}
export type GetErrorObjectsQueryHookResult = ReturnType<typeof useGetErrorObjectsQuery>;
export type GetErrorObjectsLazyQueryHookResult = ReturnType<typeof useGetErrorObjectsLazyQuery>;
export type GetErrorObjectsSuspenseQueryHookResult = ReturnType<typeof useGetErrorObjectsSuspenseQuery>;
export type GetErrorObjectsQueryResult = Apollo.QueryResult<
  Types.GetErrorObjectsQuery,
  Types.GetErrorObjectsQueryVariables
>;
export const GetServicesDocument = gql`
  query GetServices($project_id: StringID!, $query: String, $after: String, $before: String) {
    services(project_id: $project_id, query: $query, after: $after, before: $before) {
      edges {
        cursor
        node {
          id
          projectID
          name
          status
          githubRepoPath
          buildPrefix
          githubPrefix
          errorDetails
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

/**
 * __useGetServicesQuery__
 *
 * To run a query within a React component, call `useGetServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServicesQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      query: // value for 'query'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useGetServicesQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetServicesQuery, Types.GetServicesQueryVariables> &
    ({ variables: Types.GetServicesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetServicesQuery, Types.GetServicesQueryVariables>(GetServicesDocument, options);
}
export function useGetServicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetServicesQuery, Types.GetServicesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetServicesQuery, Types.GetServicesQueryVariables>(GetServicesDocument, options);
}
export function useGetServicesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetServicesQuery, Types.GetServicesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetServicesQuery, Types.GetServicesQueryVariables>(GetServicesDocument, options);
}
export type GetServicesQueryHookResult = ReturnType<typeof useGetServicesQuery>;
export type GetServicesLazyQueryHookResult = ReturnType<typeof useGetServicesLazyQuery>;
export type GetServicesSuspenseQueryHookResult = ReturnType<typeof useGetServicesSuspenseQuery>;
export type GetServicesQueryResult = Apollo.QueryResult<Types.GetServicesQuery, Types.GetServicesQueryVariables>;
export const GetServiceByNameDocument = gql`
  query GetServiceByName($project_id: StringID!, $name: String!) {
    serviceByName(project_id: $project_id, name: $name) {
      id
      projectID
      name
      status
      githubRepoPath
      buildPrefix
      githubPrefix
      errorDetails
    }
  }
`;

/**
 * __useGetServiceByNameQuery__
 *
 * To run a query within a React component, call `useGetServiceByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceByNameQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetServiceByNameQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetServiceByNameQuery, Types.GetServiceByNameQueryVariables> &
    ({ variables: Types.GetServiceByNameQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetServiceByNameQuery, Types.GetServiceByNameQueryVariables>(
    GetServiceByNameDocument,
    options,
  );
}
export function useGetServiceByNameLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetServiceByNameQuery, Types.GetServiceByNameQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetServiceByNameQuery, Types.GetServiceByNameQueryVariables>(
    GetServiceByNameDocument,
    options,
  );
}
export function useGetServiceByNameSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetServiceByNameQuery, Types.GetServiceByNameQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetServiceByNameQuery, Types.GetServiceByNameQueryVariables>(
    GetServiceByNameDocument,
    options,
  );
}
export type GetServiceByNameQueryHookResult = ReturnType<typeof useGetServiceByNameQuery>;
export type GetServiceByNameLazyQueryHookResult = ReturnType<typeof useGetServiceByNameLazyQuery>;
export type GetServiceByNameSuspenseQueryHookResult = ReturnType<typeof useGetServiceByNameSuspenseQuery>;
export type GetServiceByNameQueryResult = Apollo.QueryResult<
  Types.GetServiceByNameQuery,
  Types.GetServiceByNameQueryVariables
>;
export const GetTraceDocument = gql`
  query GetTrace($project_id: StringID!, $trace_id: String!, $timestamp: Timestamp!, $session_secure_id: String) {
    trace(project_id: $project_id, trace_id: $trace_id, timestamp: $timestamp, session_secure_id: $session_secure_id) {
      trace {
        timestamp
        traceID
        spanID
        parentSpanID
        projectID
        secureSessionID
        traceState
        spanName
        spanKind
        duration
        serviceName
        serviceVersion
        environment
        environmentId
        hasErrors
        traceAttributes
        startTime
        statusCode
        statusMessage
        events {
          timestamp
          name
          attributes
        }
      }
      errors {
        created_at
        id
        trace_id
        span_id
        log_cursor
        event
        type
        source
        timestamp
        error_group_secure_id
      }
    }
  }
`;

/**
 * __useGetTraceQuery__
 *
 * To run a query within a React component, call `useGetTraceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTraceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTraceQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      trace_id: // value for 'trace_id'
 *      timestamp: // value for 'timestamp'
 *      session_secure_id: // value for 'session_secure_id'
 *   },
 * });
 */
export function useGetTraceQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetTraceQuery, Types.GetTraceQueryVariables> &
    ({ variables: Types.GetTraceQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetTraceQuery, Types.GetTraceQueryVariables>(GetTraceDocument, options);
}
export function useGetTraceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetTraceQuery, Types.GetTraceQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetTraceQuery, Types.GetTraceQueryVariables>(GetTraceDocument, options);
}
export function useGetTraceSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetTraceQuery, Types.GetTraceQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetTraceQuery, Types.GetTraceQueryVariables>(GetTraceDocument, options);
}
export type GetTraceQueryHookResult = ReturnType<typeof useGetTraceQuery>;
export type GetTraceLazyQueryHookResult = ReturnType<typeof useGetTraceLazyQuery>;
export type GetTraceSuspenseQueryHookResult = ReturnType<typeof useGetTraceSuspenseQuery>;
export type GetTraceQueryResult = Apollo.QueryResult<Types.GetTraceQuery, Types.GetTraceQueryVariables>;
export const GetTraceConversationDocument = gql`
  query GetTraceConversation(
    $project_id: StringID!
    $conversation_id: String!
    $start_date: Timestamp
    $end_date: Timestamp
  ) {
    trace_conversation(
      project_id: $project_id
      conversation_id: $conversation_id
      start_date: $start_date
      end_date: $end_date
    ) {
      conversation_id
      spans {
        timestamp
        traceID
        spanID
        parentSpanID
        projectID
        secureSessionID
        traceState
        spanName
        spanKind
        duration
        serviceName
        serviceVersion
        environment
        environmentId
        hasErrors
        traceAttributes
        startTime
        statusCode
        statusMessage
        events {
          timestamp
          name
          attributes
        }
      }
      summary {
        trace_count
        span_count
        total_duration_ns
        input_tokens
        output_tokens
      }
    }
  }
`;

/**
 * __useGetTraceConversationQuery__
 *
 * To run a query within a React component, call `useGetTraceConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTraceConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTraceConversationQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      conversation_id: // value for 'conversation_id'
 *      start_date: // value for 'start_date'
 *      end_date: // value for 'end_date'
 *   },
 * });
 */
export function useGetTraceConversationQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetTraceConversationQuery, Types.GetTraceConversationQueryVariables> &
    ({ variables: Types.GetTraceConversationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetTraceConversationQuery, Types.GetTraceConversationQueryVariables>(
    GetTraceConversationDocument,
    options,
  );
}
export function useGetTraceConversationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetTraceConversationQuery, Types.GetTraceConversationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetTraceConversationQuery, Types.GetTraceConversationQueryVariables>(
    GetTraceConversationDocument,
    options,
  );
}
export function useGetTraceConversationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetTraceConversationQuery, Types.GetTraceConversationQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetTraceConversationQuery, Types.GetTraceConversationQueryVariables>(
    GetTraceConversationDocument,
    options,
  );
}
export type GetTraceConversationQueryHookResult = ReturnType<typeof useGetTraceConversationQuery>;
export type GetTraceConversationLazyQueryHookResult = ReturnType<typeof useGetTraceConversationLazyQuery>;
export type GetTraceConversationSuspenseQueryHookResult = ReturnType<typeof useGetTraceConversationSuspenseQuery>;
export type GetTraceConversationQueryResult = Apollo.QueryResult<
  Types.GetTraceConversationQuery,
  Types.GetTraceConversationQueryVariables
>;
export const GetTracesDocument = gql`
  query GetTraces(
    $project_id: StringID!
    $params: QueryInput!
    $after: String
    $before: String
    $at: String
    $direction: SortDirection!
    $limit: Int
    $omitBody: Boolean
    $query_settings: QuerySettingsInput
  ) {
    traces(
      project_id: $project_id
      params: $params
      after: $after
      before: $before
      at: $at
      direction: $direction
      limit: $limit
      omitBody: $omitBody
      query_settings: $query_settings
    ) {
      edges {
        cursor
        node {
          timestamp
          traceID
          spanID
          parentSpanID
          projectID
          secureSessionID
          traceState
          spanName
          spanKind
          duration
          serviceName
          serviceVersion
          environment
          hasErrors
          traceAttributes
          statusCode
          statusMessage
          events {
            timestamp
            name
            attributes
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      sampled
    }
  }
`;

/**
 * __useGetTracesQuery__
 *
 * To run a query within a React component, call `useGetTracesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTracesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTracesQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      params: // value for 'params'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      at: // value for 'at'
 *      direction: // value for 'direction'
 *      limit: // value for 'limit'
 *      omitBody: // value for 'omitBody'
 *      query_settings: // value for 'query_settings'
 *   },
 * });
 */
export function useGetTracesQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetTracesQuery, Types.GetTracesQueryVariables> &
    ({ variables: Types.GetTracesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetTracesQuery, Types.GetTracesQueryVariables>(GetTracesDocument, options);
}
export function useGetTracesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetTracesQuery, Types.GetTracesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetTracesQuery, Types.GetTracesQueryVariables>(GetTracesDocument, options);
}
export function useGetTracesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetTracesQuery, Types.GetTracesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetTracesQuery, Types.GetTracesQueryVariables>(GetTracesDocument, options);
}
export type GetTracesQueryHookResult = ReturnType<typeof useGetTracesQuery>;
export type GetTracesLazyQueryHookResult = ReturnType<typeof useGetTracesLazyQuery>;
export type GetTracesSuspenseQueryHookResult = ReturnType<typeof useGetTracesSuspenseQuery>;
export type GetTracesQueryResult = Apollo.QueryResult<Types.GetTracesQuery, Types.GetTracesQueryVariables>;
export const GetTraceSummariesDocument = gql`
  query GetTraceSummaries($project_id: StringID!, $params: QueryInput!, $after: String, $limit: Int) {
    traceSummaries(project_id: $project_id, params: $params, after: $after, limit: $limit) {
      edges {
        cursor
        node {
          timestamp
          traceID
          root_name
          root_service
          services_touched
          span_count
          trace_duration
          error_count
          in_progress
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      sampled
    }
  }
`;

/**
 * __useGetTraceSummariesQuery__
 *
 * To run a query within a React component, call `useGetTraceSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTraceSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTraceSummariesQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      params: // value for 'params'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetTraceSummariesQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetTraceSummariesQuery, Types.GetTraceSummariesQueryVariables> &
    ({ variables: Types.GetTraceSummariesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetTraceSummariesQuery, Types.GetTraceSummariesQueryVariables>(
    GetTraceSummariesDocument,
    options,
  );
}
export function useGetTraceSummariesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetTraceSummariesQuery, Types.GetTraceSummariesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetTraceSummariesQuery, Types.GetTraceSummariesQueryVariables>(
    GetTraceSummariesDocument,
    options,
  );
}
export function useGetTraceSummariesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetTraceSummariesQuery, Types.GetTraceSummariesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetTraceSummariesQuery, Types.GetTraceSummariesQueryVariables>(
    GetTraceSummariesDocument,
    options,
  );
}
export type GetTraceSummariesQueryHookResult = ReturnType<typeof useGetTraceSummariesQuery>;
export type GetTraceSummariesLazyQueryHookResult = ReturnType<typeof useGetTraceSummariesLazyQuery>;
export type GetTraceSummariesSuspenseQueryHookResult = ReturnType<typeof useGetTraceSummariesSuspenseQuery>;
export type GetTraceSummariesQueryResult = Apollo.QueryResult<
  Types.GetTraceSummariesQuery,
  Types.GetTraceSummariesQueryVariables
>;
export const GetConversationsDocument = gql`
  query GetConversations($project_id: StringID!, $params: QueryInput!, $after: String, $limit: Int) {
    traceConversations(project_id: $project_id, params: $params, after: $after, limit: $limit) {
      edges {
        cursor
        node {
          projectID
          conversationID
          timestamp
          first_timestamp
          last_timestamp
          active_duration_ns
          trace_count
          span_count
          models
          providers
          input_tokens
          output_tokens
          error_count
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      sampled
    }
  }
`;

/**
 * __useGetConversationsQuery__
 *
 * To run a query within a React component, call `useGetConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationsQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      params: // value for 'params'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetConversationsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetConversationsQuery, Types.GetConversationsQueryVariables> &
    ({ variables: Types.GetConversationsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetConversationsQuery, Types.GetConversationsQueryVariables>(
    GetConversationsDocument,
    options,
  );
}
export function useGetConversationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetConversationsQuery, Types.GetConversationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetConversationsQuery, Types.GetConversationsQueryVariables>(
    GetConversationsDocument,
    options,
  );
}
export function useGetConversationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetConversationsQuery, Types.GetConversationsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetConversationsQuery, Types.GetConversationsQueryVariables>(
    GetConversationsDocument,
    options,
  );
}
export type GetConversationsQueryHookResult = ReturnType<typeof useGetConversationsQuery>;
export type GetConversationsLazyQueryHookResult = ReturnType<typeof useGetConversationsLazyQuery>;
export type GetConversationsSuspenseQueryHookResult = ReturnType<typeof useGetConversationsSuspenseQuery>;
export type GetConversationsQueryResult = Apollo.QueryResult<
  Types.GetConversationsQuery,
  Types.GetConversationsQueryVariables
>;
export const GetTracesMetricsDocument = gql`
  query GetTracesMetrics(
    $project_id: StringID!
    $params: QueryInput!
    $column: String!
    $metric_types: [MetricAggregator!]!
    $group_by: [String!]!
    $bucket_by: String
    $limit: Int
    $limit_aggregator: MetricAggregator
    $limit_column: String
  ) {
    traces_metrics(
      project_id: $project_id
      params: $params
      column: $column
      metric_types: $metric_types
      group_by: $group_by
      bucket_by: $bucket_by
      limit: $limit
      limit_aggregator: $limit_aggregator
      limit_column: $limit_column
    ) {
      buckets {
        bucket_id
        group
        metric_type
        metric_value
      }
      bucket_count
      sample_factor
    }
  }
`;

/**
 * __useGetTracesMetricsQuery__
 *
 * To run a query within a React component, call `useGetTracesMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTracesMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTracesMetricsQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      params: // value for 'params'
 *      column: // value for 'column'
 *      metric_types: // value for 'metric_types'
 *      group_by: // value for 'group_by'
 *      bucket_by: // value for 'bucket_by'
 *      limit: // value for 'limit'
 *      limit_aggregator: // value for 'limit_aggregator'
 *      limit_column: // value for 'limit_column'
 *   },
 * });
 */
export function useGetTracesMetricsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetTracesMetricsQuery, Types.GetTracesMetricsQueryVariables> &
    ({ variables: Types.GetTracesMetricsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetTracesMetricsQuery, Types.GetTracesMetricsQueryVariables>(
    GetTracesMetricsDocument,
    options,
  );
}
export function useGetTracesMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetTracesMetricsQuery, Types.GetTracesMetricsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetTracesMetricsQuery, Types.GetTracesMetricsQueryVariables>(
    GetTracesMetricsDocument,
    options,
  );
}
export function useGetTracesMetricsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetTracesMetricsQuery, Types.GetTracesMetricsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetTracesMetricsQuery, Types.GetTracesMetricsQueryVariables>(
    GetTracesMetricsDocument,
    options,
  );
}
export type GetTracesMetricsQueryHookResult = ReturnType<typeof useGetTracesMetricsQuery>;
export type GetTracesMetricsLazyQueryHookResult = ReturnType<typeof useGetTracesMetricsLazyQuery>;
export type GetTracesMetricsSuspenseQueryHookResult = ReturnType<typeof useGetTracesMetricsSuspenseQuery>;
export type GetTracesMetricsQueryResult = Apollo.QueryResult<
  Types.GetTracesMetricsQuery,
  Types.GetTracesMetricsQueryVariables
>;
export const GetKeysDocument = gql`
  query GetKeys(
    $product_type: ProductType
    $project_id: StringID!
    $date_range: DateRangeRequiredInput!
    $query: String
    $type: KeyType
    $event: String
  ) {
    keys(
      product_type: $product_type
      project_id: $project_id
      date_range: $date_range
      query: $query
      type: $type
      event: $event
    ) {
      name
      type
      count
    }
  }
`;

/**
 * __useGetKeysQuery__
 *
 * To run a query within a React component, call `useGetKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKeysQuery({
 *   variables: {
 *      product_type: // value for 'product_type'
 *      project_id: // value for 'project_id'
 *      date_range: // value for 'date_range'
 *      query: // value for 'query'
 *      type: // value for 'type'
 *      event: // value for 'event'
 *   },
 * });
 */
export function useGetKeysQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetKeysQuery, Types.GetKeysQueryVariables> &
    ({ variables: Types.GetKeysQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetKeysQuery, Types.GetKeysQueryVariables>(GetKeysDocument, options);
}
export function useGetKeysLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetKeysQuery, Types.GetKeysQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetKeysQuery, Types.GetKeysQueryVariables>(GetKeysDocument, options);
}
export function useGetKeysSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetKeysQuery, Types.GetKeysQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetKeysQuery, Types.GetKeysQueryVariables>(GetKeysDocument, options);
}
export type GetKeysQueryHookResult = ReturnType<typeof useGetKeysQuery>;
export type GetKeysLazyQueryHookResult = ReturnType<typeof useGetKeysLazyQuery>;
export type GetKeysSuspenseQueryHookResult = ReturnType<typeof useGetKeysSuspenseQuery>;
export type GetKeysQueryResult = Apollo.QueryResult<Types.GetKeysQuery, Types.GetKeysQueryVariables>;
export const GetKeyValuesDocument = gql`
  query GetKeyValues(
    $product_type: ProductType
    $project_id: StringID!
    $key_name: String!
    $date_range: DateRangeRequiredInput!
    $query: String!
    $count: Int!
    $event: String
  ) {
    key_values(
      product_type: $product_type
      project_id: $project_id
      key_name: $key_name
      date_range: $date_range
      query: $query
      count: $count
      event: $event
    )
  }
`;

/**
 * __useGetKeyValuesQuery__
 *
 * To run a query within a React component, call `useGetKeyValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKeyValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKeyValuesQuery({
 *   variables: {
 *      product_type: // value for 'product_type'
 *      project_id: // value for 'project_id'
 *      key_name: // value for 'key_name'
 *      date_range: // value for 'date_range'
 *      query: // value for 'query'
 *      count: // value for 'count'
 *      event: // value for 'event'
 *   },
 * });
 */
export function useGetKeyValuesQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetKeyValuesQuery, Types.GetKeyValuesQueryVariables> &
    ({ variables: Types.GetKeyValuesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetKeyValuesQuery, Types.GetKeyValuesQueryVariables>(GetKeyValuesDocument, options);
}
export function useGetKeyValuesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetKeyValuesQuery, Types.GetKeyValuesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetKeyValuesQuery, Types.GetKeyValuesQueryVariables>(GetKeyValuesDocument, options);
}
export function useGetKeyValuesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetKeyValuesQuery, Types.GetKeyValuesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetKeyValuesQuery, Types.GetKeyValuesQueryVariables>(
    GetKeyValuesDocument,
    options,
  );
}
export type GetKeyValuesQueryHookResult = ReturnType<typeof useGetKeyValuesQuery>;
export type GetKeyValuesLazyQueryHookResult = ReturnType<typeof useGetKeyValuesLazyQuery>;
export type GetKeyValuesSuspenseQueryHookResult = ReturnType<typeof useGetKeyValuesSuspenseQuery>;
export type GetKeyValuesQueryResult = Apollo.QueryResult<Types.GetKeyValuesQuery, Types.GetKeyValuesQueryVariables>;
export const GetKeyValueSuggestionsDocument = gql`
  query GetKeyValueSuggestions(
    $product_type: ProductType!
    $project_id: StringID!
    $date_range: DateRangeRequiredInput!
    $keys: [String!]!
  ) {
    key_values_suggestions(product_type: $product_type, project_id: $project_id, date_range: $date_range, keys: $keys) {
      key
      values {
        value
        count
        rank
      }
    }
  }
`;

/**
 * __useGetKeyValueSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetKeyValueSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKeyValueSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKeyValueSuggestionsQuery({
 *   variables: {
 *      product_type: // value for 'product_type'
 *      project_id: // value for 'project_id'
 *      date_range: // value for 'date_range'
 *      keys: // value for 'keys'
 *   },
 * });
 */
export function useGetKeyValueSuggestionsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetKeyValueSuggestionsQuery, Types.GetKeyValueSuggestionsQueryVariables> &
    ({ variables: Types.GetKeyValueSuggestionsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetKeyValueSuggestionsQuery, Types.GetKeyValueSuggestionsQueryVariables>(
    GetKeyValueSuggestionsDocument,
    options,
  );
}
export function useGetKeyValueSuggestionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetKeyValueSuggestionsQuery,
    Types.GetKeyValueSuggestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetKeyValueSuggestionsQuery, Types.GetKeyValueSuggestionsQueryVariables>(
    GetKeyValueSuggestionsDocument,
    options,
  );
}
export function useGetKeyValueSuggestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetKeyValueSuggestionsQuery, Types.GetKeyValueSuggestionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetKeyValueSuggestionsQuery, Types.GetKeyValueSuggestionsQueryVariables>(
    GetKeyValueSuggestionsDocument,
    options,
  );
}
export type GetKeyValueSuggestionsQueryHookResult = ReturnType<typeof useGetKeyValueSuggestionsQuery>;
export type GetKeyValueSuggestionsLazyQueryHookResult = ReturnType<typeof useGetKeyValueSuggestionsLazyQuery>;
export type GetKeyValueSuggestionsSuspenseQueryHookResult = ReturnType<typeof useGetKeyValueSuggestionsSuspenseQuery>;
export type GetKeyValueSuggestionsQueryResult = Apollo.QueryResult<
  Types.GetKeyValueSuggestionsQuery,
  Types.GetKeyValueSuggestionsQueryVariables
>;
export const GetValueSuggestionsDocument = gql`
  query GetValueSuggestions(
    $product_type: ProductType
    $project_id: StringID!
    $key_name: String!
    $date_range: DateRangeRequiredInput!
    $query: String
    $count: Int
    $event: String
  ) {
    value_suggestions(
      product_type: $product_type
      project_id: $project_id
      key_name: $key_name
      date_range: $date_range
      query: $query
      count: $count
      event: $event
    ) {
      value
      count
      rank
    }
  }
`;

/**
 * __useGetValueSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetValueSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValueSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValueSuggestionsQuery({
 *   variables: {
 *      product_type: // value for 'product_type'
 *      project_id: // value for 'project_id'
 *      key_name: // value for 'key_name'
 *      date_range: // value for 'date_range'
 *      query: // value for 'query'
 *      count: // value for 'count'
 *      event: // value for 'event'
 *   },
 * });
 */
export function useGetValueSuggestionsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetValueSuggestionsQuery, Types.GetValueSuggestionsQueryVariables> &
    ({ variables: Types.GetValueSuggestionsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetValueSuggestionsQuery, Types.GetValueSuggestionsQueryVariables>(
    GetValueSuggestionsDocument,
    options,
  );
}
export function useGetValueSuggestionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetValueSuggestionsQuery, Types.GetValueSuggestionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetValueSuggestionsQuery, Types.GetValueSuggestionsQueryVariables>(
    GetValueSuggestionsDocument,
    options,
  );
}
export function useGetValueSuggestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetValueSuggestionsQuery, Types.GetValueSuggestionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetValueSuggestionsQuery, Types.GetValueSuggestionsQueryVariables>(
    GetValueSuggestionsDocument,
    options,
  );
}
export type GetValueSuggestionsQueryHookResult = ReturnType<typeof useGetValueSuggestionsQuery>;
export type GetValueSuggestionsLazyQueryHookResult = ReturnType<typeof useGetValueSuggestionsLazyQuery>;
export type GetValueSuggestionsSuspenseQueryHookResult = ReturnType<typeof useGetValueSuggestionsSuspenseQuery>;
export type GetValueSuggestionsQueryResult = Apollo.QueryResult<
  Types.GetValueSuggestionsQuery,
  Types.GetValueSuggestionsQueryVariables
>;
export const GetUrlKeyValuesDocument = gql`
  query GetUrlKeyValues($project_id: StringID!, $date_range: DateRangeRequiredInput!, $query: String!, $count: Int!) {
    url_key_values(project_id: $project_id, date_range: $date_range, query: $query, count: $count) {
      key
      value
      count
    }
  }
`;

/**
 * __useGetUrlKeyValuesQuery__
 *
 * To run a query within a React component, call `useGetUrlKeyValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUrlKeyValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUrlKeyValuesQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      date_range: // value for 'date_range'
 *      query: // value for 'query'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetUrlKeyValuesQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetUrlKeyValuesQuery, Types.GetUrlKeyValuesQueryVariables> &
    ({ variables: Types.GetUrlKeyValuesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetUrlKeyValuesQuery, Types.GetUrlKeyValuesQueryVariables>(
    GetUrlKeyValuesDocument,
    options,
  );
}
export function useGetUrlKeyValuesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetUrlKeyValuesQuery, Types.GetUrlKeyValuesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetUrlKeyValuesQuery, Types.GetUrlKeyValuesQueryVariables>(
    GetUrlKeyValuesDocument,
    options,
  );
}
export function useGetUrlKeyValuesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetUrlKeyValuesQuery, Types.GetUrlKeyValuesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetUrlKeyValuesQuery, Types.GetUrlKeyValuesQueryVariables>(
    GetUrlKeyValuesDocument,
    options,
  );
}
export type GetUrlKeyValuesQueryHookResult = ReturnType<typeof useGetUrlKeyValuesQuery>;
export type GetUrlKeyValuesLazyQueryHookResult = ReturnType<typeof useGetUrlKeyValuesLazyQuery>;
export type GetUrlKeyValuesSuspenseQueryHookResult = ReturnType<typeof useGetUrlKeyValuesSuspenseQuery>;
export type GetUrlKeyValuesQueryResult = Apollo.QueryResult<
  Types.GetUrlKeyValuesQuery,
  Types.GetUrlKeyValuesQueryVariables
>;
export const GetMetricsDocument = gql`
  query GetMetrics(
    $product_type: ProductType!
    $project_id: StringID!
    $params: QueryInput!
    $sql: String
    $group_by: [String!]!
    $bucket_by: String!
    $bucket_count: Int
    $bucket_window: Int
    $limit: Int
    $limit_aggregator: MetricAggregator
    $limit_column: String
    $prediction_settings: PredictionSettings
    $expressions: [MetricExpressionInput!]!
    $population_function_type: MetricAggregator
    $population_query: String
    $population_window: Int
    $query_settings: QuerySettingsInput
    $include_null_or_empty_groups: Boolean
  ) {
    metrics(
      product_type: $product_type
      project_id: $project_id
      params: $params
      sql: $sql
      group_by: $group_by
      bucket_by: $bucket_by
      bucket_window: $bucket_window
      bucket_count: $bucket_count
      limit: $limit
      limit_aggregator: $limit_aggregator
      limit_column: $limit_column
      prediction_settings: $prediction_settings
      expressions: $expressions
      population_function_type: $population_function_type
      population_query: $population_query
      population_window: $population_window
      query_settings: $query_settings
      include_null_or_empty_groups: $include_null_or_empty_groups
    ) {
      buckets {
        bucket_id
        bucket_min
        bucket_max
        bucket_value
        group
        column
        metric_type
        metric_value
        yhat_lower
        yhat_upper
      }
      bucket_count
      sample_factor
      metric_unit
      ingest_delay {
        p50
        p90
        p100
      }
      query_stats {
        rows_scanned
        rows_matched
        was_sampled
      }
    }
  }
`;

/**
 * __useGetMetricsQuery__
 *
 * To run a query within a React component, call `useGetMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricsQuery({
 *   variables: {
 *      product_type: // value for 'product_type'
 *      project_id: // value for 'project_id'
 *      params: // value for 'params'
 *      sql: // value for 'sql'
 *      group_by: // value for 'group_by'
 *      bucket_by: // value for 'bucket_by'
 *      bucket_count: // value for 'bucket_count'
 *      bucket_window: // value for 'bucket_window'
 *      limit: // value for 'limit'
 *      limit_aggregator: // value for 'limit_aggregator'
 *      limit_column: // value for 'limit_column'
 *      prediction_settings: // value for 'prediction_settings'
 *      expressions: // value for 'expressions'
 *      population_function_type: // value for 'population_function_type'
 *      population_query: // value for 'population_query'
 *      population_window: // value for 'population_window'
 *      query_settings: // value for 'query_settings'
 *      include_null_or_empty_groups: // value for 'include_null_or_empty_groups'
 *   },
 * });
 */
export function useGetMetricsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetMetricsQuery, Types.GetMetricsQueryVariables> &
    ({ variables: Types.GetMetricsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetMetricsQuery, Types.GetMetricsQueryVariables>(GetMetricsDocument, options);
}
export function useGetMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMetricsQuery, Types.GetMetricsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetMetricsQuery, Types.GetMetricsQueryVariables>(GetMetricsDocument, options);
}
export function useGetMetricsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetMetricsQuery, Types.GetMetricsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetMetricsQuery, Types.GetMetricsQueryVariables>(GetMetricsDocument, options);
}
export type GetMetricsQueryHookResult = ReturnType<typeof useGetMetricsQuery>;
export type GetMetricsLazyQueryHookResult = ReturnType<typeof useGetMetricsLazyQuery>;
export type GetMetricsSuspenseQueryHookResult = ReturnType<typeof useGetMetricsSuspenseQuery>;
export type GetMetricsQueryResult = Apollo.QueryResult<Types.GetMetricsQuery, Types.GetMetricsQueryVariables>;
export const GetGraphTemplatesDocument = gql`
  query GetGraphTemplates {
    graph_templates {
      id
      type
      title
      description
      productType
      query
      groupByKeys
      bucketByKey
      bucketCount
      bucketInterval
      limit
      limitFunctionType
      limitMetric
      funnelSteps {
        title
        query
      }
      display
      comparisonMode
      strictOrder
      breakdownBy
      breakdownLimit
      nullHandling
      showExemplars
      exemplarScaleMode
      expressions {
        aggregator
        column
      }
      sql
    }
  }
`;

/**
 * __useGetGraphTemplatesQuery__
 *
 * To run a query within a React component, call `useGetGraphTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraphTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGraphTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGraphTemplatesQuery(
  baseOptions?: Apollo.QueryHookOptions<Types.GetGraphTemplatesQuery, Types.GetGraphTemplatesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetGraphTemplatesQuery, Types.GetGraphTemplatesQueryVariables>(
    GetGraphTemplatesDocument,
    options,
  );
}
export function useGetGraphTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetGraphTemplatesQuery, Types.GetGraphTemplatesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetGraphTemplatesQuery, Types.GetGraphTemplatesQueryVariables>(
    GetGraphTemplatesDocument,
    options,
  );
}
export function useGetGraphTemplatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetGraphTemplatesQuery, Types.GetGraphTemplatesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetGraphTemplatesQuery, Types.GetGraphTemplatesQueryVariables>(
    GetGraphTemplatesDocument,
    options,
  );
}
export type GetGraphTemplatesQueryHookResult = ReturnType<typeof useGetGraphTemplatesQuery>;
export type GetGraphTemplatesLazyQueryHookResult = ReturnType<typeof useGetGraphTemplatesLazyQuery>;
export type GetGraphTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetGraphTemplatesSuspenseQuery>;
export type GetGraphTemplatesQueryResult = Apollo.QueryResult<
  Types.GetGraphTemplatesQuery,
  Types.GetGraphTemplatesQueryVariables
>;
export const GetVisualizationDocument = gql`
  query GetVisualization($id: ID!) {
    visualization(id: $id) {
      id
      updatedAt
      projectId
      name
      timePreset
      kind
      briefContent
      variables {
        key
        defaultValues
        suggestionType
        field
      }
      graphs {
        id
        type
        title
        description
        productType
        query
        groupByKeys
        bucketByKey
        bucketCount
        bucketInterval
        limit
        limitFunctionType
        limitMetric
        funnelSteps {
          title
          query
        }
        display
        comparisonMode
        strictOrder
        breakdownBy
        breakdownLimit
        nullHandling
        showExemplars
        exemplarScaleMode
        expressions {
          aggregator
          column
        }
        sql
        heatmapSecureSessionId
        heatmapSessionTimestamp
      }
      updatedByAdmin {
        id
        name
        email
        photo_url
      }
    }
  }
`;

/**
 * __useGetVisualizationQuery__
 *
 * To run a query within a React component, call `useGetVisualizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVisualizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVisualizationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVisualizationQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetVisualizationQuery, Types.GetVisualizationQueryVariables> &
    ({ variables: Types.GetVisualizationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetVisualizationQuery, Types.GetVisualizationQueryVariables>(
    GetVisualizationDocument,
    options,
  );
}
export function useGetVisualizationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetVisualizationQuery, Types.GetVisualizationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetVisualizationQuery, Types.GetVisualizationQueryVariables>(
    GetVisualizationDocument,
    options,
  );
}
export function useGetVisualizationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetVisualizationQuery, Types.GetVisualizationQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetVisualizationQuery, Types.GetVisualizationQueryVariables>(
    GetVisualizationDocument,
    options,
  );
}
export type GetVisualizationQueryHookResult = ReturnType<typeof useGetVisualizationQuery>;
export type GetVisualizationLazyQueryHookResult = ReturnType<typeof useGetVisualizationLazyQuery>;
export type GetVisualizationSuspenseQueryHookResult = ReturnType<typeof useGetVisualizationSuspenseQuery>;
export type GetVisualizationQueryResult = Apollo.QueryResult<
  Types.GetVisualizationQuery,
  Types.GetVisualizationQueryVariables
>;
export const GetVisualizationsDocument = gql`
  query GetVisualizations($project_id: StringID!, $input: String!, $count: Int!, $offset: Int!) {
    visualizations(project_id: $project_id, input: $input, count: $count, offset: $offset) {
      count
      results {
        id
        updatedAt
        projectId
        name
        timePreset
        kind
        briefContent
        variables {
          key
          defaultValues
          suggestionType
          field
        }
        graphs {
          id
          type
          title
          productType
          query
          groupByKeys
          bucketByKey
          bucketCount
          bucketInterval
          limit
          limitFunctionType
          limitMetric
          funnelSteps {
            title
            query
          }
          display
          comparisonMode
          strictOrder
          breakdownBy
          breakdownLimit
          nullHandling
          showExemplars
          exemplarScaleMode
          expressions {
            aggregator
            column
          }
          sql
          heatmapSecureSessionId
          heatmapSessionTimestamp
        }
        updatedByAdmin {
          id
          name
          email
          photo_url
        }
      }
    }
  }
`;

/**
 * __useGetVisualizationsQuery__
 *
 * To run a query within a React component, call `useGetVisualizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVisualizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVisualizationsQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      input: // value for 'input'
 *      count: // value for 'count'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetVisualizationsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetVisualizationsQuery, Types.GetVisualizationsQueryVariables> &
    ({ variables: Types.GetVisualizationsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetVisualizationsQuery, Types.GetVisualizationsQueryVariables>(
    GetVisualizationsDocument,
    options,
  );
}
export function useGetVisualizationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetVisualizationsQuery, Types.GetVisualizationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetVisualizationsQuery, Types.GetVisualizationsQueryVariables>(
    GetVisualizationsDocument,
    options,
  );
}
export function useGetVisualizationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetVisualizationsQuery, Types.GetVisualizationsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetVisualizationsQuery, Types.GetVisualizationsQueryVariables>(
    GetVisualizationsDocument,
    options,
  );
}
export type GetVisualizationsQueryHookResult = ReturnType<typeof useGetVisualizationsQuery>;
export type GetVisualizationsLazyQueryHookResult = ReturnType<typeof useGetVisualizationsLazyQuery>;
export type GetVisualizationsSuspenseQueryHookResult = ReturnType<typeof useGetVisualizationsSuspenseQuery>;
export type GetVisualizationsQueryResult = Apollo.QueryResult<
  Types.GetVisualizationsQuery,
  Types.GetVisualizationsQueryVariables
>;
export const GetAiQuerySuggestionDocument = gql`
  query GetAIQuerySuggestion(
    $time_zone: String!
    $project_id: StringID!
    $product_type: ProductType!
    $query: String!
  ) {
    ai_query_suggestion(time_zone: $time_zone, project_id: $project_id, product_type: $product_type, query: $query) {
      query
      date_range {
        start_date
        end_date
      }
    }
  }
`;

/**
 * __useGetAiQuerySuggestionQuery__
 *
 * To run a query within a React component, call `useGetAiQuerySuggestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiQuerySuggestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiQuerySuggestionQuery({
 *   variables: {
 *      time_zone: // value for 'time_zone'
 *      project_id: // value for 'project_id'
 *      product_type: // value for 'product_type'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetAiQuerySuggestionQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetAiQuerySuggestionQuery, Types.GetAiQuerySuggestionQueryVariables> &
    ({ variables: Types.GetAiQuerySuggestionQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetAiQuerySuggestionQuery, Types.GetAiQuerySuggestionQueryVariables>(
    GetAiQuerySuggestionDocument,
    options,
  );
}
export function useGetAiQuerySuggestionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAiQuerySuggestionQuery, Types.GetAiQuerySuggestionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetAiQuerySuggestionQuery, Types.GetAiQuerySuggestionQueryVariables>(
    GetAiQuerySuggestionDocument,
    options,
  );
}
export function useGetAiQuerySuggestionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetAiQuerySuggestionQuery, Types.GetAiQuerySuggestionQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetAiQuerySuggestionQuery, Types.GetAiQuerySuggestionQueryVariables>(
    GetAiQuerySuggestionDocument,
    options,
  );
}
export type GetAiQuerySuggestionQueryHookResult = ReturnType<typeof useGetAiQuerySuggestionQuery>;
export type GetAiQuerySuggestionLazyQueryHookResult = ReturnType<typeof useGetAiQuerySuggestionLazyQuery>;
export type GetAiQuerySuggestionSuspenseQueryHookResult = ReturnType<typeof useGetAiQuerySuggestionSuspenseQuery>;
export type GetAiQuerySuggestionQueryResult = Apollo.QueryResult<
  Types.GetAiQuerySuggestionQuery,
  Types.GetAiQuerySuggestionQueryVariables
>;
export const GetHeatmapClicksDocument = gql`
  query GetHeatmapClicks($project_id: StringID!, $params: QueryInput!) {
    heatmap_clicks(project_id: $project_id, params: $params) {
      xpath
      count
      sessionCount
      userCount
      classname
      elementId
      tag
      text
      sessionInformation {
        secureSessionID
        timestamp
      }
    }
  }
`;

/**
 * __useGetHeatmapClicksQuery__
 *
 * To run a query within a React component, call `useGetHeatmapClicksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHeatmapClicksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeatmapClicksQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetHeatmapClicksQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetHeatmapClicksQuery, Types.GetHeatmapClicksQueryVariables> &
    ({ variables: Types.GetHeatmapClicksQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetHeatmapClicksQuery, Types.GetHeatmapClicksQueryVariables>(
    GetHeatmapClicksDocument,
    options,
  );
}
export function useGetHeatmapClicksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetHeatmapClicksQuery, Types.GetHeatmapClicksQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetHeatmapClicksQuery, Types.GetHeatmapClicksQueryVariables>(
    GetHeatmapClicksDocument,
    options,
  );
}
export function useGetHeatmapClicksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetHeatmapClicksQuery, Types.GetHeatmapClicksQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetHeatmapClicksQuery, Types.GetHeatmapClicksQueryVariables>(
    GetHeatmapClicksDocument,
    options,
  );
}
export type GetHeatmapClicksQueryHookResult = ReturnType<typeof useGetHeatmapClicksQuery>;
export type GetHeatmapClicksLazyQueryHookResult = ReturnType<typeof useGetHeatmapClicksLazyQuery>;
export type GetHeatmapClicksSuspenseQueryHookResult = ReturnType<typeof useGetHeatmapClicksSuspenseQuery>;
export type GetHeatmapClicksQueryResult = Apollo.QueryResult<
  Types.GetHeatmapClicksQuery,
  Types.GetHeatmapClicksQueryVariables
>;
export const GetTimestampEventChunkUrlDocument = gql`
  query GetTimestampEventChunkURL($secure_id: String!, $timestamp: Timestamp!) {
    timestamp_event_chunk_url(secure_id: $secure_id, timestamp: $timestamp)
  }
`;

/**
 * __useGetTimestampEventChunkUrlQuery__
 *
 * To run a query within a React component, call `useGetTimestampEventChunkUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimestampEventChunkUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimestampEventChunkUrlQuery({
 *   variables: {
 *      secure_id: // value for 'secure_id'
 *      timestamp: // value for 'timestamp'
 *   },
 * });
 */
export function useGetTimestampEventChunkUrlQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetTimestampEventChunkUrlQuery,
    Types.GetTimestampEventChunkUrlQueryVariables
  > &
    ({ variables: Types.GetTimestampEventChunkUrlQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetTimestampEventChunkUrlQuery, Types.GetTimestampEventChunkUrlQueryVariables>(
    GetTimestampEventChunkUrlDocument,
    options,
  );
}
export function useGetTimestampEventChunkUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetTimestampEventChunkUrlQuery,
    Types.GetTimestampEventChunkUrlQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetTimestampEventChunkUrlQuery, Types.GetTimestampEventChunkUrlQueryVariables>(
    GetTimestampEventChunkUrlDocument,
    options,
  );
}
export function useGetTimestampEventChunkUrlSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types.GetTimestampEventChunkUrlQuery,
        Types.GetTimestampEventChunkUrlQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetTimestampEventChunkUrlQuery, Types.GetTimestampEventChunkUrlQueryVariables>(
    GetTimestampEventChunkUrlDocument,
    options,
  );
}
export type GetTimestampEventChunkUrlQueryHookResult = ReturnType<typeof useGetTimestampEventChunkUrlQuery>;
export type GetTimestampEventChunkUrlLazyQueryHookResult = ReturnType<typeof useGetTimestampEventChunkUrlLazyQuery>;
export type GetTimestampEventChunkUrlSuspenseQueryHookResult = ReturnType<
  typeof useGetTimestampEventChunkUrlSuspenseQuery
>;
export type GetTimestampEventChunkUrlQueryResult = Apollo.QueryResult<
  Types.GetTimestampEventChunkUrlQuery,
  Types.GetTimestampEventChunkUrlQueryVariables
>;
export const GetConversationHistoryDocument = gql`
  query GetConversationHistory($conversation_id: StringID!, $after_turn: Int) {
    conversation_history(conversation_id: $conversation_id, after_turn: $after_turn) {
      status
      error
      messages {
        id
        conversation_id
        role
        content
        turn
        tokens_used
        is_final
        created_at
      }
    }
  }
`;

/**
 * __useGetConversationHistoryQuery__
 *
 * To run a query within a React component, call `useGetConversationHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationHistoryQuery({
 *   variables: {
 *      conversation_id: // value for 'conversation_id'
 *      after_turn: // value for 'after_turn'
 *   },
 * });
 */
export function useGetConversationHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetConversationHistoryQuery, Types.GetConversationHistoryQueryVariables> &
    ({ variables: Types.GetConversationHistoryQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetConversationHistoryQuery, Types.GetConversationHistoryQueryVariables>(
    GetConversationHistoryDocument,
    options,
  );
}
export function useGetConversationHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetConversationHistoryQuery,
    Types.GetConversationHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetConversationHistoryQuery, Types.GetConversationHistoryQueryVariables>(
    GetConversationHistoryDocument,
    options,
  );
}
export function useGetConversationHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetConversationHistoryQuery, Types.GetConversationHistoryQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetConversationHistoryQuery, Types.GetConversationHistoryQueryVariables>(
    GetConversationHistoryDocument,
    options,
  );
}
export type GetConversationHistoryQueryHookResult = ReturnType<typeof useGetConversationHistoryQuery>;
export type GetConversationHistoryLazyQueryHookResult = ReturnType<typeof useGetConversationHistoryLazyQuery>;
export type GetConversationHistorySuspenseQueryHookResult = ReturnType<typeof useGetConversationHistorySuspenseQuery>;
export type GetConversationHistoryQueryResult = Apollo.QueryResult<
  Types.GetConversationHistoryQuery,
  Types.GetConversationHistoryQueryVariables
>;
export const GetClickSessionsDocument = gql`
  query GetClickSessions(
    $project_id: StringID!
    $count: Int!
    $params: QueryInput!
    $sort_desc: Boolean!
    $sort_field: String
    $page: Int
  ) {
    click_sessions(
      project_id: $project_id
      count: $count
      params: $params
      sort_field: $sort_field
      sort_desc: $sort_desc
      page: $page
    ) {
      sessions {
        id
        secure_id
        client_id
        fingerprint
        identifier
        identified
        os_name
        os_version
        browser_name
        browser_version
        ip
        city
        state
        country
        postal
        created_at
        language
        length
        active_length
        enable_recording_network_contents
        viewed
        starred
        processed
        has_rage_clicks
        has_errors
        fields {
          name
          value
          type
          id
        }
        first_time
        user_properties
        event_counts
        last_user_interaction_time
        is_public
        excluded
        email
      }
      totalCount
    }
  }
`;

/**
 * __useGetClickSessionsQuery__
 *
 * To run a query within a React component, call `useGetClickSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClickSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClickSessionsQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      count: // value for 'count'
 *      params: // value for 'params'
 *      sort_desc: // value for 'sort_desc'
 *      sort_field: // value for 'sort_field'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetClickSessionsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetClickSessionsQuery, Types.GetClickSessionsQueryVariables> &
    ({ variables: Types.GetClickSessionsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetClickSessionsQuery, Types.GetClickSessionsQueryVariables>(
    GetClickSessionsDocument,
    options,
  );
}
export function useGetClickSessionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetClickSessionsQuery, Types.GetClickSessionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetClickSessionsQuery, Types.GetClickSessionsQueryVariables>(
    GetClickSessionsDocument,
    options,
  );
}
export function useGetClickSessionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetClickSessionsQuery, Types.GetClickSessionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetClickSessionsQuery, Types.GetClickSessionsQueryVariables>(
    GetClickSessionsDocument,
    options,
  );
}
export type GetClickSessionsQueryHookResult = ReturnType<typeof useGetClickSessionsQuery>;
export type GetClickSessionsLazyQueryHookResult = ReturnType<typeof useGetClickSessionsLazyQuery>;
export type GetClickSessionsSuspenseQueryHookResult = ReturnType<typeof useGetClickSessionsSuspenseQuery>;
export type GetClickSessionsQueryResult = Apollo.QueryResult<
  Types.GetClickSessionsQuery,
  Types.GetClickSessionsQueryVariables
>;
export const GetAiChatLimitStatusDocument = gql`
  query GetAiChatLimitStatus($project_id: StringID!) {
    aiChatLimitStatus(project_id: $project_id) {
      current_count
      limit
      workspace_id
    }
  }
`;

/**
 * __useGetAiChatLimitStatusQuery__
 *
 * To run a query within a React component, call `useGetAiChatLimitStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiChatLimitStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiChatLimitStatusQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *   },
 * });
 */
export function useGetAiChatLimitStatusQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetAiChatLimitStatusQuery, Types.GetAiChatLimitStatusQueryVariables> &
    ({ variables: Types.GetAiChatLimitStatusQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetAiChatLimitStatusQuery, Types.GetAiChatLimitStatusQueryVariables>(
    GetAiChatLimitStatusDocument,
    options,
  );
}
export function useGetAiChatLimitStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAiChatLimitStatusQuery, Types.GetAiChatLimitStatusQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetAiChatLimitStatusQuery, Types.GetAiChatLimitStatusQueryVariables>(
    GetAiChatLimitStatusDocument,
    options,
  );
}
export function useGetAiChatLimitStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetAiChatLimitStatusQuery, Types.GetAiChatLimitStatusQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetAiChatLimitStatusQuery, Types.GetAiChatLimitStatusQueryVariables>(
    GetAiChatLimitStatusDocument,
    options,
  );
}
export type GetAiChatLimitStatusQueryHookResult = ReturnType<typeof useGetAiChatLimitStatusQuery>;
export type GetAiChatLimitStatusLazyQueryHookResult = ReturnType<typeof useGetAiChatLimitStatusLazyQuery>;
export type GetAiChatLimitStatusSuspenseQueryHookResult = ReturnType<typeof useGetAiChatLimitStatusSuspenseQuery>;
export type GetAiChatLimitStatusQueryResult = Apollo.QueryResult<
  Types.GetAiChatLimitStatusQuery,
  Types.GetAiChatLimitStatusQueryVariables
>;
export const GetFilterRulesDocument = gql`
  query GetFilterRules($projectId: StringID!, $productType: ProductType!) {
    filterRules(project_id: $projectId, product_type: $productType) {
      rules {
        rule {
          ... on QueryFilterRule {
            id
            rule_name
            is_rule_enabled
            product_type
            project_id
            query
            filter_operation
            filter_operation_rate
            attributes
            created_at
            updated_at
          }
        }
      }
      rules_order
    }
  }
`;

/**
 * __useGetFilterRulesQuery__
 *
 * To run a query within a React component, call `useGetFilterRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilterRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilterRulesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      productType: // value for 'productType'
 *   },
 * });
 */
export function useGetFilterRulesQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetFilterRulesQuery, Types.GetFilterRulesQueryVariables> &
    ({ variables: Types.GetFilterRulesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetFilterRulesQuery, Types.GetFilterRulesQueryVariables>(
    GetFilterRulesDocument,
    options,
  );
}
export function useGetFilterRulesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetFilterRulesQuery, Types.GetFilterRulesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetFilterRulesQuery, Types.GetFilterRulesQueryVariables>(
    GetFilterRulesDocument,
    options,
  );
}
export function useGetFilterRulesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetFilterRulesQuery, Types.GetFilterRulesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetFilterRulesQuery, Types.GetFilterRulesQueryVariables>(
    GetFilterRulesDocument,
    options,
  );
}
export type GetFilterRulesQueryHookResult = ReturnType<typeof useGetFilterRulesQuery>;
export type GetFilterRulesLazyQueryHookResult = ReturnType<typeof useGetFilterRulesLazyQuery>;
export type GetFilterRulesSuspenseQueryHookResult = ReturnType<typeof useGetFilterRulesSuspenseQuery>;
export type GetFilterRulesQueryResult = Apollo.QueryResult<
  Types.GetFilterRulesQuery,
  Types.GetFilterRulesQueryVariables
>;
export const GetQueryFilterRuleDocument = gql`
  query GetQueryFilterRule($id: StringID!, $projectId: StringID!) {
    queryFilterRule(id: $id, project_id: $projectId) {
      rule {
        id
        rule_name
        is_rule_enabled
        product_type
        project_id
        query
        filter_operation
        filter_operation_rate
        attributes
        created_at
        updated_at
      }
    }
  }
`;

/**
 * __useGetQueryFilterRuleQuery__
 *
 * To run a query within a React component, call `useGetQueryFilterRuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueryFilterRuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueryFilterRuleQuery({
 *   variables: {
 *      id: // value for 'id'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetQueryFilterRuleQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetQueryFilterRuleQuery, Types.GetQueryFilterRuleQueryVariables> &
    ({ variables: Types.GetQueryFilterRuleQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetQueryFilterRuleQuery, Types.GetQueryFilterRuleQueryVariables>(
    GetQueryFilterRuleDocument,
    options,
  );
}
export function useGetQueryFilterRuleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetQueryFilterRuleQuery, Types.GetQueryFilterRuleQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetQueryFilterRuleQuery, Types.GetQueryFilterRuleQueryVariables>(
    GetQueryFilterRuleDocument,
    options,
  );
}
export function useGetQueryFilterRuleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetQueryFilterRuleQuery, Types.GetQueryFilterRuleQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetQueryFilterRuleQuery, Types.GetQueryFilterRuleQueryVariables>(
    GetQueryFilterRuleDocument,
    options,
  );
}
export type GetQueryFilterRuleQueryHookResult = ReturnType<typeof useGetQueryFilterRuleQuery>;
export type GetQueryFilterRuleLazyQueryHookResult = ReturnType<typeof useGetQueryFilterRuleLazyQuery>;
export type GetQueryFilterRuleSuspenseQueryHookResult = ReturnType<typeof useGetQueryFilterRuleSuspenseQuery>;
export type GetQueryFilterRuleQueryResult = Apollo.QueryResult<
  Types.GetQueryFilterRuleQuery,
  Types.GetQueryFilterRuleQueryVariables
>;
export const GetServiceMapDocument = gql`
  query GetServiceMap($project_id: StringID!, $date_range: DateRangeRequiredInput!) {
    serviceMap(project_id: $project_id, date_range: $date_range) {
      source
      target
    }
  }
`;

/**
 * __useGetServiceMapQuery__
 *
 * To run a query within a React component, call `useGetServiceMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceMapQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      date_range: // value for 'date_range'
 *   },
 * });
 */
export function useGetServiceMapQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetServiceMapQuery, Types.GetServiceMapQueryVariables> &
    ({ variables: Types.GetServiceMapQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetServiceMapQuery, Types.GetServiceMapQueryVariables>(GetServiceMapDocument, options);
}
export function useGetServiceMapLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetServiceMapQuery, Types.GetServiceMapQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetServiceMapQuery, Types.GetServiceMapQueryVariables>(
    GetServiceMapDocument,
    options,
  );
}
export function useGetServiceMapSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetServiceMapQuery, Types.GetServiceMapQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetServiceMapQuery, Types.GetServiceMapQueryVariables>(
    GetServiceMapDocument,
    options,
  );
}
export type GetServiceMapQueryHookResult = ReturnType<typeof useGetServiceMapQuery>;
export type GetServiceMapLazyQueryHookResult = ReturnType<typeof useGetServiceMapLazyQuery>;
export type GetServiceMapSuspenseQueryHookResult = ReturnType<typeof useGetServiceMapSuspenseQuery>;
export type GetServiceMapQueryResult = Apollo.QueryResult<Types.GetServiceMapQuery, Types.GetServiceMapQueryVariables>;
export const GetTraceServiceSummaryDocument = gql`
  query GetTraceServiceSummary($project_id: StringID!, $params: TraceServiceSummaryParamsInput!) {
    traceServiceSummary(project_id: $project_id, params: $params) {
      buckets {
        service_name
        time_bucket
        request_count
        error_count
      }
    }
  }
`;

/**
 * __useGetTraceServiceSummaryQuery__
 *
 * To run a query within a React component, call `useGetTraceServiceSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTraceServiceSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTraceServiceSummaryQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetTraceServiceSummaryQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetTraceServiceSummaryQuery, Types.GetTraceServiceSummaryQueryVariables> &
    ({ variables: Types.GetTraceServiceSummaryQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetTraceServiceSummaryQuery, Types.GetTraceServiceSummaryQueryVariables>(
    GetTraceServiceSummaryDocument,
    options,
  );
}
export function useGetTraceServiceSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetTraceServiceSummaryQuery,
    Types.GetTraceServiceSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetTraceServiceSummaryQuery, Types.GetTraceServiceSummaryQueryVariables>(
    GetTraceServiceSummaryDocument,
    options,
  );
}
export function useGetTraceServiceSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetTraceServiceSummaryQuery, Types.GetTraceServiceSummaryQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetTraceServiceSummaryQuery, Types.GetTraceServiceSummaryQueryVariables>(
    GetTraceServiceSummaryDocument,
    options,
  );
}
export type GetTraceServiceSummaryQueryHookResult = ReturnType<typeof useGetTraceServiceSummaryQuery>;
export type GetTraceServiceSummaryLazyQueryHookResult = ReturnType<typeof useGetTraceServiceSummaryLazyQuery>;
export type GetTraceServiceSummarySuspenseQueryHookResult = ReturnType<typeof useGetTraceServiceSummarySuspenseQuery>;
export type GetTraceServiceSummaryQueryResult = Apollo.QueryResult<
  Types.GetTraceServiceSummaryQuery,
  Types.GetTraceServiceSummaryQueryVariables
>;
export const GetServiceConnectionsDocument = gql`
  query GetServiceConnections(
    $project_id: StringID!
    $service_name: String!
    $date_range: DateRangeRequiredInput!
    $environment_ids: [String!]
  ) {
    serviceConnections(
      project_id: $project_id
      service_name: $service_name
      date_range: $date_range
      environment_ids: $environment_ids
    ) {
      incoming
      outgoing
    }
  }
`;

/**
 * __useGetServiceConnectionsQuery__
 *
 * To run a query within a React component, call `useGetServiceConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceConnectionsQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      service_name: // value for 'service_name'
 *      date_range: // value for 'date_range'
 *      environment_ids: // value for 'environment_ids'
 *   },
 * });
 */
export function useGetServiceConnectionsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetServiceConnectionsQuery, Types.GetServiceConnectionsQueryVariables> &
    ({ variables: Types.GetServiceConnectionsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetServiceConnectionsQuery, Types.GetServiceConnectionsQueryVariables>(
    GetServiceConnectionsDocument,
    options,
  );
}
export function useGetServiceConnectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetServiceConnectionsQuery,
    Types.GetServiceConnectionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetServiceConnectionsQuery, Types.GetServiceConnectionsQueryVariables>(
    GetServiceConnectionsDocument,
    options,
  );
}
export function useGetServiceConnectionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetServiceConnectionsQuery, Types.GetServiceConnectionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetServiceConnectionsQuery, Types.GetServiceConnectionsQueryVariables>(
    GetServiceConnectionsDocument,
    options,
  );
}
export type GetServiceConnectionsQueryHookResult = ReturnType<typeof useGetServiceConnectionsQuery>;
export type GetServiceConnectionsLazyQueryHookResult = ReturnType<typeof useGetServiceConnectionsLazyQuery>;
export type GetServiceConnectionsSuspenseQueryHookResult = ReturnType<typeof useGetServiceConnectionsSuspenseQuery>;
export type GetServiceConnectionsQueryResult = Apollo.QueryResult<
  Types.GetServiceConnectionsQuery,
  Types.GetServiceConnectionsQueryVariables
>;
export const GetAiConversationHistoryDocument = gql`
  query GetAiConversationHistory(
    $project_id: StringID!
    $count: Int!
    $page: Int
    $user_email: String
    $date_range: DateRangeInput
    $tag_key: String
    $tag_value: String
    $shared_only: Boolean
    $query: String
    $origin: AgentConversationOrigin
    $agent_kind: String
  ) {
    aiConversationHistory(
      project_id: $project_id
      count: $count
      page: $page
      user_email: $user_email
      date_range: $date_range
      tag_key: $tag_key
      tag_value: $tag_value
      shared_only: $shared_only
      query: $query
      origin: $origin
      agent_kind: $agent_kind
    ) {
      totalCount
      conversations {
        conversation_id
        user_email
        user_message_count
        agent_message_count
        initiated_at
        last_user_message_at
        message_preview
        title
        status
        agent_kind
        origin
        tags {
          key
          value
        }
        is_shared
      }
    }
  }
`;

/**
 * __useGetAiConversationHistoryQuery__
 *
 * To run a query within a React component, call `useGetAiConversationHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiConversationHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiConversationHistoryQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      count: // value for 'count'
 *      page: // value for 'page'
 *      user_email: // value for 'user_email'
 *      date_range: // value for 'date_range'
 *      tag_key: // value for 'tag_key'
 *      tag_value: // value for 'tag_value'
 *      shared_only: // value for 'shared_only'
 *      query: // value for 'query'
 *      origin: // value for 'origin'
 *      agent_kind: // value for 'agent_kind'
 *   },
 * });
 */
export function useGetAiConversationHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetAiConversationHistoryQuery,
    Types.GetAiConversationHistoryQueryVariables
  > &
    ({ variables: Types.GetAiConversationHistoryQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetAiConversationHistoryQuery, Types.GetAiConversationHistoryQueryVariables>(
    GetAiConversationHistoryDocument,
    options,
  );
}
export function useGetAiConversationHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetAiConversationHistoryQuery,
    Types.GetAiConversationHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetAiConversationHistoryQuery, Types.GetAiConversationHistoryQueryVariables>(
    GetAiConversationHistoryDocument,
    options,
  );
}
export function useGetAiConversationHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types.GetAiConversationHistoryQuery,
        Types.GetAiConversationHistoryQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetAiConversationHistoryQuery, Types.GetAiConversationHistoryQueryVariables>(
    GetAiConversationHistoryDocument,
    options,
  );
}
export type GetAiConversationHistoryQueryHookResult = ReturnType<typeof useGetAiConversationHistoryQuery>;
export type GetAiConversationHistoryLazyQueryHookResult = ReturnType<typeof useGetAiConversationHistoryLazyQuery>;
export type GetAiConversationHistorySuspenseQueryHookResult = ReturnType<
  typeof useGetAiConversationHistorySuspenseQuery
>;
export type GetAiConversationHistoryQueryResult = Apollo.QueryResult<
  Types.GetAiConversationHistoryQuery,
  Types.GetAiConversationHistoryQueryVariables
>;
export const GetAgentArtifactDocument = gql`
  query GetAgentArtifact($project_id: StringID!, $type: String!, $external_id: String!) {
    agentArtifact(project_id: $project_id, type: $type, external_id: $external_id) {
      artifact {
        id
        type
        external_id
        title
        url
        status
        created_at
        updated_at
      }
      events {
        id
        event_type
        status
        conversation_id
        payload
        created_at
      }
      conversation_links {
        conversation_id
        user_email
        is_shared
        relationship
        source
        linked_at
        message_preview
        title
      }
      github_pull_request {
        owner
        repo
        number
        title
        body
        state
        merged
        draft
        html_url
        created_at
        updated_at
        reviews {
          user
          state
          submitted_at
        }
        checks {
          total
          success
          failure
          pending
          neutral
        }
        timeline {
          type
          actor
          at
          title
          url
        }
      }
    }
  }
`;

/**
 * __useGetAgentArtifactQuery__
 *
 * To run a query within a React component, call `useGetAgentArtifactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentArtifactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentArtifactQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      type: // value for 'type'
 *      external_id: // value for 'external_id'
 *   },
 * });
 */
export function useGetAgentArtifactQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetAgentArtifactQuery, Types.GetAgentArtifactQueryVariables> &
    ({ variables: Types.GetAgentArtifactQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetAgentArtifactQuery, Types.GetAgentArtifactQueryVariables>(
    GetAgentArtifactDocument,
    options,
  );
}
export function useGetAgentArtifactLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAgentArtifactQuery, Types.GetAgentArtifactQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetAgentArtifactQuery, Types.GetAgentArtifactQueryVariables>(
    GetAgentArtifactDocument,
    options,
  );
}
export function useGetAgentArtifactSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetAgentArtifactQuery, Types.GetAgentArtifactQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetAgentArtifactQuery, Types.GetAgentArtifactQueryVariables>(
    GetAgentArtifactDocument,
    options,
  );
}
export type GetAgentArtifactQueryHookResult = ReturnType<typeof useGetAgentArtifactQuery>;
export type GetAgentArtifactLazyQueryHookResult = ReturnType<typeof useGetAgentArtifactLazyQuery>;
export type GetAgentArtifactSuspenseQueryHookResult = ReturnType<typeof useGetAgentArtifactSuspenseQuery>;
export type GetAgentArtifactQueryResult = Apollo.QueryResult<
  Types.GetAgentArtifactQuery,
  Types.GetAgentArtifactQueryVariables
>;
export const GetProjectArtifactsDocument = gql`
  query GetProjectArtifacts(
    $project_id: StringID!
    $search: String
    $type: String
    $source: String
    $count: Int!
    $page: Int
    $creator: ArtifactCreatorFilter
  ) {
    projectArtifacts(
      project_id: $project_id
      search: $search
      type: $type
      source: $source
      count: $count
      page: $page
      creator: $creator
    ) {
      totalCount
      artifacts {
        id
        type
        external_id
        title
        url
        status
        updated_at
      }
    }
  }
`;

/**
 * __useGetProjectArtifactsQuery__
 *
 * To run a query within a React component, call `useGetProjectArtifactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectArtifactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectArtifactsQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      search: // value for 'search'
 *      type: // value for 'type'
 *      source: // value for 'source'
 *      count: // value for 'count'
 *      page: // value for 'page'
 *      creator: // value for 'creator'
 *   },
 * });
 */
export function useGetProjectArtifactsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetProjectArtifactsQuery, Types.GetProjectArtifactsQueryVariables> &
    ({ variables: Types.GetProjectArtifactsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetProjectArtifactsQuery, Types.GetProjectArtifactsQueryVariables>(
    GetProjectArtifactsDocument,
    options,
  );
}
export function useGetProjectArtifactsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetProjectArtifactsQuery, Types.GetProjectArtifactsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetProjectArtifactsQuery, Types.GetProjectArtifactsQueryVariables>(
    GetProjectArtifactsDocument,
    options,
  );
}
export function useGetProjectArtifactsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetProjectArtifactsQuery, Types.GetProjectArtifactsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetProjectArtifactsQuery, Types.GetProjectArtifactsQueryVariables>(
    GetProjectArtifactsDocument,
    options,
  );
}
export type GetProjectArtifactsQueryHookResult = ReturnType<typeof useGetProjectArtifactsQuery>;
export type GetProjectArtifactsLazyQueryHookResult = ReturnType<typeof useGetProjectArtifactsLazyQuery>;
export type GetProjectArtifactsSuspenseQueryHookResult = ReturnType<typeof useGetProjectArtifactsSuspenseQuery>;
export type GetProjectArtifactsQueryResult = Apollo.QueryResult<
  Types.GetProjectArtifactsQuery,
  Types.GetProjectArtifactsQueryVariables
>;
export const GetConversationArtifactsDocument = gql`
  query GetConversationArtifacts(
    $project_id: StringID!
    $conversation_id: String!
    $relationships: [String!]
    $limit: Int
  ) {
    conversationArtifacts(
      project_id: $project_id
      conversation_id: $conversation_id
      relationships: $relationships
      limit: $limit
    ) {
      id
      type
      external_id
      title
      url
      status
      created_at
      updated_at
    }
  }
`;

/**
 * __useGetConversationArtifactsQuery__
 *
 * To run a query within a React component, call `useGetConversationArtifactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationArtifactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationArtifactsQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      conversation_id: // value for 'conversation_id'
 *      relationships: // value for 'relationships'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetConversationArtifactsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetConversationArtifactsQuery,
    Types.GetConversationArtifactsQueryVariables
  > &
    ({ variables: Types.GetConversationArtifactsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetConversationArtifactsQuery, Types.GetConversationArtifactsQueryVariables>(
    GetConversationArtifactsDocument,
    options,
  );
}
export function useGetConversationArtifactsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetConversationArtifactsQuery,
    Types.GetConversationArtifactsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetConversationArtifactsQuery, Types.GetConversationArtifactsQueryVariables>(
    GetConversationArtifactsDocument,
    options,
  );
}
export function useGetConversationArtifactsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types.GetConversationArtifactsQuery,
        Types.GetConversationArtifactsQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetConversationArtifactsQuery, Types.GetConversationArtifactsQueryVariables>(
    GetConversationArtifactsDocument,
    options,
  );
}
export type GetConversationArtifactsQueryHookResult = ReturnType<typeof useGetConversationArtifactsQuery>;
export type GetConversationArtifactsLazyQueryHookResult = ReturnType<typeof useGetConversationArtifactsLazyQuery>;
export type GetConversationArtifactsSuspenseQueryHookResult = ReturnType<
  typeof useGetConversationArtifactsSuspenseQuery
>;
export type GetConversationArtifactsQueryResult = Apollo.QueryResult<
  Types.GetConversationArtifactsQuery,
  Types.GetConversationArtifactsQueryVariables
>;
export const GetFlagCleanupsDocument = gql`
  query GetFlagCleanups($project_id: StringID!, $count: Int!, $page: Int, $date_range: DateRangeInput) {
    flagCleanups(project_id: $project_id, count: $count, page: $page, date_range: $date_range) {
      totalCount
      flag_cleanups {
        flag_name
        pr_link
        cleaned_at
      }
    }
  }
`;

/**
 * __useGetFlagCleanupsQuery__
 *
 * To run a query within a React component, call `useGetFlagCleanupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFlagCleanupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFlagCleanupsQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      count: // value for 'count'
 *      page: // value for 'page'
 *      date_range: // value for 'date_range'
 *   },
 * });
 */
export function useGetFlagCleanupsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetFlagCleanupsQuery, Types.GetFlagCleanupsQueryVariables> &
    ({ variables: Types.GetFlagCleanupsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetFlagCleanupsQuery, Types.GetFlagCleanupsQueryVariables>(
    GetFlagCleanupsDocument,
    options,
  );
}
export function useGetFlagCleanupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetFlagCleanupsQuery, Types.GetFlagCleanupsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetFlagCleanupsQuery, Types.GetFlagCleanupsQueryVariables>(
    GetFlagCleanupsDocument,
    options,
  );
}
export function useGetFlagCleanupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetFlagCleanupsQuery, Types.GetFlagCleanupsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetFlagCleanupsQuery, Types.GetFlagCleanupsQueryVariables>(
    GetFlagCleanupsDocument,
    options,
  );
}
export type GetFlagCleanupsQueryHookResult = ReturnType<typeof useGetFlagCleanupsQuery>;
export type GetFlagCleanupsLazyQueryHookResult = ReturnType<typeof useGetFlagCleanupsLazyQuery>;
export type GetFlagCleanupsSuspenseQueryHookResult = ReturnType<typeof useGetFlagCleanupsSuspenseQuery>;
export type GetFlagCleanupsQueryResult = Apollo.QueryResult<
  Types.GetFlagCleanupsQuery,
  Types.GetFlagCleanupsQueryVariables
>;
export const GetVegaSlackConfigurationDocument = gql`
  query GetVegaSlackConfiguration {
    vega_slack_configuration {
      id
      admin_id
      permission_mode
      investigation_prompt
      investigation_project_id
      investigation_repositories
    }
  }
`;

/**
 * __useGetVegaSlackConfigurationQuery__
 *
 * To run a query within a React component, call `useGetVegaSlackConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVegaSlackConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVegaSlackConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVegaSlackConfigurationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.GetVegaSlackConfigurationQuery,
    Types.GetVegaSlackConfigurationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetVegaSlackConfigurationQuery, Types.GetVegaSlackConfigurationQueryVariables>(
    GetVegaSlackConfigurationDocument,
    options,
  );
}
export function useGetVegaSlackConfigurationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetVegaSlackConfigurationQuery,
    Types.GetVegaSlackConfigurationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetVegaSlackConfigurationQuery, Types.GetVegaSlackConfigurationQueryVariables>(
    GetVegaSlackConfigurationDocument,
    options,
  );
}
export function useGetVegaSlackConfigurationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types.GetVegaSlackConfigurationQuery,
        Types.GetVegaSlackConfigurationQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetVegaSlackConfigurationQuery, Types.GetVegaSlackConfigurationQueryVariables>(
    GetVegaSlackConfigurationDocument,
    options,
  );
}
export type GetVegaSlackConfigurationQueryHookResult = ReturnType<typeof useGetVegaSlackConfigurationQuery>;
export type GetVegaSlackConfigurationLazyQueryHookResult = ReturnType<typeof useGetVegaSlackConfigurationLazyQuery>;
export type GetVegaSlackConfigurationSuspenseQueryHookResult = ReturnType<
  typeof useGetVegaSlackConfigurationSuspenseQuery
>;
export type GetVegaSlackConfigurationQueryResult = Apollo.QueryResult<
  Types.GetVegaSlackConfigurationQuery,
  Types.GetVegaSlackConfigurationQueryVariables
>;
export const GetVegaProjectConfigurationDocument = gql`
  query GetVegaProjectConfiguration($project_id: StringID!) {
    vega_project_configuration(project_id: $project_id) {
      id
      project_id
      pull_request_title_prefix
      pull_request_bot_identity_workflows
    }
  }
`;

/**
 * __useGetVegaProjectConfigurationQuery__
 *
 * To run a query within a React component, call `useGetVegaProjectConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVegaProjectConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVegaProjectConfigurationQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *   },
 * });
 */
export function useGetVegaProjectConfigurationQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetVegaProjectConfigurationQuery,
    Types.GetVegaProjectConfigurationQueryVariables
  > &
    ({ variables: Types.GetVegaProjectConfigurationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetVegaProjectConfigurationQuery, Types.GetVegaProjectConfigurationQueryVariables>(
    GetVegaProjectConfigurationDocument,
    options,
  );
}
export function useGetVegaProjectConfigurationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetVegaProjectConfigurationQuery,
    Types.GetVegaProjectConfigurationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetVegaProjectConfigurationQuery, Types.GetVegaProjectConfigurationQueryVariables>(
    GetVegaProjectConfigurationDocument,
    options,
  );
}
export function useGetVegaProjectConfigurationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types.GetVegaProjectConfigurationQuery,
        Types.GetVegaProjectConfigurationQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.GetVegaProjectConfigurationQuery,
    Types.GetVegaProjectConfigurationQueryVariables
  >(GetVegaProjectConfigurationDocument, options);
}
export type GetVegaProjectConfigurationQueryHookResult = ReturnType<typeof useGetVegaProjectConfigurationQuery>;
export type GetVegaProjectConfigurationLazyQueryHookResult = ReturnType<typeof useGetVegaProjectConfigurationLazyQuery>;
export type GetVegaProjectConfigurationSuspenseQueryHookResult = ReturnType<
  typeof useGetVegaProjectConfigurationSuspenseQuery
>;
export type GetVegaProjectConfigurationQueryResult = Apollo.QueryResult<
  Types.GetVegaProjectConfigurationQuery,
  Types.GetVegaProjectConfigurationQueryVariables
>;
export const GetDashboardOptionsDocument = gql`
  query GetDashboardOptions($project_id: StringID!, $query: String, $limit: Int) {
    dashboard_options(project_id: $project_id, query: $query, limit: $limit) {
      id
      name
    }
  }
`;

/**
 * __useGetDashboardOptionsQuery__
 *
 * To run a query within a React component, call `useGetDashboardOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardOptionsQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetDashboardOptionsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetDashboardOptionsQuery, Types.GetDashboardOptionsQueryVariables> &
    ({ variables: Types.GetDashboardOptionsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetDashboardOptionsQuery, Types.GetDashboardOptionsQueryVariables>(
    GetDashboardOptionsDocument,
    options,
  );
}
export function useGetDashboardOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetDashboardOptionsQuery, Types.GetDashboardOptionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetDashboardOptionsQuery, Types.GetDashboardOptionsQueryVariables>(
    GetDashboardOptionsDocument,
    options,
  );
}
export function useGetDashboardOptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetDashboardOptionsQuery, Types.GetDashboardOptionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetDashboardOptionsQuery, Types.GetDashboardOptionsQueryVariables>(
    GetDashboardOptionsDocument,
    options,
  );
}
export type GetDashboardOptionsQueryHookResult = ReturnType<typeof useGetDashboardOptionsQuery>;
export type GetDashboardOptionsLazyQueryHookResult = ReturnType<typeof useGetDashboardOptionsLazyQuery>;
export type GetDashboardOptionsSuspenseQueryHookResult = ReturnType<typeof useGetDashboardOptionsSuspenseQuery>;
export type GetDashboardOptionsQueryResult = Apollo.QueryResult<
  Types.GetDashboardOptionsQuery,
  Types.GetDashboardOptionsQueryVariables
>;
export const GetGraphOptionsDocument = gql`
  query GetGraphOptions($project_id: StringID!, $dashboard_id: ID, $query: String, $limit: Int) {
    graph_options(project_id: $project_id, dashboard_id: $dashboard_id, query: $query, limit: $limit) {
      id
      name
    }
  }
`;

/**
 * __useGetGraphOptionsQuery__
 *
 * To run a query within a React component, call `useGetGraphOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraphOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGraphOptionsQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      dashboard_id: // value for 'dashboard_id'
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetGraphOptionsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetGraphOptionsQuery, Types.GetGraphOptionsQueryVariables> &
    ({ variables: Types.GetGraphOptionsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetGraphOptionsQuery, Types.GetGraphOptionsQueryVariables>(
    GetGraphOptionsDocument,
    options,
  );
}
export function useGetGraphOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetGraphOptionsQuery, Types.GetGraphOptionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetGraphOptionsQuery, Types.GetGraphOptionsQueryVariables>(
    GetGraphOptionsDocument,
    options,
  );
}
export function useGetGraphOptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetGraphOptionsQuery, Types.GetGraphOptionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetGraphOptionsQuery, Types.GetGraphOptionsQueryVariables>(
    GetGraphOptionsDocument,
    options,
  );
}
export type GetGraphOptionsQueryHookResult = ReturnType<typeof useGetGraphOptionsQuery>;
export type GetGraphOptionsLazyQueryHookResult = ReturnType<typeof useGetGraphOptionsLazyQuery>;
export type GetGraphOptionsSuspenseQueryHookResult = ReturnType<typeof useGetGraphOptionsSuspenseQuery>;
export type GetGraphOptionsQueryResult = Apollo.QueryResult<
  Types.GetGraphOptionsQuery,
  Types.GetGraphOptionsQueryVariables
>;
export const GetAlertOptionsDocument = gql`
  query GetAlertOptions($project_id: StringID!, $query: String, $limit: Int) {
    alert_options(project_id: $project_id, query: $query, limit: $limit) {
      id
      name
    }
  }
`;

/**
 * __useGetAlertOptionsQuery__
 *
 * To run a query within a React component, call `useGetAlertOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlertOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlertOptionsQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAlertOptionsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetAlertOptionsQuery, Types.GetAlertOptionsQueryVariables> &
    ({ variables: Types.GetAlertOptionsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetAlertOptionsQuery, Types.GetAlertOptionsQueryVariables>(
    GetAlertOptionsDocument,
    options,
  );
}
export function useGetAlertOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAlertOptionsQuery, Types.GetAlertOptionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetAlertOptionsQuery, Types.GetAlertOptionsQueryVariables>(
    GetAlertOptionsDocument,
    options,
  );
}
export function useGetAlertOptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetAlertOptionsQuery, Types.GetAlertOptionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetAlertOptionsQuery, Types.GetAlertOptionsQueryVariables>(
    GetAlertOptionsDocument,
    options,
  );
}
export type GetAlertOptionsQueryHookResult = ReturnType<typeof useGetAlertOptionsQuery>;
export type GetAlertOptionsLazyQueryHookResult = ReturnType<typeof useGetAlertOptionsLazyQuery>;
export type GetAlertOptionsSuspenseQueryHookResult = ReturnType<typeof useGetAlertOptionsSuspenseQuery>;
export type GetAlertOptionsQueryResult = Apollo.QueryResult<
  Types.GetAlertOptionsQuery,
  Types.GetAlertOptionsQueryVariables
>;
export const GetPaEventsDocument = gql`
  query GetPAEvents(
    $project_id: StringID!
    $params: QueryInput!
    $after: String
    $before: String
    $at: String
    $direction: SortDirection!
    $limit: Int
    $query_settings: QuerySettingsInput
  ) {
    pa_events(
      project_id: $project_id
      params: $params
      after: $after
      before: $before
      at: $at
      direction: $direction
      limit: $limit
      query_settings: $query_settings
    ) {
      edges {
        cursor
        node {
          type
          timestamp
          attributes
          secureSessionID
          contextKeys
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      sampled
    }
  }
`;

/**
 * __useGetPaEventsQuery__
 *
 * To run a query within a React component, call `useGetPaEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaEventsQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      params: // value for 'params'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      at: // value for 'at'
 *      direction: // value for 'direction'
 *      limit: // value for 'limit'
 *      query_settings: // value for 'query_settings'
 *   },
 * });
 */
export function useGetPaEventsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetPaEventsQuery, Types.GetPaEventsQueryVariables> &
    ({ variables: Types.GetPaEventsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetPaEventsQuery, Types.GetPaEventsQueryVariables>(GetPaEventsDocument, options);
}
export function useGetPaEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPaEventsQuery, Types.GetPaEventsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetPaEventsQuery, Types.GetPaEventsQueryVariables>(GetPaEventsDocument, options);
}
export function useGetPaEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetPaEventsQuery, Types.GetPaEventsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetPaEventsQuery, Types.GetPaEventsQueryVariables>(GetPaEventsDocument, options);
}
export type GetPaEventsQueryHookResult = ReturnType<typeof useGetPaEventsQuery>;
export type GetPaEventsLazyQueryHookResult = ReturnType<typeof useGetPaEventsLazyQuery>;
export type GetPaEventsSuspenseQueryHookResult = ReturnType<typeof useGetPaEventsSuspenseQuery>;
export type GetPaEventsQueryResult = Apollo.QueryResult<Types.GetPaEventsQuery, Types.GetPaEventsQueryVariables>;
export const GetPaEventsFunnelDocument = gql`
  query GetPaEventsFunnel(
    $project_id: StringID!
    $params: QueryInput!
    $funnel_steps: [FunnelStepInput!]!
    $group_by: [String!]!
    $strict_order: Boolean
  ) {
    pa_events_funnel(
      project_id: $project_id
      params: $params
      funnel_steps: $funnel_steps
      group_by: $group_by
      strict_order: $strict_order
    ) {
      steps {
        step_index
        count
      }
    }
  }
`;

/**
 * __useGetPaEventsFunnelQuery__
 *
 * To run a query within a React component, call `useGetPaEventsFunnelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaEventsFunnelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaEventsFunnelQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      params: // value for 'params'
 *      funnel_steps: // value for 'funnel_steps'
 *      group_by: // value for 'group_by'
 *      strict_order: // value for 'strict_order'
 *   },
 * });
 */
export function useGetPaEventsFunnelQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetPaEventsFunnelQuery, Types.GetPaEventsFunnelQueryVariables> &
    ({ variables: Types.GetPaEventsFunnelQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetPaEventsFunnelQuery, Types.GetPaEventsFunnelQueryVariables>(
    GetPaEventsFunnelDocument,
    options,
  );
}
export function useGetPaEventsFunnelLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPaEventsFunnelQuery, Types.GetPaEventsFunnelQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetPaEventsFunnelQuery, Types.GetPaEventsFunnelQueryVariables>(
    GetPaEventsFunnelDocument,
    options,
  );
}
export function useGetPaEventsFunnelSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetPaEventsFunnelQuery, Types.GetPaEventsFunnelQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetPaEventsFunnelQuery, Types.GetPaEventsFunnelQueryVariables>(
    GetPaEventsFunnelDocument,
    options,
  );
}
export type GetPaEventsFunnelQueryHookResult = ReturnType<typeof useGetPaEventsFunnelQuery>;
export type GetPaEventsFunnelLazyQueryHookResult = ReturnType<typeof useGetPaEventsFunnelLazyQuery>;
export type GetPaEventsFunnelSuspenseQueryHookResult = ReturnType<typeof useGetPaEventsFunnelSuspenseQuery>;
export type GetPaEventsFunnelQueryResult = Apollo.QueryResult<
  Types.GetPaEventsFunnelQuery,
  Types.GetPaEventsFunnelQueryVariables
>;
export const GetPaEventsFunnelV2Document = gql`
  query GetPaEventsFunnelV2(
    $project_id: StringID!
    $params: QueryInput!
    $funnel_steps: [FunnelStepInput!]!
    $group_by: [String!]!
    $strict_order: Boolean
    $breakdown_by: [String!]!
    $breakdown_limit: Int!
  ) {
    pa_events_funnel_v2(
      project_id: $project_id
      params: $params
      funnel_steps: $funnel_steps
      group_by: $group_by
      strict_order: $strict_order
      breakdown_by: $breakdown_by
      breakdown_limit: $breakdown_limit
    ) {
      groups {
        groupValues
        steps {
          step_index
          count
        }
      }
    }
  }
`;

/**
 * __useGetPaEventsFunnelV2Query__
 *
 * To run a query within a React component, call `useGetPaEventsFunnelV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetPaEventsFunnelV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaEventsFunnelV2Query({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      params: // value for 'params'
 *      funnel_steps: // value for 'funnel_steps'
 *      group_by: // value for 'group_by'
 *      strict_order: // value for 'strict_order'
 *      breakdown_by: // value for 'breakdown_by'
 *      breakdown_limit: // value for 'breakdown_limit'
 *   },
 * });
 */
export function useGetPaEventsFunnelV2Query(
  baseOptions: Apollo.QueryHookOptions<Types.GetPaEventsFunnelV2Query, Types.GetPaEventsFunnelV2QueryVariables> &
    ({ variables: Types.GetPaEventsFunnelV2QueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetPaEventsFunnelV2Query, Types.GetPaEventsFunnelV2QueryVariables>(
    GetPaEventsFunnelV2Document,
    options,
  );
}
export function useGetPaEventsFunnelV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPaEventsFunnelV2Query, Types.GetPaEventsFunnelV2QueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetPaEventsFunnelV2Query, Types.GetPaEventsFunnelV2QueryVariables>(
    GetPaEventsFunnelV2Document,
    options,
  );
}
export function useGetPaEventsFunnelV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetPaEventsFunnelV2Query, Types.GetPaEventsFunnelV2QueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetPaEventsFunnelV2Query, Types.GetPaEventsFunnelV2QueryVariables>(
    GetPaEventsFunnelV2Document,
    options,
  );
}
export type GetPaEventsFunnelV2QueryHookResult = ReturnType<typeof useGetPaEventsFunnelV2Query>;
export type GetPaEventsFunnelV2LazyQueryHookResult = ReturnType<typeof useGetPaEventsFunnelV2LazyQuery>;
export type GetPaEventsFunnelV2SuspenseQueryHookResult = ReturnType<typeof useGetPaEventsFunnelV2SuspenseQuery>;
export type GetPaEventsFunnelV2QueryResult = Apollo.QueryResult<
  Types.GetPaEventsFunnelV2Query,
  Types.GetPaEventsFunnelV2QueryVariables
>;
export const GetTeamQueryHistoryDocument = gql`
  query GetTeamQueryHistory($project_id: StringID!, $query_type: ProductType!, $limit: Int) {
    team_query_history(project_id: $project_id, query_type: $query_type, limit: $limit) {
      id
      executedAt
      admin {
        id
        name
        email
        photo_url
      }
      queryType
      queryText
      parsedFilters {
        body
        attributes {
          key
          values
        }
      }
      dateRangeStart
      dateRangeEnd
      resultCount
      chartPreview {
        bucketStart
        bucketEnd
        count
      }
    }
  }
`;

/**
 * __useGetTeamQueryHistoryQuery__
 *
 * To run a query within a React component, call `useGetTeamQueryHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamQueryHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamQueryHistoryQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      query_type: // value for 'query_type'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetTeamQueryHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetTeamQueryHistoryQuery, Types.GetTeamQueryHistoryQueryVariables> &
    ({ variables: Types.GetTeamQueryHistoryQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetTeamQueryHistoryQuery, Types.GetTeamQueryHistoryQueryVariables>(
    GetTeamQueryHistoryDocument,
    options,
  );
}
export function useGetTeamQueryHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetTeamQueryHistoryQuery, Types.GetTeamQueryHistoryQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetTeamQueryHistoryQuery, Types.GetTeamQueryHistoryQueryVariables>(
    GetTeamQueryHistoryDocument,
    options,
  );
}
export function useGetTeamQueryHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetTeamQueryHistoryQuery, Types.GetTeamQueryHistoryQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetTeamQueryHistoryQuery, Types.GetTeamQueryHistoryQueryVariables>(
    GetTeamQueryHistoryDocument,
    options,
  );
}
export type GetTeamQueryHistoryQueryHookResult = ReturnType<typeof useGetTeamQueryHistoryQuery>;
export type GetTeamQueryHistoryLazyQueryHookResult = ReturnType<typeof useGetTeamQueryHistoryLazyQuery>;
export type GetTeamQueryHistorySuspenseQueryHookResult = ReturnType<typeof useGetTeamQueryHistorySuspenseQuery>;
export type GetTeamQueryHistoryQueryResult = Apollo.QueryResult<
  Types.GetTeamQueryHistoryQuery,
  Types.GetTeamQueryHistoryQueryVariables
>;
export const GetMetricExemplarsDocument = gql`
  query GetMetricExemplars($project_id: StringID!, $params: QueryInput!, $bucket_window: Int, $limit: Int) {
    metric_exemplars(project_id: $project_id, params: $params, bucket_window: $bucket_window, limit: $limit) {
      exemplars {
        timestamp
        value
        traceID
        spanID
        secureSessionID
        attributes
        metric_name
      }
      exemplar_window_start
      truncated_to_horizon
    }
  }
`;

/**
 * __useGetMetricExemplarsQuery__
 *
 * To run a query within a React component, call `useGetMetricExemplarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricExemplarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricExemplarsQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      params: // value for 'params'
 *      bucket_window: // value for 'bucket_window'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetMetricExemplarsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetMetricExemplarsQuery, Types.GetMetricExemplarsQueryVariables> &
    ({ variables: Types.GetMetricExemplarsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetMetricExemplarsQuery, Types.GetMetricExemplarsQueryVariables>(
    GetMetricExemplarsDocument,
    options,
  );
}
export function useGetMetricExemplarsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMetricExemplarsQuery, Types.GetMetricExemplarsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetMetricExemplarsQuery, Types.GetMetricExemplarsQueryVariables>(
    GetMetricExemplarsDocument,
    options,
  );
}
export function useGetMetricExemplarsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetMetricExemplarsQuery, Types.GetMetricExemplarsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetMetricExemplarsQuery, Types.GetMetricExemplarsQueryVariables>(
    GetMetricExemplarsDocument,
    options,
  );
}
export type GetMetricExemplarsQueryHookResult = ReturnType<typeof useGetMetricExemplarsQuery>;
export type GetMetricExemplarsLazyQueryHookResult = ReturnType<typeof useGetMetricExemplarsLazyQuery>;
export type GetMetricExemplarsSuspenseQueryHookResult = ReturnType<typeof useGetMetricExemplarsSuspenseQuery>;
export type GetMetricExemplarsQueryResult = Apollo.QueryResult<
  Types.GetMetricExemplarsQuery,
  Types.GetMetricExemplarsQueryVariables
>;
export const ExperimentHypothesisSuggestionDocument = gql`
  query ExperimentHypothesisSuggestion($project_id: StringID!, $prompt: String!) {
    experiment_hypothesis_suggestion(project_id: $project_id, prompt: $prompt)
  }
`;

/**
 * __useExperimentHypothesisSuggestionQuery__
 *
 * To run a query within a React component, call `useExperimentHypothesisSuggestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useExperimentHypothesisSuggestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExperimentHypothesisSuggestionQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      prompt: // value for 'prompt'
 *   },
 * });
 */
export function useExperimentHypothesisSuggestionQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.ExperimentHypothesisSuggestionQuery,
    Types.ExperimentHypothesisSuggestionQueryVariables
  > &
    ({ variables: Types.ExperimentHypothesisSuggestionQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.ExperimentHypothesisSuggestionQuery, Types.ExperimentHypothesisSuggestionQueryVariables>(
    ExperimentHypothesisSuggestionDocument,
    options,
  );
}
export function useExperimentHypothesisSuggestionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ExperimentHypothesisSuggestionQuery,
    Types.ExperimentHypothesisSuggestionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.ExperimentHypothesisSuggestionQuery,
    Types.ExperimentHypothesisSuggestionQueryVariables
  >(ExperimentHypothesisSuggestionDocument, options);
}
export function useExperimentHypothesisSuggestionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Types.ExperimentHypothesisSuggestionQuery,
        Types.ExperimentHypothesisSuggestionQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Types.ExperimentHypothesisSuggestionQuery,
    Types.ExperimentHypothesisSuggestionQueryVariables
  >(ExperimentHypothesisSuggestionDocument, options);
}
export type ExperimentHypothesisSuggestionQueryHookResult = ReturnType<typeof useExperimentHypothesisSuggestionQuery>;
export type ExperimentHypothesisSuggestionLazyQueryHookResult = ReturnType<
  typeof useExperimentHypothesisSuggestionLazyQuery
>;
export type ExperimentHypothesisSuggestionSuspenseQueryHookResult = ReturnType<
  typeof useExperimentHypothesisSuggestionSuspenseQuery
>;
export type ExperimentHypothesisSuggestionQueryResult = Apollo.QueryResult<
  Types.ExperimentHypothesisSuggestionQuery,
  Types.ExperimentHypothesisSuggestionQueryVariables
>;
export const GetServiceSettingsDocument = gql`
  query GetServiceSettings($service_id: Int64ID!, $project_id: StringID!) {
    serviceSettings(service_id: $service_id, project_id: $project_id) {
      serviceID
      projectID
      rootSpanFilter
    }
  }
`;

/**
 * __useGetServiceSettingsQuery__
 *
 * To run a query within a React component, call `useGetServiceSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceSettingsQuery({
 *   variables: {
 *      service_id: // value for 'service_id'
 *      project_id: // value for 'project_id'
 *   },
 * });
 */
export function useGetServiceSettingsQuery(
  baseOptions: Apollo.QueryHookOptions<Types.GetServiceSettingsQuery, Types.GetServiceSettingsQueryVariables> &
    ({ variables: Types.GetServiceSettingsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetServiceSettingsQuery, Types.GetServiceSettingsQueryVariables>(
    GetServiceSettingsDocument,
    options,
  );
}
export function useGetServiceSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.GetServiceSettingsQuery, Types.GetServiceSettingsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.GetServiceSettingsQuery, Types.GetServiceSettingsQueryVariables>(
    GetServiceSettingsDocument,
    options,
  );
}
export function useGetServiceSettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.GetServiceSettingsQuery, Types.GetServiceSettingsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.GetServiceSettingsQuery, Types.GetServiceSettingsQueryVariables>(
    GetServiceSettingsDocument,
    options,
  );
}
export type GetServiceSettingsQueryHookResult = ReturnType<typeof useGetServiceSettingsQuery>;
export type GetServiceSettingsLazyQueryHookResult = ReturnType<typeof useGetServiceSettingsLazyQuery>;
export type GetServiceSettingsSuspenseQueryHookResult = ReturnType<typeof useGetServiceSettingsSuspenseQuery>;
export type GetServiceSettingsQueryResult = Apollo.QueryResult<
  Types.GetServiceSettingsQuery,
  Types.GetServiceSettingsQueryVariables
>;
